<div class="sfdc-configuration-content" dir="{{languageDir}}">
  <div class="content-top-box">
    <ul class="breadcrumb">
      <li class="breadcrumb-item" *ngFor="let breadcrumItem of breadcrumList">
        <a
          class="breadcrumb-link"
          [routerLink]="breadcrumItem.Url"
          [id]="breadcrumItem.id"
          (click)="DisplayRightmenu(breadcrumItem.id, breadcrumItem.Url)"
          >{{lang.getTransalatedValue(breadcrumItem.text)}}</a
        >
      </li>
    </ul>
    <div class="tab-content-top-box">
      <h1 class="main-title">
        {{ langObj ? langObj?.ShopFloorTitle : ("ShopFloorTitle" | translate) }}
      </h1>
    </div>
  </div>
  <!--new code-->
  <!--msfdc tab-->
  <!-- <mat-tab label="SFDC Configuration"> -->
  <div class="wrapper-box wrapper-box-shadow table-wrapper">
    <ngx-spinner
      bdColor="rgba(0, 0, 0, 0.8)"
      template=" <img src='assets/images/spinner.gif' />"
    ></ngx-spinner>
    <form [formGroup]="groupDataForm">
      <div style="display: flex">
        <div style="width: 85%">
          <div class="content-top-row">
            <input formControlName="Id" [hidden]="true" />
            <mat-form-field
              appearence="fill"
              class="top-row-first-filed-item top-row-first-filed-item-order-processing"
              style="margin-left: 2px"
              *ngIf="groups?.length !== 1"
            >
              <mat-label class="placeholder-title"
                >{{
                  langObj ? langObj?.SelectGroup : ("SelectGroup" | translate)
                }}
              </mat-label>
              <mat-select
                formControlName="group"
                panelClass="testClass"
                name="Group"
                (selectionChange)="
                  selectHistoryProcessOrdersForSelectionChange($event)
                "
              >
                <mat-select-filter
                  [placeholder]="'Search'"
                  [displayMember]="'TypeName'"
                  [array]="groups"
                  (filteredReturn)="filteredModules = $event"
                ></mat-select-filter>
                <mat-option
                  *ngFor="let group of filteredModules"
                  [value]="group.TypeId"
                >
                  {{ group.TypeName }}
                </mat-option>
                <!-- <mat-option **ngFor="let group of groups" value="group.TypeId">   {{ group.TypeName }} </mat-option> -->
              </mat-select>
            </mat-form-field>

            <mat-form-field
              class="top-row-first-filed-item top-row-first-filed-item-order-processing"
              style="margin-left: 10px"
            >
              <mat-label>{{
                langObj ? langObj?.SelectUnit : ("SelectUnit" | translate)
              }}</mat-label>
              <div class="unit-input-wrapper">
                <!-- (selectionChange)="GetProcessOrderList()" -->
                <input
                  matInput
                  formControlName="Unit"
                  (click)="openTreeModal()"
                  [readonly]="true"
                />
                <span matSuffix (click)="openTreeModal()">
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15 9.375V5.625H4.6875V6.5625H2.8125V3.75H11.25V0H0V3.75H1.875V13.125H4.6875V15H15V11.25H4.6875V12.1875H2.8125V7.5H4.6875V9.375H15Z"
                      fill="#824AED"
                    />
                  </svg>
                </span>
              </div>
            </mat-form-field>
            <mat-form-field
              appearence="fill"
              class="top-row-first-filed-item top-row-first-filed-item-order-processing"
              style="margin-left: 10px"
            >
              <mat-label>{{
                langObj
                  ? langObj?.ProcessOrderNo
                  : ("ProcessOrderNo" | translate)
              }}</mat-label>
              <input
                matInput
                formControlName="processOrder"
                name="processOrder"
                [readonly]="true"
              />
            </mat-form-field>
            <mat-form-field
              appearence="fill"
              class="top-row-first-filed-item top-row-first-filed-item-order-processing"
              style="margin-left: 10px"
            >
              <mat-label>{{
                langObj ? langObj?.OperationName : ("OperationName" | translate)
              }}</mat-label>
              <input
                matInput
                formControlName="operationName"
                name="operationName"
                [readonly]="true"
              />
            </mat-form-field>
            <mat-form-field
              appearence="fill"
              class="top-row-first-filed-item top-row-first-filed-item-order-processing"
              pTooltip="{{ PDtooltip }}"
              tooltipPosition="top"
              style="margin-left: 10px"
            >
              <mat-label>{{
                langObj ? langObj?.ProductDetail : ("ProductDetail" | translate)
              }}</mat-label>
              <input
                matInput
                formControlName="productDetail"
                name="productDetails"
                [readonly]="true"
              />
            </mat-form-field>
          </div>
          <div class="content-top-row">
            <mat-form-field
              appearence="fill"
              class="top-row-first-filed-item top-row-first-filed-item-order-processing"
              style="margin-left: 2px"
            >
              <mat-label>{{
                langObj ? langObj?.ItemCode : ("ItemCode" | translate)
              }}</mat-label>
              <input
                matInput
                formControlName="itemCode"
                name="itemCode"
                [readonly]="true"
              />
            </mat-form-field>
            <mat-form-field
              appearence="fill"
              class="top-row-first-filed-item top-row-first-filed-item-order-processing"
              pTooltip="{{ IDtooltip }}"
              style="margin-left: 10px"
            >
              <mat-label>{{
                langObj
                  ? langObj?.ItemDescription
                  : ("ItemDescription" | translate)
              }}</mat-label>
              <input
                matInput
                formControlName="itemDescription"
                name="itemDesc"
                [readonly]="true"
              />
            </mat-form-field>
            <mat-form-field
              appearence="fill"
              class="top-row-first-filed-item top-row-first-filed-item-order-processing"
              style="margin-left: 10px"
            >
              <mat-label>{{
                langObj ? langObj?.Status : ("Status" | translate)
              }}</mat-label>
              <mat-select formControlName="status" panelClass="testClass">
                <mat-select-filter
                  [placeholder]="'Search'"
                  [displayMember]="'TypeName'"
                  [array]="statusList"
                  (filteredReturn)="filteredStatus = $event"
                ></mat-select-filter>
                <mat-option
                  *ngFor="let status of filteredStatus"
                  [value]="status.TypeId"
                >
                  {{ status.TypeName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <!-- <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"
              style="margin-left: 10px">
              <mat-label>{{ langObj ? langObj?.EventType : ('EventType' | translate) }}</mat-label>
              <mat-select formControlName="intervalType" panelClass="testClass">
                <mat-option value="Time"> Time </mat-option>
                <mat-option value="Event"> Event </mat-option>
              </mat-select>
            </mat-form-field> -->
            <!-- <mat-form-field class="top-row-first-filed-item" style="margin-left: 10px">
              <mat-label class="placeholder-title">{{ langObj ? langObj?.SelectInterval : ('SelectInterval' | translate) }}</mat-label>
              <mat-select formControlName="parameterInterval" panelClass="testClass" name="Group"
                (selectionChange)="onToProcessDate()" required>
                <mat-option *ngFor="let c of intervalList" [value]="c.Interval">
                  {{c.Interval }}
                </mat-option>
              </mat-select>
            </mat-form-field> -->
            <!-- <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"
              style="display :none;">
              <mat-label>{{'ProcessType' | translate}}</mat-label>
              <mat-select panelClass="testClass" [disabled]="true" placeholder="Process Type"
                formControlName="processType" name="group">
                <mat-option value="PO">{{langObj ? langObj?.ProcessOrder : ('ProcessOrder' | translate)}}</mat-option>
                <mat-option value="Batch">{{'Batch' | translate}}</mat-option>
                <mat-option value="Lotcode">{{'LoteCodeOrPallet' | translate}}</mat-option>
              </mat-select>
            </mat-form-field> -->
            <mat-form-field
              appearence="fill"
              class="top-row-first-filed-item top-row-first-filed-item-order-processing"
              style="margin-left: 2px"
            >
              <mat-label>{{
                langObj ? langObj?.Remarks : ("Remarks" | translate)
              }}</mat-label>
              <textarea
                matInput
                formControlName="remarks"
                name="remarks"
                [readonly]="true"
              ></textarea>
            </mat-form-field>
            <button
              (click)="
                groupDataMode
                  ? SumbitProcessOrderStatus()
                  : SumbitProcessOrderStatus()
              "
              type="submit"
              *ngIf="materialConsumptionMode && IsWrite"
              mat-mini-fab
              mat-button
              color="primary"
              [pTooltip]="langObj ? langObj?.Save : ('Save' | translate)"
              tooltipPosition="top"
              style="margin-left: 20px"
            >
              <i class="fa fa-floppy-o" style="color: #fff"></i>
            </button>
          </div>
          <!-- <div class="content-top-row" style="height: auto;">
            <div class="inputField">
              <nz-date-picker class="calender-input" id="picker" formControlName="fromProcessDate"
                nzFormat="dd/MM/yyyy HH:mm" [nzShowTime]="{ nzFormat: 'HH:mm' }"
                [nzInputReadOnly]="true"></nz-date-picker>
              <span class="floating-text">{{ langObj ? langObj?.ProcessFromDate : ('ProcessFromDate' | translate) }}</span>
            </div>

            <div class="inputField">
              <nz-date-picker class="calender-input" id="timePicker" formControlName="toProcessDate"
                nzFormat="dd/MM/yyyy HH:mm" [nzShowTime]="{ nzFormat: 'HH:mm' }"
                [nzInputReadOnly]="true"></nz-date-picker>
              <span class="floating-text">{{ langObj ? langObj?.ProcessToDate : ('ProcessToDate' | translate) }}</span>
            </div>
            <mat-form-field appearence="fill"
              class="top-row-first-filed-item top-row-first-filed-item-order-processing " style="margin-left: 2px">
              <mat-label>{{'Remarks' | translate}}</mat-label>
              <textarea matInput formControlName="remarks" name="remarks" [readonly]="true"></textarea>
            </mat-form-field>
            <button (click)="groupDataMode ? SumbitProcessOrderStatus() : SumbitProcessOrderStatus()" type="submit"
              *ngIf="materialConsumptionMode" mat-mini-fab mat-button color="primary" [pTooltip]="langObj ? langObj?.Save: ('Save' | translate)"
              tooltipPosition="top" style="margin-left: 20px;">
              <i class="fa fa-floppy-o" style="color: #fff"></i>
            </button>
          </div> -->
        </div>
        <div style="width: 15%">
          <div
            class="content-top-row"
            style="display: flex; justify-content: center"
          >
            <div style="float: left">
              <button
                *ngIf="showButtons"
                mat-flat-button
                color="accent"
                (click)="openPoModal()"
                class="btn-accent"
                style="margin-left: 20px; width: 108px"
              >
                {{ langObj ? langObj?.PoList : "PoList | translate" }}
              </button>
              <br />
              <button
                *ngIf="showButtons"
                mat-flat-button
                color="accent"
                (click)="GetLastShiftInfo($event)"
                class="btn-accent"
                style="margin-left: 20px; width: 108px"
              >
                {{ langObj ? langObj?.LastShift : ("LastShift" | translate) }}
              </button>
              <br />
              <button
                *ngIf="showShiftClose"
                mat-flat-button
                color="accent"
                (click)="openshiftcloseModal()"
                class="btn-accent"
                style="margin-left: 20px"
              >
                {{ langObj ? langObj?.ShiftClose : ("ShiftClose" | translate) }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- </mat-tab> -->

  <!-- Accordian -->
  <mat-accordion style="margin-top: 20px">
    <!-- Process Control -->

    <mat-expansion-panel
      (opened)="panelOpenState = true"
      (closed)="panelOpenState = false"
    >
      <mat-expansion-panel-header class="acc1" class="disable_ripple_acc1">
        <mat-panel-title>
          {{
            langObj ? langObj?.ProcessControl : ("ProcessControl" | translate)
          }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <form [formGroup]="processControlForm">
        <div class="wrapper-box wrapper-box-shadow table-wrapper">
          <div [ngClass]="{ fullscreen: isCardExpanded }">
            <div class="content-top-row">
              <mat-form-field
                appearence="fill"
                class="top-row-first-filed-item top-row-first-filed-item-order-processing"
                style="width: 15%; margin-left: 0px"
              >
                <mat-label class="placeholder-title"
                  >{{
                    langObj ? langObj?.GroupType : ("GroupType" | translate)
                  }}
                </mat-label>
                <mat-select
                  formControlName="groupType"
                  panelClass="testClass"
                  name="Group"
                  required
                  (selectionChange)="variableEventMode()"
                >
                  <mat-option
                    *ngFor="let c of groupTypeList"
                    [value]="c.parameterGroupTypeId"
                  >
                    {{ c.groupTypeName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field
                appearence="fill"
                class="top-row-first-filed-item top-row-first-filed-item-order-processing"
                style="width: 15%"
                *ngIf="processGroupType === 'Event'"
              >
                <mat-label>{{
                  langObj ? langObj?.EventType : ("EventType" | translate)
                }}</mat-label>
                <mat-select
                  formControlName="eventType"
                  panelClass="testClass"
                  (selectionChange)="onToProcessDate()"
                >
                  <mat-option
                    *ngFor="let interval of processIntervalTypeDDL"
                    [value]="interval.val"
                    >{{ interval.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field
                appearence="fill"
                class="top-row-first-filed-item top-row-first-filed-item-order-processing"
                *ngIf="processGroupType === 'Time'"
                style="width: 15%"
              >
                <mat-label class="placeholder-title">{{
                  langObj
                    ? langObj?.SelectInterval
                    : ("SelectInterval" | translate)
                }}</mat-label>
                <mat-select
                  formControlName="timeInterval"
                  panelClass="testClass"
                  name="Group"
                  (selectionChange)="onIntervalChange()"
                  required
                >
                  <mat-option
                    *ngFor="let c of intervalList"
                    [value]="c.Interval"
                  >
                    {{ c.Interval }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <div *ngIf="processGroupType === 'Manual'">
                <div
                  class="form-floating"
                  style="margin-left: 25px; width: 290px"
                >
                  <label class="floating-label-multiselect"
                    >Parameter Group</label
                  >
                  <p-multiSelect
                    class="form-select"
                    (onChange)="onProcessParameterGroupChange()"
                    inputId="multiselect"
                    formControlName="parameterGroup"
                    [options]="processparameterGroupList"
                    optionLabel="vgDesc"
                    [filter]="true"
                  >
                  </p-multiSelect>
                </div>
              </div>
              <div
                style="width: auto !important"
                class="top-row-first-filed-item top-row-first-filed-item-order-processing"
                style="width: 258px"
              >
                <label class="floating-label">Date Range</label>
                <input
                  type="text"
                  matInput
                  ngxDaterangepickerMd
                  formControlName="datePicker"
                  [timePicker]="true"
                  [timePicker24Hour]="true"
                  [showDropdowns]="true"
                  (change)="onToProcessDate()"
                  [closeOnAutoApply]="true"
                  [locale]="{ format: 'DD/MM/YYYY HH:mm' }"
                  [autoApply]="true"
                />
              </div>
              <!-- <div class="inputField">
                <nz-range-picker class="calender-input" [nzInputReadOnly]="true" [nzShowTime]="{ nzFormat: 'HH:mm' }"
                  [nzDisabledDate]="disabledDate" nzFormat="yyyy-MM-dd HH:mm" formControlName="datePicker">
                </nz-range-picker>
                <span class="floating-text">Date Range</span>
              </div> -->
              <mat-form-field
                appearence="fill"
                class="top-row-first-filed-item top-row-first-filed-item-order-processing"
                style="display: none"
              >
                <mat-label>Process Type</mat-label>
                <mat-select
                  panelClass="testClass"
                  [disabled]="true"
                  placeholder="Process Type"
                  formControlName="processType"
                  name="group"
                >
                  <mat-option value="PO">Process Order</mat-option>
                  <mat-option value="Batch">Batch</mat-option>
                  <mat-option value="Lotcode">Lotcode/Pallet</mat-option>
                </mat-select>
              </mat-form-field>
              <button
                mat-mini-fab
                color="accent"
                (click)="manualInput('process')"
                *ngIf="processGroupType === 'Manual'"
                [pTooltip]="
                  langObj ? langObj?.ManualInput : ('ManualInput' | translate)
                "
                style="margin-left: 16px; margin-top: 5px"
              >
                <!-- {{'ManualInput' | translate}} -->
                <mat-icon>plus_one</mat-icon>
              </button>
            </div>

            <div class="content-top-row">
              <mat-spinner-button
                [options]="spinnerButtonOptions"
                (btnClick)="onClickParamterAnalysisProcess()"
                class="loader"
                id="selectedRows"
                style="margin: 6px 0px"
              >
              </mat-spinner-button>
              <mat-spinner-button
                [options]="spinnerButtonOptions1"
                (btnClick)="onClickParamterComparsionProcess()"
                class="loader"
                id="selectedRows"
                style="margin: 6px 10px"
              >
              </mat-spinner-button>
              <mat-spinner-button
                [options]="spinnerButtonOptionsOrders"
                (btnClick)="onClickControlProcessOrderProcess()"
                class="loader"
                id="selectedRows"
                style="margin: 6px 10px"
              >
              </mat-spinner-button>

              <button
                type="button"
                (click)="onProcessControlRefresh()"
                mat-mini-fab
                mat-button
                color="primary"
                pTooltip="Refresh"
                tooltipPosition="top"
                style="margin-left: 20px; margin-top: 5px"
              >
                <i class="fa fa-refresh" style="color: #fff"></i>
              </button>
              <button
                type="button"
                (click)="toggleTimer()"
                mat-mini-fab
                mat-button
                color="primary"
                [pTooltip]="
                  ResumeInterval ? 'Stop Auto Refresh' : 'Resume Auto Refresh'
                "
                tooltipPosition="top"
                style="margin-left: 10px; margin-top: 6px"
              >
                <mat-icon *ngIf="ResumeInterval">pause_circle_outline</mat-icon>
                <mat-icon *ngIf="!ResumeInterval">play_arrow</mat-icon>
              </button>
              <!-- <div class="example-button-row"> -->
              <button
                mat-mini-fab
                mat-button
                (click)="csvExportPC()"
                pTooltip="CSV Export"
                tooltipPosition="top"
                style="margin-left: 20px; margin-top: 5px"
              >
                <img src="assets/images/csv-file-format.png" />
              </button>
              <button
                mat-mini-fab
                mat-button
                (click)="excelExportPC()"
                pTooltip="Excel Export"
                tooltipPosition="top"
                style="margin-top: 5px"
              >
                <i
                  class="fa fa-file-excel-o"
                  style="color: #fff"
                  aria-hidden="true"
                ></i>
              </button>
              <button
                mat-mini-fab
                mat-button
                (click)="pdfExport()"
                pTooltip="PDF Export"
                tooltipPosition="top"
                style="margin-top: 5px"
              >
                <i
                  class="fa fa-file-pdf-o"
                  style="color: #fff"
                  aria-hidden="true"
                ></i>
              </button>
              <!-- </div> -->
              <button
                mat-mini-fab
                mat-button
                mat-dialog-close
                color="accent"
                pTooltip="Expand Grid"
                tooltipPosition="top"
                *ngIf="Exdpandhide"
                (click)="expandprocess()"
                style="margin-top: 5px; margin-left: 10px"
              >
                <mat-icon>fullscreen</mat-icon>
              </button>
              <button
                mat-mini-fab
                mat-button
                mat-dialog-close
                color="accent"
                (click)="closeprocess()"
                style="margin-top: 5px; margin-left: 10px"
                *ngIf="Collapsehide"
              >
                <mat-icon>fullscreen_exit</mat-icon>
              </button>
            </div>

            <ag-grid-angular
              style="width: 100%; height: 30vw"
              class="ag-theme-alpine"
              [rowData]="rowDataProcessControl"
              [columnDefs]="columnDefsProcessControl"
              id="gridContainerProcessControl"
              [gridOptions]="gridOptionsProcessControl"
              [rowSelection]="rowSelection"
              [rowMultiSelectWithClick]="true"
              (gridReady)="onProcessGridReady($event)"
              (cellValueChanged)="onCellValueChanged($event)"
              [frameworkComponents]="frameworkComponents"
              [loadingOverlayComponent]="loadingOverlayComponent"
              [loadingOverlayComponentParams]="loadingOverlayComponentParams"
              [pagination]="true"
              [autoGroupColumnDef]="autoGroupColumnDef"
              [getContextMenuItems]="getContextMenuItemsProcessControl"
              [groupHideOpenParents]="true"
              [enterMovesDown]="true"
              [enterMovesDownAfterEdit]="true"
            >
            </ag-grid-angular>
          </div>
        </div>

        <ng-template #pdfModel>
          <!-- <button (click)="getSelectedRowData()">Click</button> -->
          <div mat-dialog-title>
            <div class="d-flex justify-content-between align-items-center">
              <h3>{{ langObj ? langObj?.SelectColumnsForPDFFile : ("SelectColumnsForPDFFile" | translate) }}</h3>
              <button
                mat-mini-fab
                mat-button
                mat-dialog-close
                color="warn"
                pTooltip="Close"
                tooltipPosition="top"
              >
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>
          <hr />
          <mat-dialog-content>
            <div style="width: 100%; height: 290px; margin-top: 10px 0px 10px">
              <div class="p-grid p-fluid" style="margin: 10px 0px 10px">
                <div class="p-col-12 p-md-6 p-lg-6 p-xl-6">
                  <h4 style="text-decoration: underline">{{ langObj ? langObj?.SelectColumns : ("SelectColumns" | translate) }}:</h4>
                  <label>{{
                    langObj
                      ? langObj?.SelectColumns
                      : ("SelectColumns" | translate)
                  }}</label>
                  <p-multiSelect
                    [options]="columns"
                    [filter]="true"
                    (onChange)="columnSelect()"
                    defaultLabel="Select Column"
                    formControlName="pdfcolumn"
                    optionLabel="headerName"
                  ></p-multiSelect>
                </div>
                <div class="p-col-12 p-md-6 p-lg-6 p-xl-6">
                  <h3 style="text-decoration: underline">{{ langObj ? langObj?.SelectColumns : ("SelectColumns" | translate) }}:</h3>
                  <p>{{ selectedColumns }}</p>
                </div>
              </div>
            </div>
            <hr />
            <div mat-dialog-title>
              <div class="d-flex justify-content-between align-items-center">
                <button
                  type="button"
                  mat-raised-button
                  color="warn"
                  style="
                    background-color: #0f0fd1;
                    font-size: 14px !important;
                    margin-left: 20px;
                    height: 40px;
                    margin-top: 5px;
                  "
                  (click)="downloadPDF()"
                >
                  <span style="font-size: 12px; color: white"
                    >{{ langObj ? langObj?.DownloadPDF : ("DownloadPDF" | translate) }}</span
                  >
                </button>
              </div>
            </div>
          </mat-dialog-content>
        </ng-template>
      </form>

      <p-dialog
        [contentStyle]="{ overflow: 'scroll' }"
        header="{{ paramterSpcecificationName }} - Specifications"
        [(visible)]="processControlSpecificationModal"
        [style]="{ width: '50vw' }"
        [maximizable]="true"
        [baseZIndex]="10000"
        [resizable]="true"
      >
        <div class="p-grid p-fluid">
          <div class="p-col-12 p-md-12">
            <table
              mat-table
              class="basic-table plant-model-table"
              matSort
              [dataSource]="parameterspecifications"
            >
              <ng-container matColumnDef="LRL">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">{{ langObj ? langObj?.LRL : ("LRL" | translate) }}</p>
                </th>
                <td mat-cell *matCellDef="let element">{{ element.LSL }}</td>
              </ng-container>

              <ng-container matColumnDef="LSL">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">{{ langObj ? langObj?.LSL : ("LSL" | translate) }}</p>
                </th>
                <td mat-cell *matCellDef="let element">{{ element.LCL }}</td>
              </ng-container>

              <ng-container matColumnDef="LWL">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">{{ langObj ? langObj?.LWL : ("LWL" | translate) }}</p>
                </th>
                <td mat-cell *matCellDef="let element">{{ element.LWL }}</td>
              </ng-container>

              <ng-container matColumnDef="TGT">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">{{ langObj ? langObj?.TGT : ("TGT" | translate) }}</p>
                </th>
                <td mat-cell *matCellDef="let element">{{ element.TGT }}</td>
              </ng-container>

              <ng-container matColumnDef="UWL">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">{{ langObj ? langObj?.UWL : ("UWL" | translate) }}</p>
                </th>
                <td mat-cell *matCellDef="let element">{{ element.UWL }}</td>
              </ng-container>

              <ng-container matColumnDef="USL">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">{{ langObj ? langObj?.USL : ("USL" | translate) }}</p>
                </th>
                <td mat-cell *matCellDef="let element">{{ element.UCL }}</td>
              </ng-container>

              <ng-container matColumnDef="URL">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">{{ langObj ? langObj?.URL : ("URL" | translate) }}</p>
                </th>
                <td mat-cell *matCellDef="let element">{{ element.USL }}</td>
              </ng-container>
              -->
              <tr mat-header-row *matHeaderRowDef="processcontrolcolumns"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: processcontrolcolumns"
              ></tr>
            </table>
            <mat-paginator
              class="basic-paginataor"
              [pageSizeOptions]="[10, 20]"
              showFirstLastButtons
            ></mat-paginator>
          </div>
        </div>
      </p-dialog>

      <p-dialog
        [contentStyle]="{ overflow: 'scroll' }"
        header="{{ paramterSpcecificationName }} - Specifications"
        [(visible)]="displayProcssDefectModal"
        [style]="{ width: 'auto' }"
        [maximizable]="true"
        [baseZIndex]="10000"
        [resizable]="true"
      >
        <div class="p-grid p-fluid">
          <div class="p-col-12 p-md-12">
            <table
              mat-table
              class="basic-table plant-model-table"
              matSort
              [dataSource]="parametrdefect"
            >
              <ng-container matColumnDef="DefectMode">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">{{ langObj ? langObj?.FailureModeDetails : ("FailureModeDetails" | translate) }}</p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.defectmode }}
                </td>
              </ng-container>

              <ng-container matColumnDef="Department">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">{{ langObj ? langObj?.Department : ("Department" | translate) }}</p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.department }}
                </td>
              </ng-container>

              <ng-container matColumnDef="Assembly">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">{{ langObj ? langObj?.Assembly : ("Assembly" | translate) }}</p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.assembly }}
                </td>
              </ng-container>

              <ng-container matColumnDef="Component">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">{{ langObj ? langObj?.Component : ("Component" | translate) }}</p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.component }}
                </td>
              </ng-container>

              <ng-container matColumnDef="Subassembly">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">{{ langObj ? langObj?.SubAssembly : ("SubAssembly" | translate) }}</p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.subassembly }}
                </td>
              </ng-container>

              <ng-container matColumnDef="Unit">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">{{ langObj ? langObj?.Unit : ("Unit" | translate) }}</p>
                </th>
                <td mat-cell *matCellDef="let element">{{ element.Unit }}</td>
              </ng-container>

              <ng-container matColumnDef="Line">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">{{ langObj ? langObj?.Line : ("Line" | translate) }}</p>
                </th>
                <td mat-cell *matCellDef="let element">{{ element.Line }}</td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="defectColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: defectColumns"></tr>
            </table>
            <mat-paginator
              class="basic-paginataor"
              [pageSizeOptions]="[10, 20]"
              showFirstLastButtons
            ></mat-paginator>
          </div>
        </div>
      </p-dialog>
      <!-- </ng-template>  -->
    </mat-expansion-panel>
    <!-- Material Consumption -->

    <mat-expansion-panel
      (opened)="panelOpenState = true"
      (closed)="panelOpenState = false"
    >
      <mat-expansion-panel-header class="acc2" class="disable_ripple_acc2">
        <mat-panel-title>
          {{
            langObj
              ? langObj?.MaterialConsumption
              : ("MaterialConsumption" | translate)
          }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <form [formGroup]="materialConsumptionForm">
        <div
          class="wrapper-box wrapper-box-shadow table-wrapper"
          *ngIf="!isFoodSector"
        >
          <div class="content-top-row">
            <mat-form-field
              appearence="fill"
              class="top-row-first-filed-item top-row-first-filed-item-order-processing"
              style="margin-left: 1px"
            >
              <input formControlName="Id" [hidden]="true" />
              <mat-label>{{
                langObj ? langObj?.MaterialDetail : "MaterialDetail"
              }}</mat-label>
              <mat-select
                formControlName="materialDate"
                panelClass="testClass"
                name="materialDate"
                (selectionChange)="GetLableBatch($event)"
              >
                <mat-option
                  *ngFor="let material of ItemTypeList"
                  [value]="material.BatchItemTypeId"
                >
                  {{ material.Name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div class="inputField">
              <nz-date-picker
                class="calender-input"
                id="timePicker"
                formControlName="date"
                nzFormat="dd/MM/yyyy HH:mm"
                [nzShowTime]="{ nzFormat: 'HH:mm' }"
                [nzInputReadOnly]="true"
              ></nz-date-picker>
              <span class="floating-text">{{
                langObj ? langObj?.Time : ("Time" | translate)
              }}</span>
            </div>
            <mat-form-field
              appearence="fill"
              class="top-row-first-filed-item top-row-first-filed-item-order-processing"
              style="margin-left: 10px"
            >
              <mat-label>{{
                langObj
                  ? langObj?.LotCodeOrDetail
                  : ("LotCodeOrDetail" | translate)
              }}</mat-label>
              <input
                formControlName="lot"
                (change)="calculateInput($event)"
                matInput
                name="batchdesc"
              />
            </mat-form-field>
            <mat-form-field
              appearence="fill"
              class="top-row-first-filed-item top-row-first-filed-item-order-processing"
              style="margin-left: 10px"
            >
              <mat-label
                >{{
                  langObj
                    ? langObj?.ActualQuantity
                    : ("ActualQuantity" | translate)
                }}
                {{ result }}</mat-label
              >
              <input
                formControlName="actQty"
                type="number"
                matInput
                name="length"
              />
            </mat-form-field>
            <mat-form-field
              appearence="fill"
              class="top-row-first-filed-item top-row-first-filed-item-order-processing"
              style="margin-left: 10px"
            >
              <mat-label
                >{{
                  langObj
                    ? langObj?.EstimatedQuantity
                    : ("EstimatedQuantity" | translate)
                }}
                {{ result }}
              </mat-label>
              <input
                formControlName="qty"
                matInput
                name="qty"
                [readonly]="true"
              />
            </mat-form-field>
          </div>

          <div class="content-top-row">
            <button
              class="user_badge"
              mat-flat-button
              color="accent"
              matBadgePosition="after"
              matBadgeColor="accent"
              MatBadgeSize="large"
              disableRipple
            >
              {{ itemCode }}
            </button>
            <button
              class="user_badge"
              mat-flat-button
              color="accent"
              matBadgePosition="after"
              matBadgeColor="accent"
              MatBadgeSize="large"
              disableRipple
              style="margin-left: 14px"
              [class]="languageDir === 'rtl' ? 'arb-btn-mrgn' : ''"
            >
              {{ total }}
            </button>
            <mat-form-field
              appearence="outline"
              class="top-row-first-filed-item top-row-first-filed-item-order-processing"
              style="margin-left: 14px"
            >
              <mat-label>{{
                langObj ? langObj?.Remarks : ("Remarks" | translate)
              }}</mat-label>
              <input formControlName="remarks" matInput name="remarks" />
            </mat-form-field>
          </div>
          <div
            class="content-top-row"
            style="margin-top: 20px; display: flex; justify-content: flex-end"
          >
            <div>
              <button
                (click)="UpdateJBBatchInfoForMaterialConsumption()"
                type="submit"
                *ngIf="!materialConsumptionMode && IsWrite"
                [disabled]="!materialConsumptionForm.valid"
                mat-mini-fab
                mat-button
                color="primary"
                [pTooltip]="langObj ? langObj?.Update : ('Update' | translate)"
                tooltipPosition="top"
              >
                <i class="fa fa-pencil" style="color: #fff"></i>
              </button>
              <button
                (click)="SaveJBBatchInfoForMaterialConsumption()"
                type="submit"
                *ngIf="materialConsumptionMode && IsWrite"
                [disabled]="!materialConsumptionForm.valid"
                mat-mini-fab
                mat-button
                color="primary"
                [pTooltip]="langObj ? langObj?.Save : ('Save' | translate)"
                tooltipPosition="top"
              >
                <i class="fa fa-floppy-o" style="color: #fff"></i>
              </button>
              <button
                type="button"
                mat-mini-fab
                mat-button
                class="refresh-btn"
                [pTooltip]="langObj ? langObj?.Reset : ('Reset' | translate)"
                tooltipPosition="top"
                style="margin-left: 10px"
                (click)="RefreshMaterialConsumption()"
              >
                <i class="fa fa-refresh" style="color: #fff"></i>
              </button>
              <button
                type="button"
                mat-mini-fab
                mat-button
                class="list-btn"
                [pTooltip]="
                  langObj
                    ? langObj?.HistoryBatchList
                    : ('HistoryBatchList' | translate)
                "
                type="button"
                tooltipPosition="top"
                style="margin-left: 10px"
                (click)="openHistorybatchModal($event)"
              >
                <i class="fa fa-list" style="color: #fff"></i>
              </button>
            </div>
          </div>

          <!--second row-->
          <div class="content-row-flex-both-end">
            <!--table-->
            <table
              mat-table
              [dataSource]="materialConsumptionDataSource"
              class="basic-table plant-model-table"
              matSort
            >
              <!-- Item Type Column -->
              <ng-container matColumnDef="itemtype">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">
                    {{ langObj ? langObj?.ItemType : ("ItemType" | translate) }}
                  </p>
                </th>
                <td mat-cell *matCellDef="let element">{{ element?.Name }}</td>
              </ng-container>

              <!-- Batch Column -->
              <ng-container matColumnDef="batch">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">
                    {{
                      langObj
                        ? langObj?.LotCodeOrDetail
                        : ("LotCodeOrDetail" | translate)
                    }}
                  </p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.BatchNo }}
                </td>
              </ng-container>

              <!-- length Column -->
              <ng-container matColumnDef="length">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">
                    {{
                      langObj
                        ? langObj?.ActualQuantity
                        : ("ActualQuantity" | translate)
                    }}
                    {{ result }}
                  </p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.Result }}
                </td>
              </ng-container>

              <!-- Remarks Column -->
              <ng-container matColumnDef="remarks">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">
                    {{ langObj ? langObj?.Remarks : ("Remarks" | translate) }}
                  </p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.Remarks }}
                </td>
              </ng-container>

              <!-- Time Column -->
              <ng-container matColumnDef="time">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">
                    {{ langObj ? langObj?.Time : ("Time" | translate) }}
                  </p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.RollStarttime | date: "dd/MM/yyyy HH:mm:ss" }}
                </td>
              </ng-container>

              <!-- Created On Column -->
              <ng-container matColumnDef="createdon">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">
                    {{
                      langObj ? langObj?.CreatedOn : ("CreatedOn" | translate)
                    }}
                  </p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.CreatedOn | date: "dd/MM/yyyy HH:mm:ss" }}
                </td>
              </ng-container>

              <!-- Created by Column -->
              <ng-container matColumnDef="createdby">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">
                    {{
                      langObj ? langObj?.CreatedBy : ("CreatedBy" | translate)
                    }}
                  </p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.CreatedBy }}
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="materialColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: materialColumns"></tr>
              <tr class="mat-row" *matNoDataRow style="text-align: center">
                <td class="mat-cell" colspan="8">
                  {{
                    langObj ? langObj?.NoDataFound : ("NoDataFound" | translate)
                  }}
                </td>
              </tr>
            </table>
          </div>
        </div>
      </form>
      <!-- Food sector -->
      <form [formGroup]="materialFoodSectorConsumptionForm">
        <div
          class="wrapper-box wrapper-box-shadow table-wrapper"
          *ngIf="isFoodSector"
        >
          <div class="content-top-row">
            <section class="example-section" *ngIf="IsReworkRequired">
              <mat-checkbox
                formControlName="isRework"
                (change)="isReworkWork($event)"
                class="example-margin"
                >Rework
              </mat-checkbox>
            </section>
            <mat-form-field
              appearence="fill"
              class="top-row-first-filed-item top-row-first-filed-item-order-processing"
              style="margin-left: 10px"
            >
              <mat-label>{{
                langObj ? langObj?.LotCode : ("LotCode" | translate)
              }}</mat-label>
              <input
                formControlName="mlotCode"
                readonly
                matInput
                name="batchdesc"
              />
            </mat-form-field>
            <mat-form-field
              appearence="fill"
              class="top-row-first-filed-item top-row-first-filed-item-order-processing"
              style="margin-left: 10px"
              *ngIf="IsReworkRequired"
            >
              <mat-label>{{
                langObj
                  ? langObj?.EstimatedQuantity
                  : ("EstimatedQuantity" | translate)
              }}</mat-label>
              <input
                formControlName="mActQtys"
                readonly
                type="number"
                matInput
                name="length"
              />
            </mat-form-field>

            <mat-form-field
              appearence="fill"
              class="top-row-first-filed-item top-row-first-filed-item-order-processing"
              style="margin-left: 10px"
            >
              <input
                matInput
                [ngxMatDatetimePicker]="mtimePicker"
                placeholder="Time"
                formControlName="mTime"
              />
              <mat-error
                class="error-msg"
                *ngIf="checkErrorMaterialFoodConsumption('mTime', 'required')"
                >time is required</mat-error
              >
              <mat-datepicker-toggle
                matSuffix
                [for]="$any(mtimePicker)"
              ></mat-datepicker-toggle>
              <ngx-mat-datetime-picker #mtimePicker> </ngx-mat-datetime-picker>
            </mat-form-field>
            <mat-form-field
              appearence="fill"
              class="top-row-first-filed-item top-row-first-filed-item-order-processing"
              style="margin-left: 10px"
            >
              <mat-label>{{
                langObj ? langObj?.Remarks : ("Remarks" | translate)
              }}</mat-label>
              <input formControlName="remarks" type="text" matInput />
            </mat-form-field>
          </div>

          <div class="content-row-flex-both-end">
            <!--table-->
            <table
              mat-table
              class="basic-table plant-model-table"
              [dataSource]="ItemBOMList"
              matSort
            >
              <!-- Item Type Column -->
              <ng-container matColumnDef="itemtype">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">
                    {{ langObj ? langObj?.ItemCode : ("ItemCode" | translate) }}
                  </p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.ItemCode }}
                </td>
              </ng-container>

              <ng-container matColumnDef="itemDesc">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">
                    {{
                      langObj
                        ? langObj?.ItemDescription
                        : ("ItemDescription" | translate)
                    }}
                  </p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.ItemDesc }}
                </td>
              </ng-container>
              <ng-container matColumnDef="itemuom">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">
                    {{ langObj ? langObj?.Item : ("Item" | translate) }} UOM
                  </p>
                </th>
                <td mat-cell *matCellDef="let element">{{ element.UOM }}</td>
              </ng-container>

              <!-- Batch Column -->
              <ng-container matColumnDef="estQty">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">
                    {{
                      langObj
                        ? langObj?.EstimatedQuantity
                        : ("EstimatedQuantity" | translate)
                    }}
                  </p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.EsimatedQty }}
                </td>
              </ng-container>

              <!-- length Column -->
              <ng-container matColumnDef="actQty">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">
                    {{
                      langObj
                        ? langObj?.ActualQuantity
                        : ("ActualQuantity" | translate)
                    }}
                  </p>
                </th>
                <td mat-cell *matCellDef="let element">
                  <input
                    type="number"
                    (keyup)="changeActQty($event, element.ItemBOMDetailId)"
                    [readonly]="!element.IsEditable"
                    class="w120"
                    value="{{ element.ItemBOMValue }}"
                  />
                </td>
              </ng-container>

              <ng-container matColumnDef="supplier">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">
                    {{ langObj ? langObj?.Supplier : ("Supplier" | translate) }}
                  </p>
                </th>
                <td mat-cell *matCellDef="let element">
                  <input
                    type="text"
                    class="w120"
                    (keyup)="changeSupplier($event, element.ItemBOMDetailId)"
                    value="{{ element.Supplier }}"
                  />
                </td>
              </ng-container>
              <ng-container matColumnDef="prodDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">
                    {{
                      langObj
                        ? langObj?.ProductionDate
                        : ("ProductionDate" | translate)
                    }}
                  </p>
                </th>
                <td mat-cell *matCellDef="let element">
                  <mat-form-field class="w120">
                    <input
                      matInput
                      [matDatepicker]="pickerProd"
                      [readonly]="true"
                      value="{{ element.ProductionDate }}"
                      (dateChange)="
                        changeProductionDate($event, element.ItemBOMDetailId)
                      "
                      [placeholder]="
                        langObj
                          ? langObj?.ChooseDate
                          : ('ChooseDate' | translate)
                      "
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="pickerProd"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #pickerProd></mat-datepicker>
                  </mat-form-field>
                </td>
              </ng-container>
              <ng-container matColumnDef="expireDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">
                    {{
                      langObj
                        ? langObj?.ExpirationDate
                        : ("ExpirationDate" | translate)
                    }}
                  </p>
                </th>
                <td mat-cell *matCellDef="let element">
                  <mat-form-field class="w120">
                    <input
                      matInput
                      #inputExp
                      [matDatepicker]="pickerExp"
                      [readonly]="true"
                      value="{{ element.ExpireDate }}"
                      (dateChange)="
                        changeExpireDate($event, element.ItemBOMDetailId)
                      "
                      placeholder="{{
                        langObj
                          ? langObj?.ChooseDate
                          : ('ChooseDate' | translate)
                      }}"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="pickerExp"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #pickerExp></mat-datepicker>
                  </mat-form-field>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="materialSubColumns"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: materialSubColumns"
              ></tr>
              <tr class="mat-row" *matNoDataRow style="text-align: center">
                <td class="mat-cell" colspan="8">
                  {{
                    langObj ? langObj?.NoDataFound : ("NoDataFound" | translate)
                  }}
                </td>
              </tr>
            </table>
          </div>
          <div
            class="content-top-row content-top-row-order-processing"
            style="display: flex; justify-content: flex-end"
          >
            <button
              type="submit"
              class="add-btn2"
              [pTooltip]="langObj ? langObj?.Save : ('Save' | translate)"
              tooltipPosition="top"
              style="margin-left: 10px"
              (click)="SaveFoodSectorMaterialConsumption()"
            >
              <img
                src="assets/images/save.png"
                alt=""
                width="20px"
                height="20px"
              />
            </button>

            <button
              (click)="RefreshMaterialSubConsumption()"
              class="add-btn2"
              style="margin-left: 10px"
              [pTooltip]="langObj ? langObj?.Reset : ('Reset' | translate)"
              tooltipPosition="top"
            >
              <img
                src="assets/images/refresh1.png"
                alt=""
                width="20px"
                height="20px"
              />
            </button>
            <button
              (click)="openHistoryFoodMaterialModal()"
              class="add-btn2"
              style="margin-left: 10px"
              [pTooltip]="'HistoryMaterialBatchList' | translate"
              tooltipPosition="top"
            >
              <img
                src="assets/images/popup.png"
                alt=""
                width="20px"
                height="20px"
              />
            </button>
          </div>

          <div class="content-row-flex-both-end">
            <!--table-->
            <table
              mat-table
              [dataSource]="batchItemBOMList"
              class="basic-table plant-model-table"
              matSort
            >
              <ng-container matColumnDef="isrework">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">
                    {{ langObj ? langObj?.IsRework : ("IsRework" | translate) }}
                  </p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.IsRework === true ? "Yes" : "No" }}
                </td>
              </ng-container>
              <!-- Batch Column -->
              <ng-container matColumnDef="batch">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">
                    {{
                      langObj
                        ? langObj?.LotCodeOrDetail
                        : ("LotCodeOrDetail" | translate)
                    }}
                  </p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.BatchNo }}
                </td>
              </ng-container>

              <!-- length Column -->
              <ng-container matColumnDef="length">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">
                    {{
                      langObj
                        ? langObj?.EstimatedQuantity
                        : ("EstimatedQuantity" | translate)
                    }}
                    {{ result }}
                  </p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.Result }}
                </td>
              </ng-container>

              <ng-container matColumnDef="totalActQty">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">
                    {{
                      langObj
                        ? langObj?.TotalActualQuantity
                        : ("TotalActualQuantity" | translate)
                    }}
                  </p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.Actual }}
                </td>
              </ng-container>

              <!-- Remarks Column -->
              <ng-container matColumnDef="remarks">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">
                    {{ langObj ? langObj?.Remarks : ("Remarks" | translate) }}
                  </p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.Remarks }}
                </td>
              </ng-container>

              <!-- Time Column -->
              <ng-container matColumnDef="time">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">
                    {{ langObj ? langObj?.Time : ("Time" | translate) }}
                  </p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.RollStarttime | date: "dd/MM/yyyy HH:mm:ss" }}
                </td>
              </ng-container>

              <!-- Created On Column -->
              <ng-container matColumnDef="createdon">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">
                    {{
                      langObj ? langObj?.CreatedOn : ("CreatedOn" | translate)
                    }}
                  </p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.CreatedOn | date: "dd/MM/yyyy HH:mm:ss" }}
                </td>
              </ng-container>

              <!-- Created by Column -->
              <ng-container matColumnDef="createdby">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">
                    {{
                      langObj ? langObj?.CreatedBy : ("CreatedBy" | translate)
                    }}
                  </p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.CreatedBy }}
                </td>
              </ng-container>

              <ng-container matColumnDef="sfdcactions">
                <th mat-header-cell *matHeaderCellDef>
                  <p class="header-text">
                    {{ langObj ? langObj?.Action : ("Action" | translate) }}
                  </p>
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  class="row-action-btns-column"
                >
                  <div class="row-action-btns">
                    <button
                      mat-icon-button
                      class="edit-btn"
                      aria-label="Edit Row"
                      (click)="openPopupViewForMaterialHistory(element)"
                      matTooltip="View"
                      matTooltipClass="custom-tooltip"
                      matTooltipPosition="above"
                      style="background-color: lightseagreen"
                    >
                      <svg
                        width="12"
                        height="12"
                        class="svg-icon"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fill="white"
                          d="M19.471,8.934L18.883,8.34c-2.096-2.14-4.707-4.804-8.903-4.804c-4.171,0-6.959,2.83-8.996,4.897L0.488,8.934c-0.307,0.307-0.307,0.803,0,1.109l0.401,0.403c2.052,2.072,4.862,4.909,9.091,4.909c4.25,0,6.88-2.666,8.988-4.807l0.503-0.506C19.778,9.737,19.778,9.241,19.471,8.934z M9.98,13.787c-3.493,0-5.804-2.254-7.833-4.3C4.182,7.424,6.493,5.105,9.98,5.105c3.536,0,5.792,2.301,7.784,4.332l0.049,0.051C15.818,11.511,13.551,13.787,9.98,13.787z"
                        ></path>
                        <circle
                          fill="white"
                          cx="9.98"
                          cy="9.446"
                          r="1.629"
                        ></circle>
                      </svg>
                    </button>
                  </div>
                </td>
              </ng-container>

              <tr
                mat-header-row
                *matHeaderRowDef="materialFoodSectorColumns"
              ></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: materialFoodSectorColumns"
              ></tr>
              <tr class="mat-row" *matNoDataRow style="text-align: center">
                <td class="mat-cell" colspan="8">
                  {{
                    langObj ? langObj?.NoDataFound : ("NoDataFound" | translate)
                  }}
                </td>
              </tr>
            </table>
          </div>
        </div>
      </form>
    </mat-expansion-panel>

    <!--- Production Output -->

    <mat-expansion-panel
      (opened)="panelOpenState = true"
      (closed)="panelOpenState = false"
    >
      <mat-expansion-panel-header class="acc3" class="disable_ripple_acc3">
        <mat-panel-title>
          {{
            langObj
              ? langObj?.ProductionOutput
              : ("ProductionOutput" | translate)
          }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <form [formGroup]="productionOutputForm">
        <div class="wrapper-box wrapper-box-shadow table-wrapper">
          <div class="content-top-row">
            <mat-form-field
              appearence="fill"
              class="top-row-first-filed-item top-row-first-filed-item-order-processing"
              style="margin-left: 10px"
            >
              <mat-label>{{
                langObj
                  ? langObj?.BatchConsumption
                  : ("BatchConsumption" | translate)
              }}</mat-label>
              <mat-select
                formControlName="batchcon"
                panelClass="testClass"
                style="margin-left: 1px"
              >
                <mat-select-filter
                  [placeholder]="'Search'"
                  [displayMember]="'TypeName'"
                  [array]="batchConsumptionList"
                  (filteredReturn)="filteredbatchConsumptionList = $event"
                ></mat-select-filter>
                <mat-option
                  *ngFor="let batch of filteredbatchConsumptionList"
                  [value]="batch.TypeId"
                >
                  {{ batch.TypeName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field
              appearence="fill"
              class="top-row-first-filed-item top-row-first-filed-item-order-processing"
              style="margin-left: 10px"
            >
              <mat-label>{{
                langObj
                  ? langObj?.LoteCodeOrPallet
                  : ("LoteCodeOrPallet" | translate)
              }}</mat-label>
              <input
                formControlName="pallet"
                matInput
                name="test"
                [readonly]="isAuto"
              />
            </mat-form-field>
            <div class="inputField">
              <nz-date-picker
                class="calender-input"
                id="timePicker"
                formControlName="time"
                nzFormat="dd/MM/yyyy HH:mm"
                [nzShowTime]="{ nzFormat: 'HH:mm' }"
                [nzInputReadOnly]="true"
              ></nz-date-picker>
              <span class="floating-text">{{
                langObj ? langObj?.Time : ("Time" | translate)
              }}</span>
            </div>

            <mat-form-field
              appearence="fill"
              class="top-row-first-filed-item top-row-first-filed-item-order-processing"
              style="margin-left: 10px"
            >
              <mat-label
                >{{
                  langObj
                    ? langObj?.ActualQuantity
                    : ("ActualQuantity" | translate)
                }}
                {{ Result }}</mat-label
              >
              <input
                type="number"
                formControlName="actQty"
                matInput
                name="actqty"
              />
            </mat-form-field>
            <mat-form-field
              appearence="fill"
              class="top-row-first-filed-item top-row-first-filed-item-order-processing"
              style="margin-left: 10px"
            >
              <mat-label>{{
                langObj ? langObj?.Remarks : ("Remarks" | translate)
              }}</mat-label>
              <input formControlName="remarks" matInput name="remarks" />
            </mat-form-field>
          </div>
          <div class="content-top-row">
            <button
              class="user_badge"
              mat-flat-button
              color="accent"
              matBadgePosition="after"
              matBadgeColor="accent"
              MatBadgeSize="large"
              disableRipple
              style="margin-left: 10px"
            >
              {{
                langObj
                  ? langObj?.TargetQuantity
                  : ("TargetQuantity" | translate)
              }}: {{ targetQty }}
            </button>
            <button
              class="user_badge"
              mat-flat-button
              color="accent"
              matBadgePosition="after"
              matBadgeColor="accent"
              MatBadgeSize="large"
              disableRipple
              style="margin-left: 10px"
            >
              {{ total1 }}
            </button>
          </div>

          <!--second row-->
          <div
            [ngClass]="
              productionOutputDataSource !== undefined ? 'table-overflow' : ''
            "
          >
            <!--table-->
            <table
              [dataSource]="productionOutputDataSource"
              mat-table
              class="basic-table plant-model-table theight"
              matSort
            >
              <!-- Checklist Column -->
              <ng-container matColumnDef="checklist">
                <th
                  mat-header-cell
                  mat-sort-header-pointer-middle
                  *matHeaderCellDef
                  mat-sort-header
                >
                  <p class="header-text">
                    {{
                      langObj ? langObj?.Checklist : ("Checklist" | translate)
                    }}
                  </p>
                </th>
                <td mat-cell *matCellDef="let element">{{ element?.Name }}</td>
              </ng-container>

              <!-- Values Column -->
              <ng-container matColumnDef="values">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">
                    {{ langObj ? langObj?.Values : ("Values" | translate) }}
                  </p>
                </th>
                <td mat-cell *matCellDef="let element; let i = index">
                  <input
                    *ngIf="
                      element.DataType === 'bool' &&
                      element.BatchCheckListValue === 'true'
                    "
                    [checked]="true"
                    type="checkbox"
                    (change)="
                      checkListFunction(element.BatchCheckListTypeId, $event)
                    "
                    color="primary"
                  />
                  <input
                    *ngIf="
                      element.DataType === 'bool' &&
                      element.BatchCheckListValue !== 'true'
                    "
                    type="checkbox"
                    (change)="
                      checkListFunction(element.BatchCheckListTypeId, $event)
                    "
                    color="primary"
                  />
                  <input
                    *ngIf="element.DataType === 'string'"
                    type="text"
                    [value]="
                      element.BatchCheckListValue === undefined
                        ? ''
                        : element.BatchCheckListValue
                    "
                    (change)="
                      checkListFunction(element.BatchCheckListTypeId, $event)
                    "
                  />
                  <input
                    *ngIf="element.DataType === 'number'"
                    type="number"
                    [value]="element.BatchCheckListValue"
                    (change)="
                      checkListFunction(element.BatchCheckListTypeId, $event)
                    "
                  />
                  <select
                    (change)="
                      checkListFunction(element.BatchCheckListTypeId, $event)
                    "
                    appearance="fill"
                    class="field-fill"
                    *ngIf="element.DataType === 'dropdown'"
                    style="width: 180px"
                  >
                    <option
                      *ngFor="let list of newDropdownList[i]"
                      [selected]="element.BatchCheckListValue === list.TypeName"
                      [value]="list.TypeName"
                    >
                      {{ list.TypeName }}
                    </option>
                  </select>
                  <!-- <input *ngIf="element.DataType === 'dropdown'" type="text" [value]="element.BatchCheckListValue"> -->
                  <mat-form-field
                    appearance="fill"
                    class="field-fill"
                    *ngIf="element.DataType === 'date'"
                    style="width: 180px"
                  >
                    <input
                      matInput
                      [matDatepicker]="pickerspoedit"
                      [value]="element.BatchCheckListValue"
                      (dateInput)="
                        checkListFunction(element.BatchCheckListTypeId, $event)
                      "
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="pickerspoedit"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #pickerspoedit></mat-datepicker>
                  </mat-form-field>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="productionColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: productionColumns"></tr>
              <tr class="mat-row" *matNoDataRow style="text-align: center">
                <td class="mat-cell" colspan="8">
                  {{
                    langObj ? langObj?.NoDataFound : ("NoDataFound" | translate)
                  }}
                </td>
              </tr>
            </table>
          </div>
          <!-- <mat-paginator class="basic-paginataor" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator> -->
          <div
            class="content-top-row content-top-row-order-processing"
            style="display: flex; justify-content: flex-end"
          >
            <button
              (click)="UpdateJBBatchInfoForProductionOutput()"
              type="submit"
              *ngIf="!productionMode"
              mat-mini-fab
              mat-button
              color="primary"
              [pTooltip]="langObj ? langObj?.Update : ('Update' | translate)"
              tooltipPosition="top"
            >
              <i class="fa fa-pencil" style="color: #fff"></i>
            </button>
            <button
              (click)="SaveJBBatchInfoForProductionOutput()"
              type="submit"
              [disabled]="isbuttDisabled"
              *ngIf="productionMode && IsWrite"
              mat-mini-fab
              mat-button
              color="primary"
              [pTooltip]="langObj ? langObj?.Save : ('Save' | translate)"
              tooltipPosition="top"
            >
              <i class="fa fa-floppy-o" style="color: #fff"></i>
            </button>
            <button
              mat-mini-fab
              mat-button
              class="refresh-btn"
              [pTooltip]="langObj ? langObj?.Reset : ('Reset' | translate)"
              tooltipPosition="top"
              style="margin-left: 10px"
              (click)="RefreshProductionOutput()"
            >
              <i class="fa fa-refresh" style="color: #fff"></i>
            </button>
            <button
              type="button"
              mat-mini-fab
              mat-button
              class="list-btn"
              [pTooltip]="
                langObj
                  ? langObj?.HistoryBatchList
                  : ('HistoryBatchList' | translate)
              "
              tooltipPosition="top"
              style="margin-left: 10px"
              (click)="openHistoryModal()"
            >
              <i class="fa fa-list" style="color: #fff"></i>
            </button>
          </div>
          <!--Third row-->
          <div class="content-row-flex-both-end">
            <!--table-->
            <table
              [dataSource]="HistoryBatchDataSource1"
              mat-table
              class="basic-table plant-model-table"
              matSort
            >
              <!-- Batch Consumption -->
              <ng-container matColumnDef="batchCon">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">
                    {{
                      langObj
                        ? langObj?.BatchConsumption
                        : ("BatchConsumption" | translate)
                    }}
                  </p>
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  style="padding: 13px 3px"
                >
                  {{ element?.IPBatchNo }}
                </td>
              </ng-container>

              <!--Lotcode/Pallet-->
              <ng-container matColumnDef="lotcode">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">
                    {{
                      langObj
                        ? langObj?.LoteCodeOrPallet
                        : ("LoteCodeOrPallet" | translate)
                    }}
                  </p>
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  style="padding: 13px 3px"
                >
                  {{ element?.BatchNo }}
                </td>
              </ng-container>
              <!-- Act Qty Column -->
              <ng-container matColumnDef="act">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">
                    {{
                      langObj
                        ? langObj?.ActualQuantity
                        : ("ActualQuantity" | translate)
                    }}
                    {{ Result }}
                  </p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.Result }}
                </td>
              </ng-container>

              <!-- Remakrs Column -->
              <ng-container matColumnDef="remarks">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">
                    {{ langObj ? langObj?.Remarks : ("Remarks" | translate) }}
                  </p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.Remarks }}
                </td>
              </ng-container>

              <!-- Time Column -->
              <ng-container matColumnDef="time">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">
                    {{ langObj ? langObj?.Time : ("Time" | translate) }}
                  </p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.RollStarttime | date: "dd/MM/yyyy HH:mm:ss" }}
                </td>
              </ng-container>

              <!-- Created on Column -->
              <ng-container matColumnDef="createdon">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">
                    {{
                      langObj ? langObj?.CreatedOn : ("CreatedOn" | translate)
                    }}
                  </p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.CreatedOn | date: "dd/MM/yyyy HH:mm:ss" }}
                </td>
              </ng-container>

              <!-- Created by Column -->
              <ng-container matColumnDef="createdby">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">
                    {{
                      langObj ? langObj?.CreatedBy : ("CreatedBy" | translate)
                    }}
                  </p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.CreatedBy }}
                </td>
              </ng-container>

              <!-- Action Column -->
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">
                    {{ langObj ? langObj?.Action : ("Action" | translate) }}
                  </p>
                </th>
                <td mat-cell *matCellDef="let element">
                  <div class="row-action-btns">
                    <button
                      mat-icon-button
                      class="edit-btn"
                      aria-label="Edit Row"
                      (click)="editProductionHistoryBatch(element)"
                      *ngIf="IsWrite"
                      [pTooltip]="
                        langObj ? langObj?.Update : ('Update' | translate)
                      "
                      tooltipPosition="top"
                      style="background-color: #3aafe4"
                    >
                      <svg
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.75 9.06298V11.2505H2.9375L9.38917 4.79881L7.20167 2.61131L0.75 9.06298ZM11.0808 3.10715C11.3083 2.87965 11.3083 2.51215 11.0808 2.28465L9.71583 0.919648C9.48833 0.692148 9.12083 0.692148 8.89333 0.919648L7.82583 1.98715L10.0133 4.17465L11.0808 3.10715Z"
                          fill="white"
                        />
                      </svg>
                    </button>
                    <button
                      type="submit"
                      mat-icon-button
                      class="edit-btn"
                      aria-label="Edit Row"
                      [pTooltip]="
                        langObj ? langObj?.Print : ('Print' | translate)
                      "
                      tooltipPosition="top"
                      style="background-color: crimson"
                      (click)="GetBarCodeDetails(element)"
                    >
                      <svg
                        width="20"
                        height="20"
                        class="svg-icon"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fill="white"
                          d="M17.453,12.691V7.723 M17.453,12.691V7.723 M1.719,12.691V7.723 M18.281,12.691V7.723 M12.691,12.484H7.309c-0.228,0-0.414,0.187-0.414,0.414s0.187,0.414,0.414,0.414h5.383c0.229,0,0.414-0.187,0.414-0.414S12.92,12.484,12.691,12.484M12.691,14.555H7.309c-0.228,0-0.414,0.187-0.414,0.414s0.187,0.414,0.414,0.414h5.383c0.229,0,0.414-0.187,0.414-0.414S12.92,14.555,12.691,14.555 M12.691,12.484H7.309c-0.228,0-0.414,0.187-0.414,0.414s0.187,0.414,0.414,0.414h5.383c0.229,0,0.414-0.187,0.414-0.414S12.92,12.484,12.691,12.484 M12.691,14.555H7.309c-0.228,0-0.414,0.187-0.414,0.414s0.187,0.414,0.414,0.414h5.383c0.229,0,0.414-0.187,0.414-0.414S12.92,14.555,12.691,14.555 M12.691,14.555H7.309c-0.228,0-0.414,0.187-0.414,0.414s0.187,0.414,0.414,0.414h5.383c0.229,0,0.414-0.187,0.414-0.414S12.92,14.555,12.691,14.555M12.691,12.484H7.309c-0.228,0-0.414,0.187-0.414,0.414s0.187,0.414,0.414,0.414h5.383c0.229,0,0.414-0.187,0.414-0.414S12.92,12.484,12.691,12.484 M7.309,13.312h5.383c0.229,0,0.414-0.187,0.414-0.414s-0.186-0.414-0.414-0.414H7.309c-0.228,0-0.414,0.187-0.414,0.414S7.081,13.312,7.309,13.312 M12.691,14.555H7.309c-0.228,0-0.414,0.187-0.414,0.414s0.187,0.414,0.414,0.414h5.383c0.229,0,0.414-0.187,0.414-0.414S12.92,14.555,12.691,14.555 M16.625,6.066h-1.449V3.168c0-0.228-0.186-0.414-0.414-0.414H5.238c-0.228,0-0.414,0.187-0.414,0.414v2.898H3.375c-0.913,0-1.656,0.743-1.656,1.656v4.969c0,0.913,0.743,1.656,1.656,1.656h1.449v2.484c0,0.228,0.187,0.414,0.414,0.414h9.523c0.229,0,0.414-0.187,0.414-0.414v-2.484h1.449c0.912,0,1.656-0.743,1.656-1.656V7.723C18.281,6.81,17.537,6.066,16.625,6.066 M5.652,3.582h8.695v2.484H5.652V3.582zM14.348,16.418H5.652v-4.969h8.695V16.418z M17.453,12.691c0,0.458-0.371,0.828-0.828,0.828h-1.449v-2.484c0-0.228-0.186-0.414-0.414-0.414H5.238c-0.228,0-0.414,0.186-0.414,0.414v2.484H3.375c-0.458,0-0.828-0.37-0.828-0.828V7.723c0-0.458,0.371-0.828,0.828-0.828h13.25c0.457,0,0.828,0.371,0.828,0.828V12.691z M7.309,13.312h5.383c0.229,0,0.414-0.187,0.414-0.414s-0.186-0.414-0.414-0.414H7.309c-0.228,0-0.414,0.187-0.414,0.414S7.081,13.312,7.309,13.312M7.309,15.383h5.383c0.229,0,0.414-0.187,0.414-0.414s-0.186-0.414-0.414-0.414H7.309c-0.228,0-0.414,0.187-0.414,0.414S7.081,15.383,7.309,15.383 M12.691,14.555H7.309c-0.228,0-0.414,0.187-0.414,0.414s0.187,0.414,0.414,0.414h5.383c0.229,0,0.414-0.187,0.414-0.414S12.92,14.555,12.691,14.555 M12.691,12.484H7.309c-0.228,0-0.414,0.187-0.414,0.414s0.187,0.414,0.414,0.414h5.383c0.229,0,0.414-0.187,0.414-0.414S12.92,12.484,12.691,12.484 M12.691,12.484H7.309c-0.228,0-0.414,0.187-0.414,0.414s0.187,0.414,0.414,0.414h5.383c0.229,0,0.414-0.187,0.414-0.414S12.92,12.484,12.691,12.484M12.691,14.555H7.309c-0.228,0-0.414,0.187-0.414,0.414s0.187,0.414,0.414,0.414h5.383c0.229,0,0.414-0.187,0.414-0.414S12.92,14.555,12.691,14.555"
                        ></path>
                      </svg>
                    </button>
                    <button
                      mat-icon-button
                      class="edit-btn"
                      aria-label="Edit Row"
                      (click)="openPopupViewForChecklistHistory(element)"
                      matTooltip="View"
                      matTooltipClass="custom-tooltip"
                      matTooltipPosition="above"
                      style="background-color: lightseagreen"
                    >
                      <svg
                        width="12"
                        height="12"
                        class="svg-icon"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fill="white"
                          d="M19.471,8.934L18.883,8.34c-2.096-2.14-4.707-4.804-8.903-4.804c-4.171,0-6.959,2.83-8.996,4.897L0.488,8.934c-0.307,0.307-0.307,0.803,0,1.109l0.401,0.403c2.052,2.072,4.862,4.909,9.091,4.909c4.25,0,6.88-2.666,8.988-4.807l0.503-0.506C19.778,9.737,19.778,9.241,19.471,8.934z M9.98,13.787c-3.493,0-5.804-2.254-7.833-4.3C4.182,7.424,6.493,5.105,9.98,5.105c3.536,0,5.792,2.301,7.784,4.332l0.049,0.051C15.818,11.511,13.551,13.787,9.98,13.787z"
                        ></path>
                        <circle
                          fill="white"
                          cx="9.98"
                          cy="9.446"
                          r="1.629"
                        ></circle>
                      </svg>
                    </button>
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="production1Columns"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: production1Columns"
              ></tr>
              <tr class="mat-row" *matNoDataRow style="text-align: center">
                <td class="mat-cell" colspan="7">
                  {{
                    langObj
                      ? langObj?.NoDataFound
                      : ("NoDataFound" | translate)
                  }}d
                </td>
              </tr>
            </table>
          </div>
        </div>
      </form>
    </mat-expansion-panel>

    <!-- Waste -->
    <mat-expansion-panel
      (opened)="panelOpenState = true"
      (closed)="panelOpenState = false"
    >
      <mat-expansion-panel-header class="acc4" class="disable_ripple_acc4">
        <mat-panel-title>
          {{ langObj ? langObj?.Waste : ("Waste" | translate) }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <form [formGroup]="wasteForm">
        <div class="wrapper-box wrapper-box-shadow table-wrapper">
          <div class="content-top-row">
            <mat-form-field
              appearence="fill"
              class="top-row-first-filed-item top-row-first-filed-item-order-processing"
              style="margin-left: 1px"
            >
              <mat-label>{{
                langObj ? langObj?.CategoryType : ("CategoryType" | translate)
              }}</mat-label>
              <mat-select
                formControlName="categoryType"
                panelClass="testClass"
                name="cattype"
              >
                <mat-option
                  *ngFor="let fault of FaultList"
                  [value]="fault.FaultId"
                >
                  {{ fault.FaultName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div class="inputField">
              <nz-date-picker
                class="calender-input"
                id="time2Picker"
                formControlName="dateTime"
                nzFormat="dd/MM/yyyy HH:mm"
                [nzShowTime]="{ nzFormat: 'HH:mm' }"
                [nzInputReadOnly]="true"
              >
              </nz-date-picker>
              <span class="floating-text">{{
                langObj ? langObj?.Time : ("Time" | translate)
              }}</span>
            </div>
            <mat-form-field
              appearence="fill"
              class="top-row-first-filed-item top-row-first-filed-item-order-processing"
              style="margin-left: 10px"
            >
              <mat-label>{{ resultWaste }}</mat-label>
              <input type="number" formControlName="uom" matInput name="uom" />
            </mat-form-field>
            <mat-form-field
              appearence="fill"
              class="top-row-first-filed-item top-row-first-filed-item-order-processing"
              style="margin-left: 10px"
            >
              <mat-label>{{ name }}</mat-label>
              <input
                formControlName="failureMode"
                matInput
                name="failuremode"
              />
            </mat-form-field>
          </div>
          <div
            class="content-top-row"
            style="
              margin-top: 20px;
              display: flex;
              justify-content: space-between;
            "
          >
            <button
              class="user_badge"
              mat-flat-button
              color="accent"
              matBadgePosition="after"
              matBadgeColor="accent"
              MatBadgeSize="large"
              disableRipple
              style="margin-left: 10px"
              *ngIf="wasteButtonShow"
            >
              {{ totalWaste }}
            </button>

            <div>
              <button
                (click)="UpdateJBWasteInfo()"
                type="submit"
                *ngIf="!wasteMode && IsWrite"
                mat-mini-fab
                mat-button
                color="primary"
                [pTooltip]="langObj ? langObj?.Update : ('Update' | translate)"
                tooltipPosition="top"
              >
                <i class="fa fa-pencil" style="color: #fff"></i>
              </button>
              <button
                (click)="SaveJBWasteInfo()"
                type="submit"
                *ngIf="wasteMode && IsWrite"
                mat-mini-fab
                mat-button
                color="primary"
                [pTooltip]="langObj ? langObj?.Save : ('Save' | translate)"
                tooltipPosition="top"
              >
                <i class="fa fa-floppy-o" style="color: #fff"></i>
              </button>
              <button
                mat-mini-fab
                mat-button
                class="refresh-btn"
                [pTooltip]="langObj ? langObj?.Reset : ('Reset' | translate)"
                tooltipPosition="top"
                style="margin-left: 10px"
                (click)="RefreshWaste()"
              >
                <i class="fa fa-refresh" style="color: #fff"></i>
              </button>
              <button
                type="button"
                mat-mini-fab
                mat-button
                class="list-btn"
                [pTooltip]="
                  langObj
                    ? langObj?.WasteHistoryList
                    : ('WasteHistoryList' | translate)
                "
                tooltipPosition="top"
                style="margin-left: 10px"
                (click)="openWasteHistoryModal()"
              >
                <i class="fa fa-list" style="color: #fff"></i>
              </button>
            </div>
          </div>
          <!--second row-->
          <div class="content-row-flex-both-end">
            <!--table-->
            <table
              [dataSource]="wasteDataSource1"
              mat-table
              class="basic-table plant-model-table"
              matSort
            >
              <!-- Category Type Column -->
              <ng-container matColumnDef="cattype">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">
                    {{
                      langObj
                        ? langObj?.CategoryType
                        : ("CategoryType" | translate)
                    }}
                  </p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.FaultName }}
                </td>
              </ng-container>

              <!-- Time Column -->
              <ng-container matColumnDef="time">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">
                    {{ langObj ? langObj?.Time : ("Time" | translate) }}
                  </p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.Time | date: "dd/MM/yyyy HH:mm:ss" }}
                </td>
              </ng-container>

              <!-- Failure Mode Column -->
              <ng-container matColumnDef="failure">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">{{ name }}</p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.Remarks }}
                </td>
              </ng-container>

              <!-- UoM Column -->
              <ng-container matColumnDef="uom">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">{{ resultWaste }}</p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.Amount }}
                </td>
              </ng-container>

              <!-- Created On Column -->
              <ng-container matColumnDef="createdon">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">
                    {{
                      langObj ? langObj?.CreatedOn : ("CreatedOn" | translate)
                    }}
                  </p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.CreatedOn | date: "dd/MM/yyyy HH:mm:ss" }}
                </td>
              </ng-container>

              <!-- Created by Column -->
              <ng-container matColumnDef="createdby">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">
                    {{
                      langObj ? langObj?.CreatedBy : ("CreatedBy" | translate)
                    }}
                  </p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.CreatedBy }}
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="wasteColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: wasteColumns"></tr>
              <tr class="mat-row" *matNoDataRow style="text-align: center">
                <td class="mat-cell" colspan="6">
                  {{
                    langObj ? langObj?.NoDataFound : ("NoDataFound" | translate)
                  }}
                </td>
              </tr>
            </table>
          </div>
        </div>
      </form>
    </mat-expansion-panel>

    <!--Down Time-->

    <mat-expansion-panel
      (opened)="panelOpenState = true"
      (closed)="panelOpenState = false"
    >
      <mat-expansion-panel-header class="acc5" class="disable_ripple_acc5">
        <mat-panel-title>
          {{ langObj ? langObj?.DownTime : ("DownTime" | translate) }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-tab-group animationDuration="0ms" #matTabId>
        <!--1st tab-->
        <mat-tab
          [label]="langObj ? langObj?.DownTime : ('DownTime' | translate)"
        >
          <form [formGroup]="downTimeForm">
            <div class="wrapper-box wrapper-box-shadow table-wrapper">
              <div class="content-top-row">
                <input formControlName="Id" [hidden]="true" />
                <div class="inputField">
                  <nz-date-picker
                    class="calender-input"
                    (ngModelChange)="getMinutes($event)"
                    id="startPicker"
                    formControlName="startDate"
                    #ref
                    nzFormat="dd/MM/yyyy HH:mm"
                    [nzShowTime]="{ nzFormat: 'HH:mm' }"
                    [nzInputReadOnly]="true"
                  ></nz-date-picker>
                  <span class="floating-text">{{
                    langObj ? langObj?.StartDate : ("StartDate" | translate)
                  }}</span>
                </div>
                <div class="inputField">
                  <nz-date-picker
                    class="calender-clear"
                    (ngModelChange)="getMinutes($event)"
                    id="endPicker"
                    formControlName="endDate"
                    #ref
                    nzFormat="dd/MM/yyyy HH:mm"
                    [nzShowTime]="{ nzFormat: 'HH:mm' }"
                    [nzInputReadOnly]="true"
                  ></nz-date-picker>
                  <span class="floating-text">{{
                    langObj ? langObj?.EndDate : ("EndDate" | translate)
                  }}</span>
                </div>
                <mat-form-field
                  appearence="fill"
                  class="top-row-first-filed-item top-row-first-filed-item-order-processing"
                  style="margin-left: 10px"
                >
                  <mat-label
                    >{{
                      langObj ? langObj?.EndDate : ("Duration" | translate)
                    }}(mins)</mat-label
                  >
                  <input
                    formControlName="duration"
                    matInput
                    name="duration"
                    [readonly]="true"
                  />
                </mat-form-field>
                <mat-form-field
                  appearence="fill"
                  class="top-row-first-filed-item top-row-first-filed-item-order-processing"
                  style="margin-left: 10px"
                >
                  <mat-label>{{
                    langObj ? langObj?.Faults : ("Faults" | translate)
                  }}</mat-label>
                  <mat-select
                    formControlName="fault"
                    panelClass="testClass"
                    name="faults"
                  >
                    <mat-select-filter
                      [placeholder]="'Search'"
                      [displayMember]="'FaultName'"
                      [array]="DTFaultList"
                      (filteredReturn)="filteredDTFaultList = $event"
                    ></mat-select-filter>
                    <mat-option
                      *ngFor="let fault of filteredDTFaultList"
                      [value]="fault.FaultId"
                    >
                      {{ fault.FaultName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field
                  appearence="fill"
                  class="top-row-first-filed-item top-row-first-filed-item-order-processing"
                  style="margin-left: 10px"
                >
                  <mat-label>{{
                    langObj ? langObj?.Remarks : ("Remarks" | translate)
                  }}</mat-label>
                  <input formControlName="remarks" matInput name="remarks" />
                </mat-form-field>
              </div>
              <div
                class="content-top-row"
                style="
                  margin-top: 20px;
                  display: flex;
                  justify-content: flex-end;
                "
              >
                <div>
                  <button
                    (click)="UpdateJBDowntimeInfo()"
                    type="submit"
                    *ngIf="!downTimeMode && IsWrite"
                    mat-mini-fab
                    mat-button
                    color="primary"
                    [pTooltip]="
                      langObj ? langObj?.Update : ('Update' | translate)
                    "
                    tooltipPosition="top"
                  >
                    <i class="fa fa-pencil" style="color: #fff"></i>
                  </button>
                  <button
                    (click)="SaveJBDowntimeInfo()"
                    type="submit"
                    *ngIf="downTimeMode && IsWrite"
                    mat-mini-fab
                    mat-button
                    color="primary"
                    [pTooltip]="langObj ? langObj?.Save : ('Save' | translate)"
                    tooltipPosition="top"
                  >
                    <i class="fa fa-floppy-o" style="color: #fff"></i>
                  </button>
                  <button
                    mat-mini-fab
                    mat-button
                    class="refresh-btn"
                    [pTooltip]="
                      langObj ? langObj?.Reset : ('Reset' | translate)
                    "
                    tooltipPosition="top"
                    style="margin-left: 10px"
                    (click)="RefreshDownTime()"
                  >
                    <i class="fa fa-refresh" style="color: #fff"></i>
                  </button>
                  <button
                    mat-mini-fab
                    mat-button
                    class="list-btn"
                    [pTooltip]="
                      langObj
                        ? langObj?.DownTimeHistory
                        : ('DownTimeHistory' | translate)
                    "
                    tooltipPosition="top"
                    style="margin-left: 10px"
                    (click)="openModal()"
                  >
                    <i class="fa fa-list" style="color: #fff"></i>
                  </button>
                </div>
              </div>
              <!--second row-->
              <div class="content-row-flex-both-end">
                <!--table-->
                <table
                  mat-table
                  [dataSource]="downtimeDataSource"
                  class="basic-table plant-model-table"
                  matSort
                >
                  <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef>
                      <p class="header-text">
                        {{ langObj ? langObj?.action : ("action" | translate) }}
                      </p>
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      class="row-action-btns-column"
                    >
                      <div class="row-action-btns">
                        <button
                          mat-icon-button
                          class="tree-view-btn"
                          aria-label="View Row Tree"
                          (click)="GetMaintanceInfo(element)"
                        >
                          <svg
                            version="1.1"
                            id="Capa_1"
                            height="15"
                            width="15"
                            viewBox="0 0 482.568 482.568"
                            xml:space="preserve"
                          >
                            <g>
                              <g>
                                <path
                                  d="M116.993,203.218c13.4-1.8,26.8,2.8,36.3,12.3l24,24l22.7-22.6l-32.8-32.7c-5.1-5.1-5.1-13.4,0-18.5s13.4-5.1,18.5,0
                                l32.8,32.8l22.7-22.6l-24.1-24.1c-9.5-9.5-14.1-23-12.3-36.3c4-30.4-5.7-62.2-29-85.6c-23.8-23.8-56.4-33.4-87.3-28.8
                                c-4.9,0.7-6.9,6.8-3.4,10.3l30.9,30.9c14.7,14.7,14.7,38.5,0,53.1l-19,19c-14.7,14.7-38.5,14.7-53.1,0l-31-30.9
                                c-3.5-3.5-9.5-1.5-10.3,3.4c-4.6,30.9,5,63.5,28.8,87.3C54.793,197.518,86.593,207.218,116.993,203.218z"
                                  fill="white"
                                />
                                <path
                                  d="M309.193,243.918l-22.7,22.6l134.8,134.8c5.1,5.1,5.1,13.4,0,18.5s-13.4,5.1-18.5,0l-134.8-134.8l-22.7,22.6l138.9,138.9
                                c17.6,17.6,46.1,17.5,63.7-0.1s17.6-46.1,0.1-63.7L309.193,243.918z"
                                  fill="white"
                                />
                                <circle cx="17" cy="17" r="14" fill="#F85439" />
                                <path
                                  d="M361.293,153.918h59.9l59.9-119.7l-29.9-29.9l-119.8,59.8v59.9l-162.8,162.3l-29.3-29.2l-118,118
                                c-24.6,24.6-24.6,64.4,0,89s64.4,24.6,89,0l118-118l-29.9-29.9L361.293,153.918z"
                                  fill="white"
                                />
                              </g>
                            </g>
                            <g></g>
                            <g></g>
                            <g></g>
                            <g></g>
                            <g></g>
                            <g></g>
                            <g></g>
                            <g></g>
                            <g></g>
                            <g></g>
                            <g></g>
                            <g></g>
                            <g></g>
                            <g></g>
                            <g></g>
                          </svg>
                        </button>
                      </div>
                    </td>
                  </ng-container>
                  <!-- Start Time Column -->
                  <ng-container matColumnDef="starttime">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">
                        {{
                          langObj
                            ? langObj?.StartDate
                            : ("StartDate" | translate)
                        }}
                      </p>
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element?.StartTime | date: "dd/MM/yyyy HH:mm:ss" }}
                    </td>
                  </ng-container>

                  <!-- End Time Column -->
                  <ng-container matColumnDef="endtime">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">
                        {{
                          langObj ? langObj?.EndDate : ("EndDate" | translate)
                        }}
                      </p>
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element?.EndTime | date: "dd/MM/yyyy HH:mm:ss" }}
                    </td>
                  </ng-container>

                  <!-- Duration Column -->
                  <ng-container matColumnDef="duration">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">
                        {{
                          langObj ? langObj?.EndDate : ("Duration" | translate)
                        }}
                        (mins)
                      </p>
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element?.Duration }}
                    </td>
                  </ng-container>

                  <!-- fault Column -->
                  <ng-container matColumnDef="fault">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">
                        {{ langObj ? langObj?.Faults : ("Faults" | translate) }}
                      </p>
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element?.FaultName }}
                    </td>
                  </ng-container>

                  <!-- Remarks Column -->
                  <ng-container matColumnDef="remarks">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">
                        {{
                          langObj ? langObj?.Remarks : ("Remarks" | translate)
                        }}
                      </p>
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element?.Remarks }}
                    </td>
                  </ng-container>

                  <!-- Created On Column -->
                  <ng-container matColumnDef="createdon">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">
                        {{
                          langObj
                            ? langObj?.CreatedOn
                            : ("CreatedOn" | translate)
                        }}
                      </p>
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element?.CreatedOn | date: "dd/MM/yyyy hh:mm:ss" }}
                    </td>
                  </ng-container>

                  <!-- Created By Column -->
                  <ng-container matColumnDef="createdby">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">
                        {{
                          langObj
                            ? langObj?.CreatedBy
                            : ("CreatedBy" | translate)
                        }}
                      </p>
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element?.CreatedBy }}
                    </td>
                  </ng-container>

                  <!-- userManagerActions Column -->
                  <ng-container matColumnDef="sfdcactions">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      class="row-action-btns-column"
                    >
                      <div class="row-action-btns">
                        <button
                          mat-icon-button
                          class="edit-btn"
                          aria-label="Edit Row"
                          (click)="editDownTime(element)"
                        >
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M0.75 9.06298V11.2505H2.9375L9.38917 4.79881L7.20167 2.61131L0.75 9.06298ZM11.0808 3.10715C11.3083 2.87965 11.3083 2.51215 11.0808 2.28465L9.71583 0.919648C9.48833 0.692148 9.12083 0.692148 8.89333 0.919648L7.82583 1.98715L10.0133 4.17465L11.0808 3.10715Z"
                              fill="white"
                            />
                          </svg>
                        </button>
                        <button
                          mat-icon-button
                          class="tree-view-btn"
                          aria-label="View Row Tree"
                        >
                          <svg
                            width="34"
                            height="34"
                            viewBox="0 0 34 34"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M0 10C0 4.47715 4.47715 0 10 0H24C29.5228 0 34 4.47715 34 10V24C34 29.5228 29.5228 34 24 34H10C4.47715 34 0 29.5228 0 24V10Z"
                              fill="#F85439"
                            />
                            <circle cx="17" cy="17" r="14" fill="#F85439" />
                            <path
                              d="M20.9157 12.2611H18.874L18.2907 11.6777H15.374L14.7907 12.2611H12.749V13.4277H20.9157V12.2611ZM13.3324 21.0111C13.3324 21.3205 13.4553 21.6172 13.6741 21.836C13.8929 22.0548 14.1896 22.1777 14.499 22.1777H19.1657C19.4751 22.1777 19.7719 22.0548 19.9906 21.836C20.2094 21.6172 20.3324 21.3205 20.3324 21.0111V14.0111H13.3324V21.0111Z"
                              fill="white"
                            />
                          </svg>
                        </button>
                      </div>
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="downtimeColumns"></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: downtimeColumns"
                  ></tr>
                  <tr class="mat-row" *matNoDataRow style="text-align: center">
                    <td class="mat-cell" colspan="7">
                      {{
                        langObj
                          ? langObj?.NoDataFound
                          : ("NoDataFound" | translate)
                      }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </form>
        </mat-tab>
        <!--2nd tab-->
        <mat-tab
          [label]="langObj ? langObj?.ShortStops : ('ShortStops' | translate)"
        >
          <form [formGroup]="shortStopsForm">
            <div class="wrapper-box wrapper-box-shadow table-wrapper">
              <div class="content-top-row">
                <div class="inputField">
                  <nz-date-picker
                    class="calender-input"
                    (ngModelChange)="getMinutes($event)"
                    id="startPicker1"
                    formControlName="startDate"
                    #ref
                    nzFormat="dd/MM/yyyy HH:mm"
                    [nzShowTime]="{ nzFormat: 'HH:mm' }"
                    [nzDisabled]="true"
                    [nzInputReadOnly]="true"
                  ></nz-date-picker>
                  <span class="floating-text">{{
                    langObj ? langObj?.StartDate : ("StartDate" | translate)
                  }}</span>
                </div>
                <div class="inputField">
                  <nz-date-picker
                    class="calender-input"
                    id="endPicker1"
                    formControlName="endDate"
                    #ref
                    nzFormat="dd/MM/yyyy HH:mm"
                    [nzShowTime]="{ nzFormat: 'HH:mm' }"
                    [nzDisabled]="true"
                    [nzInputReadOnly]="true"
                  ></nz-date-picker>
                  <span class="floating-text">{{
                    langObj ? langObj?.EndDate : ("EndDate" | translate)
                  }}</span>
                </div>
                <mat-form-field
                  appearence="fill"
                  class="top-row-first-filed-item top-row-first-filed-item-order-processing"
                  style="margin-left: 10px"
                >
                  <mat-label
                    >{{
                      langObj ? langObj?.EndDate : ("Duration" | translate)
                    }}(mins)</mat-label
                  >
                  <mat-select
                    formControlName="duration"
                    panelClass="testClass"
                    name="faults"
                    (selectionChange)="getChangeStartTime($event)"
                  >
                    <mat-option
                      *ngFor="let fault of masterList"
                      [value]="fault.TypeId"
                      >{{ fault.TypeName }}</mat-option
                    >
                  </mat-select>
                </mat-form-field>
                <mat-form-field
                  appearence="fill"
                  class="top-row-first-filed-item top-row-first-filed-item-order-processing"
                  style="margin-left: 10px"
                >
                  <mat-label>{{
                    langObj ? langObj?.Faults : ("Faults" | translate)
                  }}</mat-label>
                  <mat-select formControlName="fault" panelClass="testClass">
                    <mat-select-filter
                      [placeholder]="'Search'"
                      [displayMember]="'FaultName'"
                      [array]="GTList"
                      (filteredReturn)="filteredGTList = $event"
                    ></mat-select-filter>
                    <mat-option
                      *ngFor="let fault of filteredGTList"
                      [value]="fault.FaultId"
                    >
                      {{ fault.FaultName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field
                  appearence="fill"
                  class="top-row-first-filed-item top-row-first-filed-item-order-processing"
                  style="margin-left: 10px"
                >
                  <mat-label>{{
                    langObj ? langObj?.Remarks : ("Remarks" | translate)
                  }}</mat-label>
                  <input formControlName="remarks" matInput name="remarks" />
                </mat-form-field>
              </div>

              <div
                class="content-top-row"
                style="
                  margin-top: 20px;
                  display: flex;
                  justify-content: flex-end;
                "
              >
                <div>
                  <button
                    (click)="SaveJBDowntimeInfoForShortStops()"
                    *ngIf="IsWrite"
                    type="submit"
                    mat-mini-fab
                    mat-button
                    color="primary"
                    [pTooltip]="langObj ? langObj?.Save : ('Save' | translate)"
                    tooltipPosition="top"
                  >
                    <i class="fa fa-floppy-o" style="color: #fff"></i>
                  </button>
                  <button
                    mat-mini-fab
                    mat-button
                    class="refresh-btn"
                    [pTooltip]="
                      langObj ? langObj?.Reset : ('Reset' | translate)
                    "
                    tooltipPosition="top"
                    style="margin-left: 10px"
                    (click)="RefreshDownTime()"
                  >
                    <i class="fa fa-refresh" style="color: #fff"></i>
                  </button>
                  <button
                    mat-mini-fab
                    mat-button
                    class="list-btn"
                    [pTooltip]="
                      langObj
                        ? langObj?.DownTimeHistory
                        : ('DownTimeHistory' | translate)
                    "
                    tooltipPosition="top"
                    style="margin-left: 10px"
                    (click)="openModal()"
                  >
                    <i class="fa fa-list" style="color: #fff"></i>
                  </button>
                </div>
              </div>
              <!--second row-->
              <div class="content-row-flex-both-end">
                <!--table-->
                <table
                  mat-table
                  [dataSource]="downtimeDataSource"
                  class="basic-table plant-model-table"
                  matSort
                >
                  <!-- Start Time Column -->
                  <ng-container matColumnDef="starttime">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">
                        {{
                          langObj
                            ? langObj?.StartDate
                            : ("StartDate" | translate)
                        }}
                      </p>
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element?.StartTime | date: "dd/MM/yyyy HH:mm:ss" }}
                    </td>
                  </ng-container>

                  <!-- End Time Column -->
                  <ng-container matColumnDef="endtime">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">
                        {{
                          langObj ? langObj?.EndDate : ("EndDate" | translate)
                        }}
                      </p>
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element?.EndTime }}
                    </td>
                  </ng-container>

                  <!-- Duration Column -->
                  <ng-container matColumnDef="duration">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">
                        {{
                          langObj ? langObj?.EndDate : ("Duration" | translate)
                        }}
                        (mins)
                      </p>
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element?.Duration }}
                    </td>
                  </ng-container>

                  <!-- fault Column -->
                  <ng-container matColumnDef="fault">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">
                        {{ langObj ? langObj?.Faults : ("Faults" | translate) }}
                      </p>
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element?.FaultName }}
                    </td>
                  </ng-container>

                  <!-- Remarks Column -->
                  <ng-container matColumnDef="remarks">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">
                        {{
                          langObj ? langObj?.Remarks : ("Remarks" | translate)
                        }}
                      </p>
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element?.Remarks }}
                    </td>
                  </ng-container>

                  <!-- Created On Column -->
                  <ng-container matColumnDef="createdon">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">
                        {{
                          langObj
                            ? langObj?.CreatedOn
                            : ("CreatedOn" | translate)
                        }}
                      </p>
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element?.CreatedOn | date: "dd/MM/yyyy HH:mm:ss" }}
                    </td>
                  </ng-container>

                  <!-- Created By Column -->
                  <ng-container matColumnDef="createdby">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">
                        {{
                          langObj
                            ? langObj?.CreatedBy
                            : ("CreatedBy" | translate)
                        }}
                      </p>
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element?.CreatedBy }}
                    </td>
                  </ng-container>

                  <!-- userManagerActions Column -->
                  <ng-container matColumnDef="sfdcactions">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      class="row-action-btns-column"
                    >
                      <div class="row-action-btns">
                        <button
                          mat-icon-button
                          class="edit-btn"
                          aria-label="Edit Row"
                          (click)="editDownTime(element)"
                        >
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M0.75 9.06298V11.2505H2.9375L9.38917 4.79881L7.20167 2.61131L0.75 9.06298ZM11.0808 3.10715C11.3083 2.87965 11.3083 2.51215 11.0808 2.28465L9.71583 0.919648C9.48833 0.692148 9.12083 0.692148 8.89333 0.919648L7.82583 1.98715L10.0133 4.17465L11.0808 3.10715Z"
                              fill="white"
                            />
                          </svg>
                        </button>
                        <button
                          mat-icon-button
                          class="tree-view-btn"
                          aria-label="View Row Tree"
                        >
                          <svg
                            width="34"
                            height="34"
                            viewBox="0 0 34 34"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M0 10C0 4.47715 4.47715 0 10 0H24C29.5228 0 34 4.47715 34 10V24C34 29.5228 29.5228 34 24 34H10C4.47715 34 0 29.5228 0 24V10Z"
                              fill="#F85439"
                            />
                            <circle cx="17" cy="17" r="14" fill="#F85439" />
                            <path
                              d="M20.9157 12.2611H18.874L18.2907 11.6777H15.374L14.7907 12.2611H12.749V13.4277H20.9157V12.2611ZM13.3324 21.0111C13.3324 21.3205 13.4553 21.6172 13.6741 21.836C13.8929 22.0548 14.1896 22.1777 14.499 22.1777H19.1657C19.4751 22.1777 19.7719 22.0548 19.9906 21.836C20.2094 21.6172 20.3324 21.3205 20.3324 21.0111V14.0111H13.3324V21.0111Z"
                              fill="white"
                            />
                          </svg>
                        </button>
                      </div>
                    </td>
                  </ng-container>
                  <tr
                    mat-header-row
                    *matHeaderRowDef="downtimeColumnsShortStop"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: downtimeColumnsShortStop"
                  ></tr>
                  <tr class="mat-row" *matNoDataRow style="text-align: center">
                    <td class="mat-cell" colspan="7">
                      {{
                        langObj
                          ? langObj?.NoDataFound
                          : ("NoDataFound" | translate)
                      }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </form>
        </mat-tab>
      </mat-tab-group>
    </mat-expansion-panel>
    <!-- Quality Control -->

    <mat-expansion-panel
      (opened)="panelOpenState = true"
      (closed)="panelOpenState = false"
    >
      <mat-expansion-panel-header class="acc5" class="disable_ripple_acc6">
        <mat-panel-title>
          {{
            langObj ? langObj?.QualityControl : ("QualityControl" | translate)
          }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <form [formGroup]="qualityControlForm">
        <div class="wrapper-box wrapper-box-shadow table-wrapper">
          <div [ngClass]="{ fullscreen: isCardExpandedQuality }">
            <div class="content-top-row">
              <mat-form-field
                appearence="fill"
                class="top-row-first-filed-item top-row-first-filed-item-order-processing"
                style="width: 15%; margin-left: 0px"
              >
                <mat-label class="placeholder-title"
                  >{{
                    langObj ? langObj?.GroupType : ("GroupType" | translate)
                  }}
                </mat-label>
                <mat-select
                  formControlName="groupType"
                  panelClass="testClass"
                  name="Group"
                  required
                  (selectionChange)="qualityControlEventMode()"
                >
                  <mat-option
                    *ngFor="let c of qualityControlGroupTypeList"
                    [value]="c.parameterGroupTypeId"
                  >
                    {{ c.groupTypeName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field
                appearence="fill"
                class="top-row-first-filed-item top-row-first-filed-item-order-processing"
                style="margin-left: 10px"
                *ngIf="qualityGroupType === 'Event'"
              >
                <mat-label>{{
                  langObj ? langObj?.EventType : ("EventType" | translate)
                }}</mat-label>
                <mat-select
                  formControlName="eventType"
                  panelClass="testClass"
                  (selectionChange)="onToProcessDateQuanlityControl()"
                >
                  <mat-option
                    *ngFor="let interval of QualityIntervalTypeDDL"
                    [value]="interval.val"
                    >{{ interval.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field
                appearence="fill"
                class="top-row-first-filed-item top-row-first-filed-item-order-processing"
                style="width: 15%"
                *ngIf="qualityGroupType === 'Time'"
              >
                <mat-label class="placeholder-title">{{
                  langObj
                    ? langObj?.SelectInterval
                    : ("SelectInterval" | translate)
                }}</mat-label>
                <mat-select
                  formControlName="timeInterval"
                  panelClass="testClass"
                  name="Group"
                  (selectionChange)="onQualityIntervalChange()"
                  required
                >
                  <mat-option
                    *ngFor="let c of qualityIntervalList"
                    [value]="c.Interval"
                  >
                    {{ c.Interval }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <div
                *ngIf="qualityGroupType === 'Manual'"
                style="width: 15%; margin-left: 25px; width: 290px"
              >
                <label class="floating-label-multiselect"
                  >{{ langObj? langObj?.ParameterGroup : ("ParameterGroup" | translate) }}</label
                >
                <p-multiSelect
                  (onChange)="onQualityParameterGroupChange()"
                  inputId="multiselect"
                  formControlName="parameterGroup"
                  [options]="qualityparameterGroupList"
                  optionLabel="vgDesc"
                  [filter]="true"
                >
                </p-multiSelect>
              </div>
              <div
                style="width: auto !important"
                class="top-row-first-filed-item top-row-first-filed-item-order-processing"
                style="width: 258px"
              >
                <label class="floating-label">{{ langObj? langObj?.DateRange : ("DateRange" | translate) }}</label>
                <input
                  type="text"
                  matInput
                  ngxDaterangepickerMd
                  formControlName="datePicker"
                  (change)="onToProcessDateQuanlityControl()"
                  [timePicker]="true"
                  [timePicker24Hour]="true"
                  [showDropdowns]="true"
                  [closeOnAutoApply]="true"
                  [locale]="{ format: 'DD/MM/YYYY HH:mm' }"
                  [autoApply]="true"
                />
              </div>
              <!-- <div class="inputField">
                <nz-range-picker class="calender-input" [nzInputReadOnly]="true" [nzShowTime]="{ nzFormat: 'HH:mm' }"
                  [nzDisabledDate]="disabledDate" nzFormat="yyyy-MM-dd HH:mm" formControlName="datePicker">
                </nz-range-picker>
                <span class="floating-text">Date Range</span>
              </div> -->

              <button
                mat-mini-fab
                color="accent"
                (click)="manualInput('quality')"
                *ngIf="qualityGroupType === 'Manual'"
                [pTooltip]="
                  langObj ? langObj?.ManualInput : ('ManualInput' | translate)
                "
                style="margin-left: 10px; margin-top: 5px"
              >
                <!-- {{'ManualInput' | translate}} -->
                <mat-icon>plus_one</mat-icon>
              </button>
            </div>
            <div class="content-top-row">
              <mat-spinner-button
                [options]="spinnerButtonOptions"
                (btnClick)="onClickParamterAnalysisQuality()"
                class="loader"
                id="selectedRows"
                style="margin: 6px 0px"
              >
              </mat-spinner-button>
              <mat-spinner-button
                [options]="spinnerButtonOptions1"
                (btnClick)="onClickParamterComparsionQuality()"
                class="loader"
                id="selectedRows"
                style="margin: 6px 10px"
              >
              </mat-spinner-button>
              <mat-spinner-button
                [options]="spinnerButtonOptionsOrders"
                (btnClick)="onClickControlProcessOrderQuality()"
                class="loader"
                id="selectedRows"
                style="margin: 6px 10px"
              >
              </mat-spinner-button>

              <button
                type="button"
                (click)="onQualityControlRefresh()"
                mat-mini-fab
                mat-button
                color="primary"
                pTooltip="Refresh"
                tooltipPosition="top"
                style="margin-left: 10px; margin-top: 5px"
              >
                <i class="fa fa-refresh" style="color: #fff"></i>
              </button>
              <button
                type="button"
                (click)="toggleTimer()"
                mat-mini-fab
                mat-button
                color="primary"
                [pTooltip]="
                  ResumeInterval ? 'Stop Auto Refresh' : 'Resume Auto Refresh'
                "
                tooltipPosition="top"
                style="margin-left: 10px; margin-top: 6px"
              >
                <mat-icon *ngIf="ResumeInterval">pause_circle_outline</mat-icon>
                <mat-icon *ngIf="!ResumeInterval">play_arrow</mat-icon>
              </button>
              <button
                mat-mini-fab
                mat-button
                (click)="csvExportQC()"
                pTooltip="CSV Export"
                tooltipPosition="top"
                style="margin-left: 20px; margin-top: 5px"
              >
                <img src="assets/images/csv-file-format.png" />
              </button>
              <button
                mat-mini-fab
                mat-button
                (click)="excelExportQC()"
                pTooltip="Excel Export"
                tooltipPosition="top"
                style="margin-top: 5px"
              >
                <i
                  class="fa fa-file-excel-o"
                  style="color: #fff"
                  aria-hidden="true"
                ></i>
              </button>
              <button
                mat-mini-fab
                mat-button
                (click)="pdfExportQC()"
                pTooltip="PDF Export"
                tooltipPosition="top"
                style="margin-top: 5px"
              >
                <i
                  class="fa fa-file-pdf-o"
                  style="color: #fff"
                  aria-hidden="true"
                ></i>
              </button>
              <button
                mat-mini-fab
                mat-button
                mat-dialog-close
                color="accent"
                pTooltip="Expand Grid"
                tooltipPosition="top"
                *ngIf="ExdpandhideQuality"
                (click)="expandquality()"
                style="margin-left: 10px; margin-top: 5px"
              >
                <mat-icon>fullscreen</mat-icon>
              </button>
              <button
                mat-mini-fab
                mat-button
                mat-dialog-close
                color="accent"
                (click)="closequality()"
                style="margin-top: 5px; margin-left: 10px"
                *ngIf="CollapsehideQuality"
              >
                <mat-icon>fullscreen_exit</mat-icon>
              </button>
            </div>

            <ag-grid-angular
              style="width: 100%; height: 30vw"
              class="ag-theme-alpine"
              [rowData]="rowDataQualityControl"
              [columnDefs]="columnDefsQualityControl"
              id="gridContainerQualityControl"
              [getContextMenuItems]="getContextMenuItems"
              [gridOptions]="gridOptionsQualityControl"
              [frameworkComponents]="frameworkComponents"
              [loadingOverlayComponent]="loadingOverlayComponent"
              [loadingOverlayComponentParams]="loadingOverlayComponentParams"
              [rowSelection]="rowSelection"
              [rowMultiSelectWithClick]="true"
              (gridReady)="onQualityControlGridReady($event)"
              [pagination]="true"
              (cellValueChanged)="onQualityControlCellValueChanged($event)"
              [groupHideOpenParents]="true"
              [autoGroupColumnDef]="autoGroupColumnDef"
              [enterMovesDown]="true"
              [enterMovesDownAfterEdit]="true"
            >
            </ag-grid-angular>
          </div>
        </div>
        <ng-template #pdfModelQC>
          <!-- <button (click)="getSelectedRowData()">Click</button> -->
          <div mat-dialog-title>
            <div class="d-flex justify-content-between align-items-center">
              <h3>{{ langObj? langObj?.SelectColumnsForPDFFile : ("SelectColumnsForPDFFile" | translate) }}</h3>
              <button
                mat-mini-fab
                mat-button
                mat-dialog-close
                color="warn"
                pTooltip="Close"
                tooltipPosition="top"
              >
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>
          <hr />
          <mat-dialog-content>
            <div style="width: 100%; height: 290px; margin-top: 10px 0px 10px">
              <div class="p-grid p-fluid" style="margin: 10px 0px 10px">
                <div class="p-col-12 p-md-6 p-lg-6 p-xl-6">
                  <h4 style="text-decoration: underline">{{ langObj? langObj?.SelectColumns : ("SelectColumns" | translate) }}:</h4>
                  <label>{{
                    langObj
                      ? langObj?.SelectColumns
                      : ("SelectColumns" | translate)
                  }}</label>
                  <p-multiSelect
                    [options]="columnsQC"
                    [filter]="true"
                    (onChange)="columnSelectQC()"
                    defaultLabel="Select Column"
                    formControlName="pdfcolumnQC"
                    optionLabel="headerName"
                  ></p-multiSelect>
                </div>
                <div class="p-col-12 p-md-6 p-lg-6 p-xl-6">
                  <h3 style="text-decoration: underline">{{ langObj? langObj?.SelectedColumns : ("SelectedColumns" | translate) }}:</h3>
                  <p>{{ selectedColumnsQC }}</p>
                </div>
              </div>
            </div>
            <hr />
            <div mat-dialog-title>
              <div class="d-flex justify-content-between align-items-center">
                <button
                  type="button"
                  mat-raised-button
                  color="warn"
                  style="
                    background-color: #0f0fd1;
                    font-size: 14px !important;
                    margin-left: 20px;
                    height: 40px;
                    margin-top: 5px;
                  "
                  (click)="downloadPDFQC()"
                >
                  <span style="font-size: 12px; color: white"
                    >{{ langObj? langObj?.DownloadPDF : ("DownloadPDF" | translate) }}</span
                  >
                </button>
              </div>
            </div>
          </mat-dialog-content>
        </ng-template>
      </form>

      <p-dialog
        [contentStyle]="{ overflow: 'scroll' }"
        header="Specifications - {{ paramterSpcecificationName }}"
        [(visible)]="displayQualitySpecificationModal"
        [style]="{ width: '50vw' }"
        [maximizable]="true"
        [baseZIndex]="10000"
        [resizable]="true"
      >
        <div class="p-grid p-fluid">
          <div class="p-col-12 p-md-12">
            <table
              mat-table
              class="basic-table plant-model-table"
              matSort
              [dataSource]="parameterspecifications"
            >
              <ng-container matColumnDef="LRL">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">{{ langObj? langObj?.LRL : ("LRL" | translate) }}</p>
                </th>
                <td mat-cell *matCellDef="let element">{{ element.LRL }}</td>
              </ng-container>

              <ng-container matColumnDef="LSL">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">{{ langObj? langObj?.LSL : ("LSL" | translate) }}</p>
                </th>
                <td mat-cell *matCellDef="let element">{{ element.LSL }}</td>
              </ng-container>

              <ng-container matColumnDef="LWL">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">{{ langObj? langObj?.LWL : ("LWL" | translate) }}</p>
                </th>
                <td mat-cell *matCellDef="let element">{{ element.LWL }}</td>
              </ng-container>

              <ng-container matColumnDef="TGT">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">{{ langObj? langObj?.TGT : ("TGT" | translate) }}</p>
                </th>
                <td mat-cell *matCellDef="let element">{{ element.TGT }}</td>
              </ng-container>

              <ng-container matColumnDef="UWL">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">{{ langObj? langObj?.UWL : ("UWL" | translate) }}</p>
                </th>
                <td mat-cell *matCellDef="let element">{{ element.UWL }}</td>
              </ng-container>

              <ng-container matColumnDef="USL">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">{{ langObj? langObj?.USL : ("USL" | translate) }}</p>
                </th>
                <td mat-cell *matCellDef="let element">{{ element.USL }}</td>
              </ng-container>

              <ng-container matColumnDef="URL">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">{{ langObj? langObj?.URL : ("URL" | translate) }}</p>
                </th>
                <td mat-cell *matCellDef="let element">{{ element.URL }}</td>
              </ng-container>
              -->
              <tr mat-header-row *matHeaderRowDef="processcontrolcolumns"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: processcontrolcolumns"
              ></tr>
            </table>
            <mat-paginator
              class="basic-paginataor"
              [pageSizeOptions]="[10, 20]"
              showFirstLastButtons
            ></mat-paginator>
          </div>
        </div>
      </p-dialog>

      <p-dialog
        [contentStyle]="{ overflow: 'scroll' }"
        header="QX Matrix - Failure Mode"
        [(visible)]="displayQualityDefectModal"
        [style]="{ width: 'auto' }"
        [maximizable]="true"
        [baseZIndex]="10000"
        [resizable]="true"
      >
        <div class="p-grid p-fluid">
          <div class="p-col-12 p-md-12">
            <table
              mat-table
              class="basic-table plant-model-table"
              matSort
              [dataSource]="parametrdefect"
            >
              <ng-container matColumnDef="DefectMode">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">{{ langObj? langObj?.FailureModeDetails : ("FailureModeDetails" | translate) }}</p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.defectmode }}
                </td>
              </ng-container>

              <ng-container matColumnDef="Department">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">{{ langObj? langObj?.Department : ("Department" | translate) }}</p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.department }}
                </td>
              </ng-container>

              <ng-container matColumnDef="Assembly">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">{{ langObj? langObj?.Assembly : ("Assembly" | translate) }}</p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.assembly }}
                </td>
              </ng-container>

              <ng-container matColumnDef="Component">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">{{ langObj? langObj?.Component : ("Component" | translate) }}</p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.component }}
                </td>
              </ng-container>

              <ng-container matColumnDef="Subassembly">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">{{ langObj? langObj?.SubAssembly : ("SubAssembly" | translate) }}</p>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.subassembly }}
                </td>
              </ng-container>

              <ng-container matColumnDef="Unit">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">{{ langObj? langObj?.Unit : ("Unit" | translate) }}</p>
                </th>
                <td mat-cell *matCellDef="let element">{{ element.Unit }}</td>
              </ng-container>

              <ng-container matColumnDef="Line">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">{{ langObj? langObj?.Line : ("Line" | translate) }}</p>
                </th>
                <td mat-cell *matCellDef="let element">{{ element.Line }}</td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="defectColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: defectColumns"></tr>
            </table>
            <mat-paginator
              class="basic-paginataor"
              [pageSizeOptions]="[10, 20]"
              showFirstLastButtons
            ></mat-paginator>
          </div>
        </div>
      </p-dialog>

      <ng-template #displayQCModal>
        <div mat-dialog-title>
          <div class="d-flex justify-content-between align-items-center">
            <h2>{{ langObj? langObj?.QCVerify : ("QCVerify" | translate) }}</h2>

            <button
              mat-mini-fab
              mat-button
              mat-dialog-close
              color="warn"
              title="close"
            >
              <i class="fa fa-times" style="color: #fff"></i>
            </button>
          </div>
        </div>
        <mat-dialog-content>
          <mat-form-field
            appearance="fill"
            class="field-fill"
            style="width: 20%; margin-left: 10px"
          >
            <mat-label>{{ langObj? langObj?.VerificationSlot : ("VerificationSlot" | translate) }}</mat-label>
            <input matInput value="{{ qcParamsSlot }}" disabled />
          </mat-form-field>
          <mat-form-field
            appearance="fill"
            class="field-fill"
            style="width: 20%; margin-left: 10px"
          >
            <mat-label>{{ langObj? langObj?.ProcessOrderNo : ("ProcessOrderNo" | translate) }}</mat-label>
            <input
              matInput
              placeholder="PO"
              value="{{ qcProcessorderNo }}"
              disabled
            />
          </mat-form-field>
          <mat-form-field
            appearance="fill"
            class="field-fill inputs"
            style="display: none"
          >
            <mat-label>{{ langObj? langObj?.VerificationStatus : ("VerificationStatus" | translate) }}</mat-label>
            <mat-select
              [(value)]="verifcationStatus"
              name="status"
              placeholder="{{ langObj? langObj?.SelectVerificationStatus : ('SelectVerificationStatus' | translate) }}"
            >
              <mat-option value="Approve">Approve</mat-option>
              <mat-option value="Reject">Reject</mat-option>
              <mat-option value="Hold">Hold</mat-option>
              <mat-option value="Hold">Downgrade</mat-option>
            </mat-select>
          </mat-form-field>
          <button
            mat-mini-fab
            mat-button
            color="primary"
            title="Save Verifcation"
            style="margin-left: 10px"
            (click)="saveQcVerify()"
          >
            <i class="fa fa-floppy-o" style="color: #fff"></i>
          </button>
          <div class="wrapper-box wrapper-box-shadow table-wrapper">
            <div class="content-row-flex-both-end">
              <table
                mat-table
                class="basic-table plant-model-table"
                matSort
                [dataSource]="qcdataSource"
              >
                <ng-container matColumnDef="ParamaterGroup">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <p class="header-text">{{ langObj? langObj?.ParameterGroup : ('ParameterGroup' | translate) }}</p>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.ParamaterGroup }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="ParameterId">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <p class="header-text">{{ langObj? langObj?.ParameterId : ('ParameterId' | translate) }}</p>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.parameterId }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="Parameter">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <p class="header-text">{{ langObj? langObj?.Parameter : ('Parameter' | translate) }}</p>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.parameter }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="Sample">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <p class="header-text">{{ langObj? langObj?.Sample : ('Sample' | translate) }}</p>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.sample }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="Value">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <p class="header-text">{{ langObj? langObj?.Value : ('Value' | translate) }}</p>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.value }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="verify">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <p class="header-text">{{ langObj? langObj?.VerificationStatus : ('VerificationStatus' | translate) }}/p>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <select
                      [ngModel]="element.verificationStatus"
                      (change)="verifyChnage(element, $event)"
                      class="tableselect"
                    >
                      <option value="Approve">Approve</option>
                      <option value="Reject">Reject</option>
                      <option value="Hold">Hold</option>
                      <option value="Downgrade">Downgrade</option>
                    </select>
                  </td>
                </ng-container>

                <ng-container matColumnDef="remarks">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <p class="header-text">{{ langObj? langObj?.Remarks : ('Remarks' | translate) }}</p>
                  </th>
                  <td mat-cell *matCellDef="let element" style="width: 30%">
                    <mat-form-field
                      appearance="fill"
                      style="width: 100%"
                      class="field-fill-table"
                    >
                      <input
                        matInput
                        placeholder="Remarks"
                        autocomplete="off"
                        (change)="QcVerifyremarksUpdate(element, $event)"
                        [value]="element.remarks"
                      />
                    </mat-form-field>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="qcVerifyColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: qcVerifyColumns"></tr>

                <!-- Group header -->
                <ng-container matColumnDef="groupHeader">
                  <th
                    (click)="QCgroupHeaderClick(group)"
                    colspan="999"
                    mat-header-cell
                    *matCellDef="let group"
                    class="group-header"
                  >
                    <div class="d-flex align-items-center">
                      <mat-icon *ngIf="group.expanded"
                        >arrow_drop_down</mat-icon
                      >
                      <mat-icon *ngIf="!group.expanded">arrow_right</mat-icon>
                      <span style="font-size: 20px" class="table-group-title">{{
                        group[groupByQCColumns[group.level - 1]]
                      }}</span>
                    </div>
                  </th>
                </ng-container>
                <tr
                  mat-header-row
                  *matRowDef="
                    let group;
                    columns: ['groupHeader'];
                    when: isGroup
                  "
                ></tr>
                <mat-row
                  *matRowDef="let row; columns: ['groupHeader']; when: isGroup"
                >
                </mat-row>
              </table>
            </div>
            <mat-paginator
              class="basic-paginataor"
              [pageSizeOptions]="[10, 20]"
              showFirstLastButtons
            ></mat-paginator>
          </div>
        </mat-dialog-content>
      </ng-template>
    </mat-expansion-panel>

    <!-- Checklist Execution -->
    <mat-expansion-panel
      (opened)="panelOpenState = true"
      (closed)="panelOpenState = false"
    >
      <mat-expansion-panel-header class="acc5" class="disable_ripple_acc7">
        <mat-panel-title>
          {{
            langObj
              ? langObj?.QualityChecklistExecution
              : ("QualityChecklistExecution" | translate)
          }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <table
        mat-table
        [dataSource]="customerManagementDataSource"
        class="basic-table plant-model-table"
        matSort
      >
        <ng-container matColumnDef="listName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <p class="header-text">
              {{
                langObj ? langObj?.ChecklistName : ("ChecklistName" | translate)
              }}
            </p>
          </th>
          <td mat-cell *matCellDef="let element">{{ element.listName }}</td>
        </ng-container>

        <ng-container matColumnDef="Area">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="header-min-width"
          >
            <p class="header-text">
              {{ langObj ? langObj?.Area : ("Area" | translate) }}
            </p>
          </th>
          <td mat-cell *matCellDef="let element">{{ element.areaName }}</td>
        </ng-container>
        <ng-container matColumnDef="Machine">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="header-min-width"
          >
            <p class="header-text">
              {{ langObj ? langObj?.Machine : ("Machine" | translate) }}
            </p>
          </th>
          <td mat-cell *matCellDef="let element">{{ element.Pu_Desc }}</td>
        </ng-container>

        <ng-container matColumnDef="createdOn">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="header-min-width"
          >
            <p class="header-text">
              {{
                langObj ? langObj?.ChecklistType : ("ChecklistType" | translate)
              }}
            </p>
          </th>
          <td mat-cell *matCellDef="let element">{{ element.listType }}</td>
        </ng-container>
        <ng-container matColumnDef="TotalExec">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="header-min-width"
          >
            <p class="header-text">
              {{
                langObj
                  ? langObj?.TotalNumberOfExecutions
                  : ("TotalNumberOfExecutions" | translate)
              }}
            </p>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.noOfExecution }}
          </td>
        </ng-container>
        <ng-container matColumnDef="LastexecDate">
          <th
            mat-header-cell
            mat-sort-header-pointer-middle
            *matHeaderCellDef
            mat-sort-header
            class="header-min-width"
          >
            <p class="header-text">
              {{
                langObj
                  ? langObj?.LastExecutionDate
                  : ("LastExecutionDate" | translate)
              }}
            </p>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.lastExecutionDate | date: "dd-MM-yyyy HH:mm:ss" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <p class="header-text">
              {{ langObj ? langObj?.Action : ("Action" | translate) }}
            </p>
          </th>
          <td mat-cell *matCellDef="let element">
            <div class="row-action-btns">
              <button
                (click)="OpenEditCheckList(element, checklistExecutionModal)"
                [pTooltip]="
                  langObj
                    ? langObj?.ListExecution
                    : ('ListExecution' | translate)
                "
                mat-icon-button
                class="edit-btn"
                aria-label="List Execution"
              >
                <svg
                  width="20"
                  height="20"
                  class="svg-icon"
                  viewBox="0 0 20 20"
                >
                  <path
                    fill="white"
                    d="M13.68,9.448h-3.128V6.319c0-0.304-0.248-0.551-0.552-0.551S9.448,6.015,9.448,6.319v3.129H6.319
                    c-0.304,0-0.551,0.247-0.551,0.551s0.247,0.551,0.551,0.551h3.129v3.129c0,0.305,0.248,0.551,0.552,0.551s0.552-0.246,0.552-0.551
                    v-3.129h3.128c0.305,0,0.552-0.247,0.552-0.551S13.984,9.448,13.68,9.448z M10,0.968c-4.987,0-9.031,4.043-9.031,9.031
                    c0,4.989,4.044,9.032,9.031,9.032c4.988,0,9.031-4.043,9.031-9.032C19.031,5.012,14.988,0.968,10,0.968z M10,17.902
                    c-4.364,0-7.902-3.539-7.902-7.903c0-4.365,3.538-7.902,7.902-7.902S17.902,5.635,17.902,10C17.902,14.363,14.364,17.902,10,17.902
                    z"
                  ></path>
                </svg>
              </button>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="customerManagementColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: customerManagementColumns"
          (click)="highlight(row)"
        ></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" style="text-align: center" colspan="4">
            {{ langObj ? langObj?.NoDataFound : ("NoDataFound" | translate) }}
          </td>
        </tr>
      </table>
      <mat-paginator
        class="basic-paginataor"
        [pageSizeOptions]="[5, 10, 20]"
        showFirstLastButtons
      >
      </mat-paginator>
    </mat-expansion-panel>
  </mat-accordion>

  <!-- Down Time History Modal -->
  <ng-template #displayRoleModal *ngIf="onlymachineSelectProperty">
    <form>
      <div mat-dialog-title>
        <div class="d-flex justify-content-between align-items-center">
          <h2>
            {{
              langObj
                ? langObj?.DownTimeHistory
                : ("DownTimeHistory" | translate)
            }}
          </h2>
          <button
            mat-mini-fab
            mat-button
            mat-dialog-close
            color="warn"
            title="close"
          >
            <i class="fa fa-times" style="color: #fff"></i>
          </button>
        </div>
      </div>
      <mat-dialog-content>
        <mat-card-content>
          <ag-grid-angular
            style="width: 100%; height: 30vw"
            class="ag-theme-alpine"
            [rowData]="rowDataDowntimeHistory"
            [columnDefs]="columnDefsDowntimeHistory"
            (gridReady)="onGridReady($event)"
            [frameworkComponents]="frameworkComponents"
            [gridOptions]="gridOptions"
            [pagination]="true"
            [paginationPageSize]="10"
          >
          </ag-grid-angular>
        </mat-card-content>
      </mat-dialog-content>
    </form>
  </ng-template>

  <!-- Waste History Detail Modal -->
  <ng-template #wastehistoryModal *ngIf="machineSelectProperty">
    <form>
      <div mat-dialog-title>
        <div class="d-flex justify-content-between align-items-center">
          <h2>
            {{
              langObj
                ? langObj?.WasteHistoryDetail
                : ("WasteHistoryDetail" | translate)
            }}
          </h2>
          <button
            mat-mini-fab
            mat-button
            mat-dialog-close
            color="warn"
            title="close"
          >
            <i class="fa fa-times" style="color: #fff"></i>
          </button>
        </div>
      </div>
      <mat-dialog-content>
        <mat-dialog-content>
          <mat-card-content>
            <ag-grid-angular
              style="width: 100%; height: 30vw"
              class="ag-theme-alpine"
              [rowData]="rowDataWasteHistory"
              [columnDefs]="columnWasteHistry"
              (gridReady)="onGridReady($event)"
              [frameworkComponents]="frameworkComponents"
              [gridOptions]="gridOptions"
              [pagination]="true"
              [paginationPageSize]="10"
            >
            </ag-grid-angular>
          </mat-card-content>
        </mat-dialog-content>
      </mat-dialog-content>
    </form>
  </ng-template>

  <!-- PO List Modal -->
  <ng-template #displayPoModal>
    <form [formGroup]="poListForm">
      <div mat-dialog-title>
        <div class="d-flex justify-content-between align-items-center">
          <h2>
            {{
              langObj
                ? langObj?.HistoryProcessOrders
                : ("HistoryProcessOrders" | translate)
            }}
          </h2>
          <button
            mat-mini-fab
            mat-button
            mat-dialog-close
            color="warn"
            title="close"
          >
            <i class="fa fa-times" style="color: #fff"></i>
          </button>
        </div>
      </div>
      <mat-dialog-content>
        <!--table-->
        <mat-card-content>
          <ag-grid-angular
            style="width: 100%; height: 30vw"
            class="ag-theme-alpine"
            [rowData]="rowData"
            [columnDefs]="columnDefs"
            (gridReady)="onGridReady($event)"
            [frameworkComponents]="frameworkComponents"
            [gridOptions]="gridOptions"
            [pagination]="true"
            [paginationPageSize]="10"
          >
          </ag-grid-angular>
        </mat-card-content>
      </mat-dialog-content>
    </form>
  </ng-template>

  <!-- History Batch Modal -->
  <ng-template #historyBatchModal *ngIf="machineSelectProperty">
    <form>
      <div mat-dialog-title>
        <div class="d-flex justify-content-between align-items-center">
          <h2>
            {{ langObj ? langObj?.HistoryBatch : ("HistoryBatch" | translate) }}
          </h2>
          <button
            mat-mini-fab
            mat-button
            mat-dialog-close
            color="warn"
            title="close"
          >
            <i class="fa fa-times" style="color: #fff"></i>
          </button>
        </div>
      </div>
      <mat-dialog-content>
        <mat-card-content>
          <ag-grid-angular
            style="width: 100%; height: 30vw"
            class="ag-theme-alpine"
            [rowData]="rowDataBatchHistory"
            [columnDefs]="columnBatchHistory"
            (gridReady)="onGridReady($event)"
            [frameworkComponents]="frameworkComponents"
            [gridOptions]="gridOptions"
            [pagination]="true"
            [paginationPageSize]="10"
          >
          </ag-grid-angular>
        </mat-card-content>
      </mat-dialog-content>
    </form>
  </ng-template>
  <ng-template #historyMaterialModal *ngIf="machineSelectProperty">
    <form>
      <div mat-dialog-title>
        <div class="d-flex justify-content-between align-items-center">
          <h2>
            {{
              langObj
                ? langObj?.HistoryMaterialConsumption
                : ("HistoryMaterialConsumption" | translate)
            }}
          </h2>
          <button
            mat-mini-fab
            mat-button
            mat-dialog-close
            color="warn"
            title="close"
          >
            <i class="fa fa-times" style="color: #fff"></i>
          </button>
        </div>
      </div>
      <mat-dialog-content>
        <mat-card-content>
          <ag-grid-angular
            style="width: 100%; height: 30vw"
            class="ag-theme-alpine"
            [rowData]="rowDataMaterialConsumptionHistory"
            [columnDefs]="columnMaterialConsumptionHistory"
            (gridReady)="onGridReady($event)"
            [frameworkComponents]="frameworkComponents"
            [gridOptions]="gridOptions"
            [pagination]="true"
            [paginationPageSize]="10"
          >
          </ag-grid-angular>
        </mat-card-content>
      </mat-dialog-content>
    </form>
  </ng-template>

  <!--popup modal for production checklist history-->
  <ng-template #popupViewModal>
    <div class="viewChecklist">
      <div mat-dialog-title>
        <div class="d-flex justify-content-between align-items-center">
          <h2>
            {{
              langObj
                ? langObj?.ChecklistHistoryView
                : ("ChecklistHistoryView" | translate)
            }}
          </h2>
          <button
            mat-mini-fab
            mat-button
            mat-dialog-close
            color="warn"
            title="close"
          >
            <i class="fa fa-times" style="color: #fff"></i>
          </button>
        </div>
      </div>
      <div
        [ngClass]="
          ViewProductionOutputDataSource !== undefined ? 'table-overflow' : ''
        "
      >
        <table
          [dataSource]="ViewProductionOutputDataSource"
          mat-table
          class="basic-table plant-model-table theight"
          matSort
        >
          <!-- Checklist Column -->
          <ng-container matColumnDef="checklist">
            <th
              mat-header-cell
              mat-sort-header-pointer-middle
              *matHeaderCellDef
              mat-sort-header
            >
              <p class="header-text">
                {{ langObj ? langObj?.Checklist : ("Checklist" | translate) }}
              </p>
            </th>
            <td mat-cell *matCellDef="let element">{{ element?.Name }}</td>
          </ng-container>

          <!-- Values Column -->
          <ng-container matColumnDef="values">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">
                {{ langObj ? langObj?.Values : ("Values" | translate) }}
              </p>
            </th>
            <td mat-cell *matCellDef="let element; let i = index">
              <input
                *ngIf="
                  element.DataType === 'bool' &&
                  element.BatchCheckListValue === 'true'
                "
                [checked]="true"
                type="checkbox"
                (change)="
                  checkListFunction(element.BatchCheckListTypeId, $event)
                "
                color="primary"
                [readonly]="true"
              />
              <input
                *ngIf="
                  element.DataType === 'bool' &&
                  element.BatchCheckListValue !== 'true'
                "
                type="checkbox"
                (change)="
                  checkListFunction(element.BatchCheckListTypeId, $event)
                "
                color="primary"
                [readonly]="true"
              />
              <input
                *ngIf="element.DataType === 'string'"
                type="text"
                [value]="
                  element.BatchCheckListValue === undefined
                    ? ''
                    : element.BatchCheckListValue
                "
                (change)="
                  checkListFunction(element.BatchCheckListTypeId, $event)
                "
                [readonly]="true"
              />
              <input
                *ngIf="element.DataType === 'number'"
                type="number"
                [value]="element.BatchCheckListValue"
                (change)="
                  checkListFunction(element.BatchCheckListTypeId, $event)
                "
                [readonly]="true"
              />
              <input
                type="text"
                appearance="fill"
                class="field-fill"
                style="width: 180px"
                *ngIf="element.DataType === 'dropdown'"
                [value]="element.BatchCheckListValue"
                [disabled]="true"
              />
              <mat-form-field
                appearance="fill"
                class="field-fill"
                *ngIf="element.DataType === 'date'"
                style="width: 180px"
              >
                <input
                  matInput
                  [matDatepicker]="pickers"
                  [value]="element.BatchCheckListValue"
                  (dateInput)="
                    checkListFunction(element.BatchCheckListTypeId, $event)
                  "
                  [readonly]="true"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="pickers"
                ></mat-datepicker-toggle>
                <mat-datepicker #pickers></mat-datepicker>
              </mat-form-field>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="productionColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: productionColumns"></tr>
          <tr class="mat-row" *matNoDataRow style="text-align: center">
            <td class="mat-cell" colspan="8">
              {{ langObj ? langObj?.NoDataFound : ("NoDataFound" | translate) }}
            </td>
          </tr>
        </table>
      </div>
    </div>
  </ng-template>
  <ng-template #materialViewModal>
    <div class="viewChecklist">
      <div mat-dialog-title>
        <div class="d-flex justify-content-between align-items-center">
          <h2>
            {{
              langObj
                ? langObj?.MaterialHistoryView
                : ("MaterialHistoryView" | translate)
            }}
          </h2>
          <button
            mat-mini-fab
            mat-button
            mat-dialog-close
            color="warn"
            title="close"
          >
            <i class="fa fa-times" style="color: #fff"></i>
          </button>
        </div>
      </div>
      <div class="content-row-flex-both-end">
        <!--table-->
        <table
          mat-table
          class="basic-table plant-model-table"
          [dataSource]="ItemBOMViewList"
          matSort
        >
          <!-- Item Type Column -->
          <ng-container matColumnDef="itemtype">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">
                {{ langObj ? langObj?.Item : ("Item" | translate) }}
              </p>
            </th>
            <td mat-cell *matCellDef="let element">{{ element.ItemCode }}</td>
          </ng-container>

          <ng-container matColumnDef="itemDesc">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">
                {{
                  langObj
                    ? langObj?.ItemDescription
                    : ("ItemDescription" | translate)
                }}
              </p>
            </th>
            <td mat-cell *matCellDef="let element">{{ element.ItemDesc }}</td>
          </ng-container>
          <ng-container matColumnDef="itemuom">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">
                {{ langObj ? langObj?.Item : ("Item" | translate) }} UOM
              </p>
            </th>
            <td mat-cell *matCellDef="let element">{{ element.UOM }}</td>
          </ng-container>

          <!-- Batch Column -->
          <ng-container matColumnDef="estQty">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">
                {{
                  langObj
                    ? langObj?.EstimatedQuantity
                    : ("EstimatedQuantity" | translate)
                }}
              </p>
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.EsimatedQty }}
            </td>
          </ng-container>

          <!-- length Column -->
          <ng-container matColumnDef="actQty">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">
                {{
                  langObj
                    ? langObj?.ActualQuantity
                    : ("ActualQuantity" | translate)
                }}
              </p>
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.ItemBOMValue }}
            </td>
          </ng-container>

          <ng-container matColumnDef="supplier">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">
                {{ langObj ? langObj?.Supplier : ("Supplier" | translate) }}
              </p>
            </th>
            <td mat-cell *matCellDef="let element">{{ element.Supplier }}</td>
          </ng-container>
          <ng-container matColumnDef="prodDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">
                {{
                  langObj
                    ? langObj?.ProductionDate
                    : ("ProductionDate" | translate)
                }}
              </p>
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.ProductionDate }}
            </td>
          </ng-container>
          <ng-container matColumnDef="expireDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">
                {{
                  langObj
                    ? langObj?.ExpirationDate
                    : ("ExpirationDate" | translate)
                }}
              </p>
            </th>
            <td mat-cell *matCellDef="let element">{{ element.ExpireDate }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="materialSubColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: materialSubColumns"></tr>
          <tr class="mat-row" *matNoDataRow style="text-align: center">
            <td class="mat-cell" colspan="8">
              {{ langObj ? langObj?.NoDataFound : ("NoDataFound" | translate) }}
            </td>
          </tr>
        </table>
      </div>
    </div>
  </ng-template>

  <!-- History Batch Material Consumption Modal -->
  <ng-template #historyBatch1Modal *ngIf="machineSelectProperty">
    <form>
      <div mat-dialog-title>
        <div class="d-flex justify-content-between align-items-center">
          <h2>
            {{ langObj ? langObj?.HistoryBatch : ("HistoryBatch" | translate) }}
          </h2>
          <button
            mat-mini-fab
            mat-button
            mat-dialog-close
            color="warn"
            title="close"
          >
            <i class="fa fa-times" style="color: #fff"></i>
          </button>
        </div>
      </div>
      <mat-dialog-content>
        <ag-grid-angular
          style="width: 100%; height: 30vw"
          class="ag-theme-alpine"
          [rowData]="rowDataMaterialBatchHistory"
          [columnDefs]="columnMaterialBatchHistory"
          (gridReady)="onGridReady($event)"
          [frameworkComponents]="frameworkComponents"
          [gridOptions]="gridOptions"
          [pagination]="true"
          [paginationPageSize]="10"
        >
        </ag-grid-angular>
      </mat-dialog-content>
    </form>
  </ng-template>

  <ng-template #centerlineModal *ngIf="machineSelectProperty">
    <form>
      <div mat-dialog-title style="margin: 0 0 0px">
        <div class="d-flex justify-content-between align-items-center">
          <h2>
            {{
              langObj
                ? langObj?.ProcessParameters
                : ("ProcessParameters" | translate)
            }}
          </h2>
          <button
            mat-mini-fab
            mat-button
            mat-dialog-close
            color="warn"
            title="close"
          >
            <i class="fa fa-times" style="color: #fff"></i>
          </button>
        </div>
      </div>
      <mat-dialog-content>
        <div class="p-grid p-fluid">
          <div class="p-xl-12 p-lg-12 p-md-12 p-col-12">
            <div class="">
              <div class="p-grid p-fluid" style="margin-top: -0.9rem">
                <div class="p-xl-4 p-lg-4 p-md-4 p-12">
                  <table
                    mat-table
                    id="chkId"
                    [dataSource]="processparameter1DataSource"
                    class="basic-table plant-model-table"
                    matSort
                  >
                    <!-- Process Parameter Column -->
                    <ng-container matColumnDef="processparameter">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header
                        style="padding-left: 12px"
                      >
                        <p class="header-text">
                          {{
                            langObj
                              ? langObj?.ProcessParameter
                              : ("ProcessParameter" | translate)
                          }}
                        </p>
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let element"
                        style="max-width: 0px"
                      >
                        {{ element?.KpiName }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="values">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        <p class="header-text">
                          {{
                            langObj ? langObj?.Values : ("Values" | translate)
                          }}
                        </p>
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let element"
                        style="padding-left: 0px"
                      >
                        <mat-form-field
                          appearance="fill"
                          class="field-fill"
                          style="width: 200px"
                        >
                          <input
                            (change)="
                              checkListFunctionForProcess(element, $event)
                            "
                            [value]="element?.KpiValues"
                            matInput
                            class="materialParameterInputs"
                          />
                        </mat-form-field>
                      </td>
                    </ng-container>
                    <tr
                      mat-header-row
                      *matHeaderRowDef="processparameter1Columns"
                    ></tr>
                    <tr
                      mat-row
                      *matRowDef="let row; columns: processparameter1Columns"
                    ></tr>
                    <tr
                      class="mat-row"
                      *matNoDataRow
                      style="text-align: center"
                    >
                      <td class="mat-cell" colspan="8">
                        {{
                          langObj
                            ? langObj?.NoDataFound
                            : ("NoDataFound" | translate)
                        }}
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="p-xl-4 p-lg-4 p-md-4 p-12">
                  <table
                    mat-table
                    [dataSource]="processparameter22DataSource"
                    class="basic-table plant-model-table"
                    matSort
                  >
                    <!-- Process Parameter Column -->
                    <ng-container matColumnDef="materialparameter">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header
                        style="padding-left: 12px"
                      >
                        <p class="header-text">
                          {{
                            langObj
                              ? langObj?.MaterialParameter
                              : ("MaterialParameter" | translate)
                          }}
                        </p>
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let element"
                        style="max-width: 0px"
                      >
                        {{ element?.KpiName }}
                      </td>
                    </ng-container>
                    <!-- Values Column -->
                    <ng-container matColumnDef="values">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        <p class="header-text">
                          {{
                            langObj ? langObj?.Values : ("Values" | translate)
                          }}
                        </p>
                      </th>
                      <td mat-cell *matCellDef="let element">
                        <mat-form-field
                          appearance="fill"
                          class="field-fill"
                          style="width: 200px"
                        >
                          <input
                            (change)="
                              checkListFunctionMaterial(element, $event)
                            "
                            [value]="element?.KpiValues"
                            matInput
                            class="materialParameterInputs"
                          />
                        </mat-form-field>
                      </td>
                    </ng-container>
                    <tr
                      mat-header-row
                      *matHeaderRowDef="processparameter2Columns"
                    ></tr>
                    <tr
                      mat-row
                      *matRowDef="let row; columns: processparameter2Columns"
                    ></tr>
                    <tr
                      class="mat-row"
                      *matNoDataRow
                      style="text-align: center"
                    >
                      <td class="mat-cell" colspan="8">
                        {{
                          langObj
                            ? langObj?.NoDataFound
                            : ("NoDataFound" | translate)
                        }}
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="p-xl-4 p-lg-4 p-md-4 p-12">
                  <table
                    mat-table
                    [dataSource]="processparameter33DataSource"
                    class="basic-table plant-model-table"
                    matSort
                  >
                    <!-- Process Parameter Column -->
                    <ng-container matColumnDef="lineclearance">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        <p class="header-text">
                          {{
                            langObj
                              ? langObj?.LineClearence
                              : ("LineClearence" | translate)
                          }}
                        </p>
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let element"
                        style="max-width: 300px"
                      >
                        {{ element?.KpiName }}
                      </td>
                    </ng-container>
                    <!-- Values Column -->
                    <ng-container matColumnDef="values">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        <p class="header-text">
                          {{
                            langObj ? langObj?.Values : ("Values" | translate)
                          }}
                        </p>
                      </th>
                      <td mat-cell *matCellDef="let element">
                        <input
                          type="checkbox"
                          [checked]="element.KpiValues"
                          (change)="checkListFunctionLine(element, $event)"
                          color="primary"
                        />
                      </td>
                      <!-- <td mat-cell *matCellDef="let element" [id]="element.KpiparaId" ><mat-checkbox [checked]="element.KpiValues" color="primary"></mat-checkbox></td> -->
                    </ng-container>
                    <tr
                      mat-header-row
                      *matHeaderRowDef="processparameter3Columns"
                    ></tr>
                    <tr
                      mat-row
                      *matRowDef="let row; columns: processparameter3Columns"
                    ></tr>
                    <tr
                      class="mat-row"
                      *matNoDataRow
                      style="text-align: center"
                    >
                      <td class="mat-cell" colspan="8">
                        {{
                          langObj
                            ? langObj?.NoDataFound
                            : ("NoDataFound" | translate)
                        }}
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-dialog-content>
      <div mat-dialog-actions style="float: right">
        <button
          (click)="SumbitJobKpiParameters1($event)"
          type="submit"
          *ngIf="!materialConsumptionMode"
          [disabled]="!materialConsumptionForm.valid"
          mat-mini-fab
          mat-button
          color="primary"
          [matTooltip]="langObj ? langObj?.Update : ('Update' | translate)"
          matTooltipClass="custom-tooltip"
          matTooltipPosition="above"
        >
          <i class="fa fa-pencil" style="color: #fff"></i>
        </button>
        <button
          (click)="SumbitJobKpiParameters($event)"
          type="submit"
          *ngIf="centerLineMode"
          mat-mini-fab
          mat-button
          color="primary"
          [matTooltip]="langObj ? langObj?.Save : ('Save' | translate)"
          matTooltipClass="custom-tooltip"
          matTooltipPosition="above"
        >
          <i class="fa fa-floppy-o" style="color: #fff"></i>
        </button>
      </div>
    </form>
  </ng-template>

  <!-- Last Shift Modal -->
  <ng-template #lastshiftModal *ngIf="onlymachineSelectProperty">
    <form>
      <div mat-dialog-title>
        <div class="d-flex justify-content-between align-items-center">
          <h2>
            {{ langObj ? langObj?.Last : ("Last" | translate) }}
            {{ langObj ? langObj?.Shift : ("Shift" | translate) }}
          </h2>
          <button
            mat-mini-fab
            mat-button
            mat-dialog-close
            color="warn"
            title="close"
          >
            <i class="fa fa-times" style="color: #fff"></i>
          </button>
        </div>
      </div>
      <mat-dialog-content>
        <div class="p-grid p-fluid">
          <div class="p-xl-12 p-lg-12 p-md-12 p-col-12">
            <div class="content-row-flex-both-end">
              <div class="card-item card-item-five" style="max-width: 39%">
                <div
                  class="card"
                  style="display: flex; width: 424px; height: 230px"
                >
                  <img
                    src="assets/images/user.png"
                    alt=""
                    width="170px"
                    height="200px"
                    style="margin: 0"
                  />
                  <o3-percentage-graph></o3-percentage-graph>
                  <div style="margin-left: 10px; margin-top: 0px">
                    <h2 style="margin-left: 15px">{{ UserName }}</h2>
                    <div style="display: flex; margin-top: -20px">
                      <div style="width: 100%">
                        <h3 class="graph-title">
                          {{
                            langObj ? langObj?.Shift : ("Shift" | translate)
                          }}:
                        </h3>
                        <h3 class="graph-title">
                          {{
                            langObj ? langObj?.Shift : ("Shift" | translate)
                          }}
                          {{
                            langObj ? langObj?.Start : ("Start" | translate)
                          }}:
                        </h3>
                        <h3 class="graph-title">
                          {{
                            langObj ? langObj?.Shift : ("Shift" | translate)
                          }}
                          {{ langObj ? langObj?.End : ("End" | translate) }}:
                        </h3>
                        <h3 class="graph-title">
                          {{
                            langObj
                              ? langObj?.Supervisor
                              : ("Supervisor" | translate)
                          }}:
                        </h3>
                      </div>
                      <div style="width: 70%">
                        <button
                          class="user_badge"
                          mat-flat-button
                          color="accent"
                          matBadgePosition="after"
                          matBadgeColor="accent"
                          MatBadgeSize="large"
                          disableRipple
                          style="margin-left: 14px"
                          *ngIf="Shift !== ''"
                        >
                          <p class="badge-text">
                            {{ Shift }}
                          </p>
                        </button>
                        <br />
                        <button
                          class="user_badge"
                          mat-flat-button
                          color="accent"
                          matBadgePosition="after"
                          matBadgeColor="accent"
                          MatBadgeSize="large"
                          disableRipple
                          style="margin-left: 14px"
                          *ngIf="ShiftStart !== ''"
                        >
                          <p class="badge-text">{{ ShiftStart }}</p>
                        </button>
                        <br />
                        <button
                          class="user_badge"
                          mat-flat-button
                          color="accent"
                          matBadgePosition="after"
                          matBadgeColor="accent"
                          MatBadgeSize="large"
                          disableRipple
                          style="margin-left: 14px"
                          *ngIf="ShiftEnd !== ''"
                        >
                          <p class="badge-text">{{ ShiftEnd }}</p>
                        </button>
                        <br />
                        <button
                          class="user_badge"
                          mat-flat-button
                          color="accent"
                          matBadgePosition="after"
                          matBadgeColor="accent"
                          MatBadgeSize="large"
                          disableRipple
                          style="margin-left: 14px"
                          *ngIf="Supervisor !== ''"
                        >
                          <p class="badge-text">{{ Supervisor }}</p>
                        </button>
                      </div>
                    </div>

                    <br />
                  </div>
                </div>
              </div>
              <div class="card-item card-item-five-group" *ngIf="showMode">
                <div
                  class="card card-group"
                  *ngFor="let element of OEEInfoList"
                  style="padding: 10px 1px"
                >
                  <o3-percentage-graph
                    [barProperties]="element.capacityUtilization"
                  ></o3-percentage-graph>
                  <p
                    class="graph-title"
                    style="margin-bottom: 6px; margin-top: 10px"
                  >
                    OEE
                  </p>
                </div>
              </div>
              <div class="card-item card-item-five-group" *ngIf="showMode">
                <div
                  class="card card-group"
                  *ngFor="let element of OEEInfoList"
                  style="padding: 10px 1px"
                >
                  <o3-percentage-graph
                    [barProperties]="element.availabilityUtilization"
                  ></o3-percentage-graph>
                  <p
                    class="graph-title"
                    style="margin-bottom: 6px; margin-top: 10px"
                  >
                    {{
                      langObj
                        ? langObj?.Availability
                        : ("Availability" | translate)
                    }}
                  </p>
                </div>
              </div>
              <div class="card-item card-item-five-group" *ngIf="showMode">
                <div
                  class="card card-group"
                  *ngFor="let element of OEEInfoList"
                  style="padding: 10px 1px"
                >
                  <o3-percentage-graph
                    [barProperties]="element.performanceUtilization"
                  ></o3-percentage-graph>
                  <p
                    class="graph-title"
                    style="margin-bottom: 6px; margin-top: 10px"
                  >
                    {{
                      langObj
                        ? langObj?.Performance
                        : ("Performance" | translate)
                    }}
                  </p>
                </div>
              </div>
              <div class="card-item card-item-five-group" *ngIf="showMode">
                <div
                  class="card card-group"
                  *ngFor="let element of OEEInfoList"
                  style="padding: 10px 1px"
                >
                  <o3-percentage-graph
                    [barProperties]="element.qualityUtilization"
                  ></o3-percentage-graph>
                  <p
                    class="graph-title merge-style"
                    style="margin-bottom: 6px; margin-top: 10px"
                  >
                    {{ langObj ? langObj?.Quality : ("Quality" | translate) }}
                  </p>
                </div>
              </div>
            </div>
            <div class="" style="display: flex">
              <div class="chart-item">
                <div class="chart-title" style="text-align: center">
                  {{
                    langObj ? langObj?.DownTime : ("DownTime" | translate)
                  }}Down Time (Mins)
                </div>
                <canvas id="downTimeChart"></canvas>
              </div>
              <div class="chart-item" style="margin-left: 100px">
                <div class="chart-title" style="text-align: center">
                  {{ langObj ? langObj?.Weight : ("Weight" | translate) }} (Kg)
                </div>
                <canvas id="weightChart"></canvas>
              </div>
            </div>

            <div class="content-row-flex-both-end">
              <!--table-->
              <table
                [dataSource]="lastShiftDataSource"
                mat-table
                class="basic-table plant-model-table"
                matSort
              >
                <!-- S.NoColumn -->
                <ng-container matColumnDef="sno">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <p class="header-text">S.No</p>
                  </th>
                  <td mat-cell *matCellDef="let element"></td>
                </ng-container>

                <!-- Validations Column -->
                <ng-container matColumnDef="validations">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <p class="header-text">
                      {{
                        langObj
                          ? langObj?.Validations
                          : ("Validations" | translate)
                      }}
                    </p>
                  </th>
                  <td mat-cell *matCellDef="let element"></td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="lastshiftColumns"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: lastshiftColumns"
                ></tr>
                <tr class="mat-row" *matNoDataRow style="text-align: center">
                  <td class="mat-cell" colspan="2">
                    {{
                      langObj
                        ? langObj?.NoDataFound
                        : ("NoDataFound" | translate)
                    }}
                  </td>
                </tr>
              </table>
            </div>
            <mat-paginator
              class="basic-paginataor"
              [pageSizeOptions]="[5, 10, 20]"
              showFirstLastButtons
            >
            </mat-paginator>
          </div>
        </div>
      </mat-dialog-content>
    </form>
  </ng-template>

  <!-- Shift Close Modal -->
  <ng-template #displayshiftcloseRoleModal *ngIf="onlymachineSelectProperty">
    <div mat-dialog-title>
      <div class="d-flex justify-content-between align-items-center">
        <h2>
          {{ langObj ? langObj?.Shift : ("Shift" | translate) }}
          {{ langObj ? langObj?.Close : ("Close" | translate) }}
        </h2>
        <button
          mat-mini-fab
          mat-button
          mat-dialog-close
          color="warn"
          title="close"
        >
          <i class="fa fa-times" style="color: #fff"></i>
        </button>
      </div>
    </div>
    <mat-dialog-content>
      <!-- <mat-form-field
        appearence="fill"
        class="top-row-first-filed-item top-row-first-filed-item-order-processing"
        style="margin-left: 2px"
      >
        <mat-label>{{ langObj? langObj?.ManPowerRequired : ('ManPowerRequired' | translate) }}</mat-label>
        <input
          matInput
          [(ngModel)]="ManPower"
          type="number"
          min="1"
          step="1"
          name="ManPower"
          required
        />
      </mat-form-field> -->
      <!-- <h3 style=" font-size: 20px;">{{'Availability' | translate}}</h3> -->
      <h3 style="font-size: 20px">
        {{ langObj ? langObj?.Availability : ("Availability" | translate) }}
      </h3>
      <div class="content-row-flex-both-end">
        <!--table-->
        <table
          mat-table
          class="basic-table plant-model-table"
          [dataSource]="availabilityDataSource"
          matSort
        >
          <!-- Start Time Column -->
          <ng-container matColumnDef="ttime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">
                {{ langObj ? langObj?.Total : ("Total" | translate) }}
                {{ langObj ? langObj?.Time : ("Time" | translate) }}
              </p>
            </th>
            <td mat-cell *matCellDef="let element">{{ element?.TotalTime }}</td>
          </ng-container>

          <!-- End Time Column -->
          <ng-container matColumnDef="dtime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">
                {{ langObj ? langObj?.DownTime : ("DownTime" | translate) }}
              </p>
            </th>
            <td mat-cell *matCellDef="let element">{{ element?.Downtime }}</td>
          </ng-container>

          <!-- Duration Column -->
          <ng-container matColumnDef="atime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">
                {{ langObj ? langObj?.Total : ("Total" | translate) }}
                {{ langObj ? langObj?.Available : ("Available" | translate) }}
                {{ langObj ? langObj?.Time : ("Time" | translate) }}
              </p>
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element?.TotalAvailableTime }}
            </td>
          </ng-container>

          <!-- Fault Column -->
          <ng-container matColumnDef="rtime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">
                {{ langObj ? langObj?.Total : ("Total" | translate) }}
                {{ langObj ? langObj?.Running : ("Running" | translate) }}
                {{ langObj ? langObj?.Time : ("Time" | translate) }}
              </p>
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element?.TotalRunningTime }}
            </td>
          </ng-container>

          <ng-container matColumnDef="mtime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">
                {{ langObj ? langObj?.Missing : ("Missing" | translate) }}
                {{ langObj ? langObj?.Time : ("Time" | translate) }}
              </p>
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element?.MissingTime }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="availabilityColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: availabilityColumns"></tr>
          <tr class="mat-row" *matNoDataRow style="text-align: center">
            <td class="mat-cell" colspan="5">
              {{ langObj ? langObj?.NoDataFound : ("NoDataFound" | translate) }}
            </td>
          </tr>
        </table>
      </div>
      <h3 style="font-size: 20px">
        {{ langObj ? langObj?.Performance : ("Performance" | translate) }}
      </h3>
      <div class="content-row-flex-both-end">
        <!--table-->
        <table
          mat-table
          class="basic-table plant-model-table"
          [dataSource]="PerformanceDataSource"
          matSort
        >
          <!-- Start Time Column -->
          <ng-container matColumnDef="order">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">
                {{
                  langObj ? langObj?.ProcessOrder : ("ProcessOrder" | translate)
                }}
              </p>
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element?.ProcessOrder }}
            </td>
          </ng-container>

          <!-- End Time Column -->
          <ng-container matColumnDef="qty">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">
                {{
                  langObj
                    ? langObj?.ProducedQuantity
                    : ("ProducedQuantity" | translate)
                }}
              </p>
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element?.ProduceQty }}
            </td>
          </ng-container>

          <!-- Duration Column -->
          <ng-container matColumnDef="speed">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">
                {{
                  langObj ? langObj?.SystemSpeed : ("SystemSpeed" | translate)
                }}
              </p>
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element?.SystemSpeed }}
            </td>
          </ng-container>

          <!-- Fault Column -->
          <ng-container matColumnDef="total">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">
                {{ langObj ? langObj?.Total : ("Total" | translate) }}
                {{
                  langObj ? langObj?.ToBeProduced : ("ToBeProduced" | translate)
                }}
              </p>
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element?.TotalTBProduce }}
            </td>
          </ng-container>

          <ng-container matColumnDef="diff">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">
                {{ langObj ? langObj?.Difference : ("Difference" | translate) }}
              </p>
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element?.Difference }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="PerformanceColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: PerformanceColumns"></tr>
          <tr class="mat-row" *matNoDataRow style="text-align: center">
            <td class="mat-cell" colspan="5">
              {{ langObj ? langObj?.NoDataFound : ("NoDataFound" | translate) }}
            </td>
          </tr>
        </table>
      </div>
      <h3 style="font-size: 20px">
        {{ langObj ? langObj?.Quality : ("Quality" | translate) }}
      </h3>
      <div class="content-row-flex-both-end">
        <!--table-->
        <table
          mat-table
          class="basic-table plant-model-table"
          [dataSource]="qualityDataSource"
          matSort
        >
          <!-- Start Time Column -->
          <ng-container matColumnDef="order">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">
                {{
                  langObj ? langObj?.ProcessOrder : ("ProcessOrder" | translate)
                }}
              </p>
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element?.ProcessOrder }}
            </td>
          </ng-container>

          <!-- End Time Column -->
          <ng-container matColumnDef="production">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">
                {{ langObj ? langObj?.Total : ("Total" | translate) }}
                {{ langObj ? langObj?.Production : ("Production" | translate) }}
              </p>
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element?.TotalProduction }}
            </td>
          </ng-container>

          <!-- Duration Column -->
          <ng-container matColumnDef="waste">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">
                {{
                  langObj
                    ? langObj?.WasteRecorded
                    : ("WasteRecorded" | translate)
                }}
              </p>
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element?.WasteRecorded }}
            </td>
          </ng-container>

          <!-- Fault Column -->
          <ng-container matColumnDef="pieces">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">
                {{ langObj ? langObj?.GoodPieces : ("GoodPieces" | translate) }}
              </p>
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element?.GoodPieces }}
            </td>
          </ng-container>

          <ng-container matColumnDef="calculation">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">
                {{
                  langObj
                    ? langObj?.AsPerCalculation
                    : ("AsPerCalculation" | translate)
                }}
              </p>
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element?.AsPercalculation }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="qualityColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: qualityColumns"></tr>
          <tr class="mat-row" *matNoDataRow style="text-align: center">
            <td class="mat-cell" colspan="5">
              {{ langObj ? langObj?.NoDataFound : ("NoDataFound" | translate) }}
            </td>
          </tr>
        </table>
      </div>
      <h3 style="font-size: 20px">
        {{ langObj ? langObj?.Validation : ("Validation" | translate) }}
      </h3>
      <div class="content-row-flex-both-end">
        <!--table-->
        <table
          [dataSource]="shiftDataSource"
          mat-table
          class="basic-table plant-model-table"
          matSort
        >
          <!-- Start Time Column -->
          <ng-container matColumnDef="sno">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">S.No</p>
            </th>
            <td mat-cell *matCellDef="let element; let i=index">{{i+1}}</td>
          </ng-container>

          <!-- End Time Column -->
          <ng-container matColumnDef="validation">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">
                {{ langObj ? langObj?.Validation : ("Validation" | translate) }}
              </p>
            </th>
            <td mat-cell *matCellDef="let element">{{element.KpiName}}</td>
          </ng-container>

          <!-- Duration Column -->
          <ng-container matColumnDef="values">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">
                {{ langObj ? langObj?.Values : ("Values" | translate) }}
              </p>
            </th>
            <td mat-cell *matCellDef="let element"> <mat-form-field
              class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            > <input (change)="validationChange($event, element)"
              matInput
              [(ngModel)]="ManPower"
              type="number"
              min="1"
              step="1"
              name="ManPower"
            /></mat-form-field></td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="shiftColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: shiftColumns"></tr>
          <tr class="mat-row" *matNoDataRow style="text-align: center">
            <td class="mat-cell" colspan="3">
              {{ langObj ? langObj?.NoDataFound : ("NoDataFound" | translate) }}
            </td>
          </tr>
        </table>
      </div>
      <mat-paginator
        class="basic-paginataor"
        [pageSizeOptions]="[2, 5, 10, 20]"
        showFirstLastButtons
      >
      </mat-paginator>
      <div style="display: flex; justify-content: flex-end">
        <div>
          <button class="add-btn2">
            <img
              src="assets/images/add.png"
              alt=""
              width="20px"
              height="20px"
              (click)="shAdd()"
            />
          </button>
        </div>
      </div>
      <h3 style="font-size: 20px">
        {{ langObj ? langObj?.Action : ("Action" | translate) }}
      </h3>
      <div class="content-row-flex-both-end">
        <table
          mat-table
          class="basic-table plant-model-table"
          [dataSource]="shiftactionDataSource"
          matSort
        >
          <!-- Start Time Column -->
          <ng-container matColumnDef="sno">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">S.No</p>
            </th>
            <td mat-cell *matCellDef="let element">{{ element.sno }}</td>
          </ng-container>

          <!-- End Time Column -->
          <ng-container matColumnDef="item">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">
                {{ langObj ? langObj?.Action : ("Action" | translate) }}
                {{ langObj ? langObj?.Item : ("Item" | translate) }}
              </p>
            </th>
            <td mat-cell *matCellDef="let element">
              <textarea
                matInput
                cols="40"
                [placeholder]="
                  langObj
                    ? langObj?.ItMakesMeFeel
                    : ('ItMakesMeFeel' | translate)
                "
                (change)="shiftCloseChange($event, element)"
                style="border: 1px solid #ddd3d0; border-radius: 6px"
              >
 {{ element.item }}</textarea
              >
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="shiftactionColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: shiftactionColumns"></tr>
        </table>
      </div>
      <mat-paginator
        class="basic-paginataor"
        [pageSizeOptions]="[2, 5, 10, 20]"
        showFirstLastButtons
      >
      </mat-paginator>
    </mat-dialog-content>
    <div mat-dialog-actions style="float: right">
      <button
        class="add-btn2"
        [pTooltip]="langObj ? langObj?.Save : ('Save' | translate)"
        tooltipPosition="top"
      >
        <img
          src="assets/images/save.png"
          alt=""
          width="20px"
          height="20px"
          (click)="SumbitShiftClose(ManPower)"
        />
      </button>
    </div>
  </ng-template>

  <!-- Batch Checklist Modal -->
  <ng-template #batchchecklist1RoleModal *ngIf="machineSelectProperty">
    <div mat-dialog-title>
      <div class="d-flex justify-content-between align-items-center">
        <h2>
          {{ langObj ? langObj?.Batch : ("Batch" | translate) }}
          {{ langObj ? langObj?.Checklist : ("Checklist" | translate) }}
        </h2>
        <button
          mat-mini-fab
          mat-button
          mat-dialog-close
          color="warn"
          title="close"
        >
          <i class="fa fa-times" style="color: #fff"></i>
        </button>
      </div>
    </div>
    <mat-dialog-content>
      <div class="content-row-flex-both-end">
        <!--table-->
        <table mat-table class="basic-table plant-model-table" matSort>
          <!-- Start Time Column -->
          <ng-container matColumnDef="checklist">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">
                {{ langObj ? langObj?.Checklist : ("Checklist" | translate) }}
              </p>
            </th>
            <td mat-cell *matCellDef="let element"></td>
          </ng-container>

          <!-- Duration Column -->
          <ng-container matColumnDef="values">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">
                {{ langObj ? langObj?.Values : ("Values" | translate) }}
              </p>
            </th>
            <td mat-cell *matCellDef="let element">
              <input type="checkbox" color="primary" />
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="batchChecklist1Columns"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: batchChecklist1Columns"
          ></tr>
        </table>
      </div>
      <mat-paginator
        class="basic-paginataor"
        [pageSizeOptions]="[5, 10, 20]"
        showFirstLastButtons
      >
      </mat-paginator>
    </mat-dialog-content>
    <div mat-dialog-actions style="float: right">
      <button type="submit" color="accent" mat-flat-button cdkFocusInitial>
        {{ langObj ? langObj?.Save : ("Save" | translate) }} &
        {{ langObj ? langObj?.Close : ("Close" | translate) }}
      </button>
    </div>
  </ng-template>

  <!-- Batch Checklist Modal only for show -->
  <ng-template
    #batchchecklistOnlyForShowRoleModal
    *ngIf="machineSelectProperty"
  >
    <div mat-dialog-title>
      <div class="d-flex justify-content-between align-items-center">
        <h2>
          {{ langObj ? langObj?.Batch : ("Batch" | translate) }}
          {{ langObj ? langObj?.Checklist : ("Checklist" | translate) }}
        </h2>
        <button
          mat-mini-fab
          mat-button
          mat-dialog-close
          color="warn"
          title="close"
        >
          <i class="fa fa-times" style="color: #fff"></i>
        </button>
      </div>
    </div>
    <mat-dialog-content>
      <div class="content-row-flex-both-end">
        <!--table-->
        <table
          [dataSource]="onlyShowCheckListDataSource"
          mat-table
          class="basic-table plant-model-table"
          matSort
        >
          <!-- Start Time Column -->
          <ng-container matColumnDef="checklist">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">
                {{ langObj ? langObj?.Checklist : ("Checklist" | translate) }}
              </p>
            </th>
            <td mat-cell *matCellDef="let element">{{ element?.Name }}</td>
          </ng-container>

          <ng-container matColumnDef="values">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">
                {{ langObj ? langObj?.Values : ("Values" | translate) }}
              </p>
            </th>
            <td mat-cell *matCellDef="let element">
              <input
                *ngIf="
                  element.DataType === 'bool' &&
                  element.BatchCheckListValue === 'true'
                "
                [checked]="true"
                type="checkbox"
                (change)="
                  checkListFunction(element.BatchCheckListTypeId, $event)
                "
                color="primary"
              />
              <input
                *ngIf="
                  element.DataType === 'bool' &&
                  element.BatchCheckListValue !== 'true'
                "
                type="checkbox"
                (change)="
                  checkListFunction(element.BatchCheckListTypeId, $event)
                "
                color="primary"
              />
              <input
                *ngIf="element.DataType === 'string'"
                type="text"
                [value]="element.BatchCheckListValue"
                (change)="
                  checkListFunction(element.BatchCheckListTypeId, $event)
                "
              />
              <input
                *ngIf="element.DataType === 'number'"
                type="number"
                [value]="element.BatchCheckListValue"
                (change)="
                  checkListFunction(element.BatchCheckListTypeId, $event)
                "
              />
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="batchChecklistOnlyForShowColumns"
          ></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: batchChecklistOnlyForShowColumns"
          ></tr>
        </table>
      </div>
      <mat-paginator
        class="basic-paginataor"
        [pageSizeOptions]="[5, 10, 20]"
        showFirstLastButtons
      >
      </mat-paginator>
    </mat-dialog-content>
  </ng-template>

  <!--side bar modal code-->
  <div
    class="sidepanel-model-wrapper edit-plant-row-model"
    [ngClass]="{ active: displayUserModal }"
  >
    <div class="sidepanel-close" (click)="closeaddNewPlantItemModel()"></div>
    <div class="model-content">
      <div class="model-top">
        <h2 class="model-title">
          {{ langObj ? langObj?.Group : ("Group" | translate) }}
          {{ langObj ? langObj?.Structure : ("Structure" | translate) }}
        </h2>
        <button
          mat-icon-button
          class="model-close-btn"
          aria-label="Close model"
          (click)="closeaddNewPlantItemModel()"
        >
          <svg
            width="14"
            height="12"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.46 7L14 12.54V14H12.54L7 8.46L1.46 14H0V12.54L5.54 7L0 1.46V0H1.46L7 5.54L12.54 0H14V1.46L8.46 7Z"
              fill="black"
            />
          </svg>
        </button>
      </div>
    </div>
  </div>
  <!-- </div> -->

  <!-- plant group view model -->
  <div
    class="sidepanel-model-wrapper open-plant-group-model"
    [ngClass]="{ active: updateOrderprocessingData }"
    style="z-index: 10000"
  >
    <div class="sidepanel-close" (click)="closePlantGroupModel()"></div>
    <div class="model-content">
      <div class="model-top">
        <h2 class="model-title">
          {{ langObj ? langObj?.Group : ("Group" | translate) }}
          {{ langObj ? langObj?.Structure : ("Structure" | translate) }}
        </h2>
        <button
          mat-icon-button
          class="model-close-btn"
          aria-label="Close model"
          (click)="closePlantGroupModel()"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.46 7L14 12.54V14H12.54L7 8.46L1.46 14H0V12.54L5.54 7L0 1.46V0H1.46L7 5.54L12.54 0H14V1.46L8.46 7Z"
              fill="black"
            />
          </svg>
        </button>
      </div>
      <div class="model-body">
        <div class="tree-controls">
          <button
            mat-flat-button
            class="btn-tree-control"
            (click)="collapseAllNode()"
          >
            <div class="icon">
              <svg
                width="29"
                height="29"
                viewBox="0 0 29 29"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.5 1.1547C13.7376 0.440169 15.2624 0.440169 16.5 1.1547L25.0574 6.0953C26.295 6.80983 27.0574 8.13034 27.0574 9.5594V19.4406C27.0574 20.8697 26.295 22.1902 25.0574 22.9047L16.5 27.8453C15.2624 28.5598 13.7376 28.5598 12.5 27.8453L3.94263 22.9047C2.70503 22.1902 1.94263 20.8697 1.94263 19.4406V9.5594C1.94263 8.13034 2.70503 6.80983 3.94263 6.0953L12.5 1.1547Z"
                  fill="#824AED"
                />
                <g clip-path="url(#clip0)">
                  <path
                    d="M14.0118 14.9844C13.933 14.897 13.8218 14.8399 13.6947 14.8395L10.1018 14.8345C9.86386 14.8341 9.67135 15.0265 9.67177 15.2645C9.67218 15.5024 9.94967 15.7699 10.0688 15.889L10.9776 16.7978L8.33301 19.417L9.58301 20.667L12.1888 18.0095L13.0976 18.9182C13.2942 19.1149 13.4938 19.3241 13.7317 19.3244C13.9697 19.3249 14.1622 19.1324 14.1617 18.8945L14.1568 15.3015C14.1563 15.1745 14.0993 15.0632 14.0118 14.9844ZM19.0763 11.1565L21.6663 8.58362L20.4163 7.33362L17.8442 9.91654L16.9201 8.98654C16.7201 8.78527 16.5172 8.57111 16.2755 8.5707C16.0334 8.57028 15.838 8.76737 15.838 9.0107L15.843 12.6882C15.843 12.8182 15.9013 12.9319 15.9905 13.0128C16.0709 13.1024 16.1838 13.1607 16.313 13.1611L19.9672 13.1661C20.2088 13.1665 20.4047 12.9694 20.4047 12.7261C20.4043 12.4828 20.1222 12.2086 20.0009 12.0869L19.0763 11.1565Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect
                      width="13.3333"
                      height="13.3333"
                      fill="white"
                      transform="translate(8.33301 7.33362)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <p class="btn-text">
              {{ langObj ? langObj?.CollapseAll : ("CollapseAll" | translate) }}
            </p>
          </button>
          <button
            mat-flat-button
            class="btn-tree-control"
            (click)="expandAllNode()"
          >
            <div class="icon">
              <svg
                width="29"
                height="29"
                viewBox="0 0 29 29"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.5 1.1547C13.7376 0.440169 15.2624 0.440169 16.5 1.1547L25.0574 6.0953C26.295 6.80983 27.0574 8.13034 27.0574 9.5594V19.4406C27.0574 20.8697 26.295 22.1902 25.0574 22.9047L16.5 27.8453C15.2624 28.5598 13.7376 28.5598 12.5 27.8453L3.94263 22.9047C2.70503 22.1902 1.94263 20.8697 1.94263 19.4406V9.5594C1.94263 8.13034 2.70503 6.80983 3.94263 6.0953L12.5 1.1547Z"
                  fill="#3AAFE4"
                />
                <g clip-path="url(#clip0)">
                  <path
                    d="M17.0932 8.50018L18.2178 9.62477L15.5086 12.3336C15.3561 12.4861 15.356 12.7333 15.5086 12.886L16.6138 13.9911C16.7666 14.1439 17.0143 14.1433 17.1665 13.9911L19.875 11.2819L20.9996 12.4065C21.2446 12.6515 21.6664 12.4783 21.6664 12.1303V8.22404C21.6664 8.00812 21.4916 7.83341 21.2757 7.83341H17.3695C17.0231 7.83341 16.8472 8.25336 17.0932 8.50018Z"
                    fill="white"
                  />
                  <path
                    d="M12.8332 15.0093L10.1244 17.7185L8.9998 16.5939C8.7548 16.3489 8.33301 16.522 8.33301 16.8701V20.7763C8.33301 20.9922 8.50772 21.1669 8.72363 21.1669H12.6299C12.9754 21.1669 13.1531 20.748 12.9061 20.5001L11.7819 19.3752L14.4907 16.6667C14.6432 16.5142 14.6433 16.267 14.4907 16.1144L13.3856 15.0093C13.2337 14.8574 12.9863 14.8562 12.8332 15.0093Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect
                      width="13.3333"
                      height="13.3333"
                      fill="white"
                      transform="translate(8.33301 21.1669) rotate(-90)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <p class="btn-text">
              {{ langObj ? langObj?.ExpandAll : ("ExpandAll" | translate) }}
            </p>
          </button>
        </div>
        <mat-tree
          #treeSelector
          class="basic-tree-structure"
          [dataSource]="plantGroupSource"
          [treeControl]="treeControl"
          [dir]="languageDir === 'rtl' ? 'ltr' : ''"
        >
          <mat-tree-node
            *matTreeNodeDef="let node"
            class="child-node"
            matTreeNodePadding
          >
            <!-- (click)="SelectUnitName(node)" -->
            <li class="tree-node">
              <div class="tree-content">
                <button
                  mat-icon-button
                  disabled
                  class="child-space-elem"
                ></button>
                <div class="node-icon">
                  <div [ngSwitch]="node.Level">
                    <div *ngSwitchCase="'Group'">
                      <svg
                        width="29"
                        height="29"
                        viewBox="0 0 29 29"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.5 1.1547C13.7376 0.440169 15.2624 0.440169 16.5 1.1547L25.0574 6.0953C26.295 6.80983 27.0574 8.13034 27.0574 9.5594V19.4406C27.0574 20.8697 26.295 22.1902 25.0574 22.9047L16.5 27.8453C15.2624 28.5598 13.7376 28.5598 12.5 27.8453L3.94263 22.9047C2.70503 22.1902 1.94263 20.8697 1.94263 19.4406V9.5594C1.94263 8.13034 2.70503 6.80983 3.94263 6.0953L12.5 1.1547Z"
                          fill="#10CE9C"
                        />
                        <path
                          d="M10.0101 9.89258H9.24838V11.6056H8V20.1187H11.2585V11.6056H10.0101V9.89258ZM10.2166 18.2144H9.04188V17.4526H10.2166V18.2144H10.2166ZM10.2166 16.6909H9.04188V15.9292H10.2166V16.6909H10.2166ZM10.2166 15.1675H9.04188V14.4058H10.2166V15.1675H10.2166ZM10.2166 12.8823V13.644H9.04188V12.8823H10.2166Z"
                          fill="white"
                        />
                        <path
                          d="M19.7516 11.6056V9.89258H18.9899V11.6056H17.7415V20.1187H21V11.6056H19.7516ZM19.9581 18.2144H18.7834V17.4526H19.9581V18.2144ZM19.9581 16.6909H18.7834V15.9292H19.9581V16.6909ZM19.9581 15.1675H18.7834V14.4058H19.9581V15.1675ZM19.9581 13.644H18.7834V12.8823H19.9581V13.644Z"
                          fill="white"
                        />
                        <path
                          d="M14.1191 18.9761H14.8809V20.1187H14.1191V18.9761Z"
                          fill="white"
                        />
                        <path
                          d="M12.0202 20.1188H13.3574V18.2145H15.6426V20.1188H16.9798V8.88037L12.0202 10.0472V20.1188ZM14.8809 11.359H16.0556V12.1207H14.8809V11.359ZM14.8809 12.8824H16.0556V13.6442H14.8809V12.8824ZM14.8809 14.4059H16.0556V15.1676H14.8809V14.4059ZM14.8809 15.9293H16.0556V16.691H14.8809V15.9293ZM12.9444 11.359H14.1191V12.1207H12.9444V11.359ZM12.9444 12.8824H14.1191V13.6442H12.9444V12.8824ZM12.9444 14.4059H14.1191V15.1676H12.9444V14.4059ZM12.9444 15.9293H14.1191V16.691H12.9444V15.9293Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div *ngSwitchCase="'Plant'">
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.4294 5.95006C12.2382 5.84766 12.0093 5.85872 11.8283 5.97955L8.66719 8.08926V6.46996C8.66719 6.2527 8.5455 6.05302 8.35405 5.95062C8.16259 5.84823 7.92944 5.85958 7.7482 5.98012L4.4977 8.14655V3.60834C4.4977 3.48779 4.40523 3.38086 4.28497 3.38086H0.480813C0.360551 3.38086 0.262695 3.48779 0.262695 3.60834V12.7829C0.262695 12.9032 0.360551 12.9996 0.480813 12.9996H12.525C12.6452 12.9996 12.738 12.9032 12.738 12.7829V6.46911C12.7382 6.25213 12.6214 6.05245 12.4294 5.95006ZM7.28842 10.2858C7.28842 10.3706 7.21978 10.4392 7.1344 10.4392H6.06367C5.97858 10.4392 5.90994 10.3706 5.90994 10.2858V9.21417C5.90994 9.12907 5.97858 9.06043 6.06367 9.06043H7.1344C7.21978 9.06043 7.28842 9.12907 7.28842 9.21417V10.2858ZM11.2931 10.2858C11.2931 10.3706 11.225 10.4392 11.1397 10.4392H10.0686C9.98355 10.4392 9.91491 10.3706 9.91491 10.2858V9.21417C9.91491 9.12907 9.98355 9.06043 10.0686 9.06043H11.1397C11.225 9.06043 11.2931 9.12907 11.2931 9.21417V10.2858Z"
                          fill="white"
                        />
                        <path
                          d="M0.481506 2.52779H4.28567C4.40593 2.52779 4.49839 2.44496 4.49839 2.3247V0.587699C4.49839 0.262366 4.24 0 3.91438 0H0.852789C0.527456 0 0.263672 0.262366 0.263672 0.587699V2.32498C0.263672 2.44496 0.361527 2.52779 0.481506 2.52779Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div *ngSwitchCase="'Division'">
                      <svg
                        width="27"
                        height="27"
                        viewBox="0 0 27 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.5 1.1547C12.7376 0.440169 14.2624 0.440169 15.5 1.1547L23.1913 5.5953C24.4289 6.30983 25.1913 7.63034 25.1913 9.0594V17.9406C25.1913 19.3697 24.4289 20.6902 23.1913 21.4047L15.5 25.8453C14.2624 26.5598 12.7376 26.5598 11.5 25.8453L3.80866 21.4047C2.57105 20.6902 1.80866 19.3697 1.80866 17.9406V9.0594C1.80866 7.63034 2.57105 6.30983 3.80866 5.5953L11.5 1.1547Z"
                          fill="#10CE9C"
                        />
                        <g clip-path="url(#clip0)">
                          <path
                            d="M12.1428 9.63622H12.5934V10.0868H12.1428V9.63622Z"
                            fill="white"
                          />
                          <path
                            d="M12.1428 11.4387H12.5934V11.8893H12.1428V11.4387Z"
                            fill="white"
                          />
                          <path
                            d="M12.1428 13.2408H12.5934V13.6914H12.1428V13.2408Z"
                            fill="white"
                          />
                          <path
                            d="M9.88936 15.0433H10.34V15.4939H9.88936V15.0433Z"
                            fill="white"
                          />
                          <path
                            d="M17.5496 11.8893H18.0002V12.34H17.5496V11.8893Z"
                            fill="white"
                          />
                          <path
                            d="M9.88936 13.2408H10.34V13.6914H9.88936V13.2408Z"
                            fill="white"
                          />
                          <path
                            d="M9.88936 9.63622H10.34V10.0868H9.88936V9.63622Z"
                            fill="white"
                          />
                          <path
                            d="M12.1428 15.0433H12.5934V15.4939H12.1428V15.0433Z"
                            fill="white"
                          />
                          <path
                            d="M9.88936 11.4387H10.34V11.8893H9.88936V11.4387Z"
                            fill="white"
                          />
                          <path
                            d="M15.7473 13.6917H16.1979V14.1423H15.7473V13.6917Z"
                            fill="white"
                          />
                          <path
                            d="M17.5496 13.6917H18.0002V14.1423H17.5496V13.6917Z"
                            fill="white"
                          />
                          <path
                            d="M17.5496 15.4939H18.0002V15.9445H17.5496V15.4939Z"
                            fill="white"
                          />
                          <path
                            d="M15.7473 11.8893H16.1979V12.34H15.7473V11.8893Z"
                            fill="white"
                          />
                          <path
                            d="M15.7473 15.4939H16.1979V15.9445H15.7473V15.4939Z"
                            fill="white"
                          />
                          <path
                            d="M9.66408 17.2964H11.0159V19.0988H9.66408V17.2964Z"
                            fill="white"
                          />
                          <path
                            d="M11.4664 17.2964H12.8183V19.0988H11.4664V17.2964Z"
                            fill="white"
                          />
                          <path
                            d="M16.1984 17.7474H17.5502V19.0992H16.1984V17.7474Z"
                            fill="white"
                          />
                          <path
                            d="M18.9018 19.5494V11.1638L14.8464 10.15V19.5494H14.3958V8.68251L8.08727 7V19.5494H7.41136V20H19.5777V19.5494H18.9018ZM11.6921 9.41079C11.6921 9.28637 11.793 9.18549 11.9174 9.18549H12.8186C12.9431 9.18549 13.0439 9.28637 13.0439 9.41079V10.312C13.0439 10.4364 12.9431 10.5373 12.8186 10.5373H11.9174C11.793 10.5373 11.6921 10.4364 11.6921 10.312V9.41079ZM11.6921 11.2132C11.6921 11.0888 11.793 10.9879 11.9174 10.9879H12.8186C12.9431 10.9879 13.0439 11.0888 13.0439 11.2132V12.1144C13.0439 12.2389 12.9431 12.3397 12.8186 12.3397H11.9174C11.793 12.3397 11.6921 12.2389 11.6921 12.1144V11.2132ZM11.6921 13.0156C11.6921 12.8912 11.793 12.7903 11.9174 12.7903H12.8186C12.9431 12.7903 13.0439 12.8912 13.0439 13.0156V13.9169C13.0439 14.0413 12.9431 14.1422 12.8186 14.1422H11.9174C11.793 14.1422 11.6921 14.0413 11.6921 13.9169V13.0156ZM11.6921 14.8181C11.6921 14.6936 11.793 14.5928 11.9174 14.5928H12.8186C12.9431 14.5928 13.0439 14.6936 13.0439 14.8181V15.7193C13.0439 15.8437 12.9431 15.9446 12.8186 15.9446H11.9174C11.793 15.9446 11.6921 15.8437 11.6921 15.7193V14.8181ZM9.43909 9.41079C9.43909 9.28637 9.53997 9.18549 9.66439 9.18549H10.5656C10.69 9.18549 10.7909 9.28637 10.7909 9.41079V10.312C10.7909 10.4364 10.69 10.5373 10.5656 10.5373H9.66439C9.53997 10.5373 9.43909 10.4364 9.43909 10.312V9.41079ZM9.43909 11.2132C9.43909 11.0888 9.53997 10.9879 9.66439 10.9879H10.5656C10.69 10.9879 10.7909 11.0888 10.7909 11.2132V12.1144C10.7909 12.2389 10.69 12.3397 10.5656 12.3397H9.66439C9.53997 12.3397 9.43909 12.2389 9.43909 12.1144V11.2132ZM9.43909 13.0156C9.43909 12.8912 9.53997 12.7903 9.66439 12.7903H10.5656C10.69 12.7903 10.7909 12.8912 10.7909 13.0156V13.9169C10.7909 14.0413 10.69 14.1422 10.5656 14.1422H9.66439C9.53997 14.1422 9.43909 14.0413 9.43909 13.9169V13.0156ZM9.43909 14.8181C9.43909 14.6936 9.53997 14.5928 9.66439 14.5928H10.5656C10.69 14.5928 10.7909 14.6936 10.7909 14.8181V15.7193C10.7909 15.8437 10.69 15.9446 10.5656 15.9446H9.66439C9.53997 15.9446 9.43909 15.8437 9.43909 15.7193V14.8181ZM13.2692 19.0988V19.5494H9.21379V17.0711C9.21379 16.9467 9.31467 16.8458 9.43909 16.8458H13.0439C13.1684 16.8458 13.2692 16.9467 13.2692 17.0711V19.0988ZM15.297 11.6638C15.297 11.5394 15.3979 11.4385 15.5223 11.4385H16.4235C16.5479 11.4385 16.6488 11.5394 16.6488 11.6638V12.565C16.6488 12.6895 16.5479 12.7903 16.4235 12.7903H15.5223C15.3979 12.7903 15.297 12.6895 15.297 12.565V11.6638ZM15.297 13.4662C15.297 13.3418 15.3979 13.2409 15.5223 13.2409H16.4235C16.5479 13.2409 16.6488 13.3418 16.6488 13.4662V14.3675C16.6488 14.4919 16.5479 14.5928 16.4235 14.5928H15.5223C15.3979 14.5928 15.297 14.4919 15.297 14.3675V13.4662ZM15.297 16.1699V15.2687C15.297 15.1443 15.3979 15.0434 15.5223 15.0434H16.4235C16.5479 15.0434 16.6488 15.1443 16.6488 15.2687V16.1699C16.6488 16.2943 16.5479 16.3952 16.4235 16.3952H15.5223C15.3979 16.3952 15.297 16.2943 15.297 16.1699ZM18.0006 19.5494H15.7476V17.5217C15.7476 17.3973 15.8485 17.2964 15.9729 17.2964H17.7753C17.8997 17.2964 18.0006 17.3973 18.0006 17.5217V19.5494ZM18.4512 16.1699C18.4512 16.2943 18.3503 16.3952 18.2259 16.3952H17.3247C17.2003 16.3952 17.0994 16.2943 17.0994 16.1699V15.2687C17.0994 15.1443 17.2003 15.0434 17.3247 15.0434H18.2259C18.3503 15.0434 18.4512 15.1443 18.4512 15.2687V16.1699ZM18.4512 14.3675C18.4512 14.4919 18.3503 14.5928 18.2259 14.5928H17.3247C17.2003 14.5928 17.0994 14.4919 17.0994 14.3675V13.4662C17.0994 13.3418 17.2003 13.2409 17.3247 13.2409H18.2259C18.3503 13.2409 18.4512 13.3418 18.4512 13.4662V14.3675ZM18.4512 12.565C18.4512 12.6895 18.3503 12.7903 18.2259 12.7903H17.3247C17.2003 12.7903 17.0994 12.6895 17.0994 12.565V11.6638C17.0994 11.5394 17.2003 11.4385 17.3247 11.4385H18.2259C18.3503 11.4385 18.4512 11.5394 18.4512 11.6638V12.565Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0">
                            <rect
                              width="13"
                              height="13"
                              fill="white"
                              transform="translate(7 7)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div *ngSwitchCase="'Department'">
                      <svg
                        width="27"
                        height="27"
                        viewBox="0 0 27 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.5 1.1547C12.7376 0.440169 14.2624 0.440169 15.5 1.1547L23.1913 5.5953C24.4289 6.30983 25.1913 7.63034 25.1913 9.0594V17.9406C25.1913 19.3697 24.4289 20.6902 23.1913 21.4047L15.5 25.8453C14.2624 26.5598 12.7376 26.5598 11.5 25.8453L3.80866 21.4047C2.57105 20.6902 1.80866 19.3697 1.80866 17.9406V9.0594C1.80866 7.63034 2.57105 6.30983 3.80866 5.5953L11.5 1.1547Z"
                          fill="#10CE9C"
                        />
                        <path
                          d="M14.7465 15.7852H12.2533C11.8885 15.7852 11.5918 16.0813 11.5918 16.4453V20H15.408V16.4453C15.408 16.0813 15.1113 15.7852 14.7465 15.7852Z"
                          fill="white"
                        />
                        <path
                          d="M18.5805 16.9531H16.8408C16.4728 16.9531 16.1735 17.2493 16.1735 17.6133C16.1735 19.73 16.1746 19.6035 16.1714 19.6336V20H19.2478V17.6133C19.2478 17.2493 18.9483 16.9531 18.5805 16.9531Z"
                          fill="white"
                        />
                        <path
                          d="M20 10.0723V8.39648C20 7.62643 19.3736 7 18.6037 7H8.39629C7.62643 7 7 7.62643 7 8.39648V10.0723H20ZM18.0697 8.54883C18.2801 8.54883 18.4506 8.71932 18.4506 8.92969C18.4506 9.14005 18.2801 9.31055 18.0697 9.31055C17.8595 9.31055 17.689 9.14005 17.689 8.92969C17.689 8.71932 17.8595 8.54883 18.0697 8.54883ZM16.5465 8.54883C16.7567 8.54883 16.9272 8.71932 16.9272 8.92969C16.9272 9.14005 16.7567 9.31055 16.5465 9.31055C16.3361 9.31055 16.1656 9.14005 16.1656 8.92969C16.1656 8.71932 16.3361 8.54883 16.5465 8.54883ZM15.0232 8.54883C15.2335 8.54883 15.404 8.71932 15.404 8.92969C15.404 9.14005 15.2335 9.31055 15.0232 9.31055C14.813 9.31055 14.6424 9.14005 14.6424 8.92969C14.6424 8.71932 14.813 8.54883 15.0232 8.54883Z"
                          fill="white"
                        />
                        <path
                          d="M9.30206 14.668C9.0916 14.668 8.92041 14.8389 8.92041 15.0488C8.92041 15.2588 9.0916 15.4297 9.30206 15.4297C9.51243 15.4297 9.68362 15.2588 9.68362 15.0488C9.68362 14.8389 9.51243 14.668 9.30206 14.668Z"
                          fill="white"
                        />
                        <path
                          d="M10.16 16.9531H8.41859C8.05003 16.9531 7.7502 17.2493 7.7502 17.6133V20H10.8284C10.8284 19.3434 10.8284 17.7141 10.8284 17.6133C10.8284 17.2493 10.5286 16.9531 10.16 16.9531Z"
                          fill="white"
                        />
                        <path
                          d="M17.7235 14.668C17.513 14.668 17.3418 14.8389 17.3418 15.0488C17.3418 15.2588 17.513 15.4297 17.7235 15.4297C17.9339 15.4297 18.1051 15.2588 18.1051 15.0488C18.1051 14.8389 17.9339 14.668 17.7235 14.668Z"
                          fill="white"
                        />
                        <path
                          d="M7 10.834V17.4261C7.09254 16.7303 7.69338 16.1914 8.4188 16.1914H9.30212C8.67082 16.1914 8.15726 15.6788 8.15726 15.0488C8.15726 14.4188 8.67082 13.9062 9.30212 13.9062C9.93341 13.9062 10.447 14.4188 10.447 15.0488C10.447 15.6788 9.93341 16.1914 9.30212 16.1914C10.1967 16.1914 10.4401 16.1505 10.8316 16.3579C10.877 15.6145 11.4972 15.0234 12.2534 15.0234H13.5127C12.7763 15.0234 12.177 14.4255 12.177 13.6904C12.177 12.9554 12.7763 12.3574 13.5127 12.3574C14.2492 12.3574 14.8484 12.9554 14.8484 13.6904C14.8484 14.4255 14.2492 15.0234 13.5127 15.0234H14.7466C15.5031 15.0234 16.1234 15.6149 16.1685 16.3587C16.5548 16.1533 16.7837 16.1914 17.7233 16.1914C17.092 16.1914 16.5784 15.6788 16.5784 15.0488C16.5784 14.4188 17.092 13.9062 17.7233 13.9062C18.3546 13.9062 18.8681 14.4188 18.8681 15.0488C18.8681 15.6788 18.3546 16.1914 17.7233 16.1914H18.5804C19.3104 16.1914 19.914 16.7378 20 17.4407V10.834H7Z"
                          fill="white"
                        />
                        <path
                          d="M13.5127 13.1191C13.1971 13.1191 12.9403 13.3754 12.9403 13.6904C12.9403 14.0054 13.1971 14.2617 13.5127 14.2617C13.8284 14.2617 14.0852 14.0054 14.0852 13.6904C14.0852 13.3754 13.8284 13.1191 13.5127 13.1191Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div *ngSwitchCase="'Line'">
                      <svg
                        width="27"
                        height="27"
                        viewBox="0 0 27 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.5 1.1547C12.7376 0.440169 14.2624 0.440169 15.5 1.1547L23.1913 5.5953C24.4289 6.30983 25.1913 7.63034 25.1913 9.0594V17.9406C25.1913 19.3697 24.4289 20.6902 23.1913 21.4047L15.5 25.8453C14.2624 26.5598 12.7376 26.5598 11.5 25.8453L3.80866 21.4047C2.57105 20.6902 1.80866 19.3697 1.80866 17.9406V9.0594C1.80866 7.63034 2.57105 6.30983 3.80866 5.5953L11.5 1.1547Z"
                          fill="#10CE9C"
                        />
                        <path
                          d="M16.0955 8.92341H15.5502C15.498 8.81308 15.4372 8.70761 15.3682 8.60752L15.6406 8.13559C15.7302 7.9804 15.6771 7.78197 15.5219 7.69239L14.398 7.04354C14.3235 7.0005 14.2349 6.98887 14.1518 7.01111C14.0687 7.0334 13.9979 7.08777 13.9548 7.16229L13.6828 7.63346C13.56 7.62303 13.44 7.62303 13.3172 7.63346L13.0452 7.16229C13.0021 7.08777 12.9313 7.0334 12.8482 7.01111C12.7651 6.98887 12.6765 7.0005 12.602 7.04354L11.4781 7.69242C11.3229 7.782 11.2698 7.98042 11.3594 8.13561L11.6318 8.60757C11.5628 8.70764 11.502 8.81314 11.4498 8.92343H10.9045C10.7253 8.92343 10.5801 9.06869 10.5801 9.24787V10.5456C10.5801 10.7248 10.7253 10.8701 10.9045 10.8701H11.4498C11.502 10.9803 11.5628 11.0858 11.6318 11.1859L11.3594 11.6579C11.2698 11.813 11.3229 12.0115 11.4781 12.101L12.602 12.7499C12.6765 12.793 12.765 12.8046 12.8482 12.7824C12.9313 12.7601 13.0021 12.7057 13.0452 12.6312L13.3172 12.1599C13.44 12.1704 13.56 12.1704 13.6828 12.1599L13.9548 12.6311C13.9979 12.7056 14.0687 12.76 14.1518 12.7823C14.1795 12.7897 14.2077 12.7933 14.2358 12.7933C14.2923 12.7933 14.3483 12.7786 14.398 12.7499L15.5219 12.101C15.6771 12.0114 15.7303 11.813 15.6407 11.6578L15.3682 11.1859C15.4373 11.0858 15.498 10.9803 15.5502 10.87H16.0955C16.2747 10.87 16.4199 10.7247 16.4199 10.5456V10.2211V9.57224V9.24785C16.4199 9.06867 16.2747 8.92341 16.0955 8.92341ZM13.5 10.8489C12.9749 10.8489 12.5479 10.4218 12.5479 9.89671C12.5479 9.37165 12.9749 8.94456 13.5 8.94456C14.0251 8.94456 14.4521 9.37165 14.4521 9.89671C14.4521 10.4218 14.0251 10.8489 13.5 10.8489Z"
                          fill="white"
                        />
                        <path
                          d="M9.03125 11.1108V10.2774H9.81836V9.5157H8.65039C8.44005 9.5157 8.26953 9.68622 8.26953 9.89655V11.1108C7.97426 11.1802 7.70322 11.33 7.48339 11.5499C7.17167 11.8616 7 12.276 7 12.7169C7 13.1577 7.17167 13.5722 7.48339 13.8839C7.6321 14.0326 7.87326 14.0326 8.022 13.8839C8.17074 13.7352 8.17074 13.494 8.022 13.3453C7.67552 12.9988 7.67552 12.435 8.022 12.0885C8.18986 11.9206 8.41301 11.8282 8.65039 11.8282C8.88777 11.8282 9.11093 11.9206 9.27878 12.0885C9.62526 12.435 9.62526 12.9988 9.27878 13.3453C9.13004 13.494 9.13004 13.7351 9.27878 13.8839C9.35315 13.9582 9.45063 13.9954 9.54808 13.9954C9.64553 13.9954 9.74303 13.9582 9.81737 13.8839C10.1291 13.5722 10.3008 13.1577 10.3008 12.7169C10.3008 12.276 10.1291 11.8616 9.81737 11.5499C9.59756 11.33 9.32652 11.1802 9.03125 11.1108Z"
                          fill="white"
                        />
                        <path
                          d="M19.5166 11.5498C19.2968 11.33 19.0257 11.1802 18.7305 11.1107V9.89649C18.7305 9.68615 18.5599 9.51563 18.3496 9.51563H17.1816V10.2773H17.9687V11.1107C17.6735 11.1802 17.4024 11.33 17.1826 11.5498C16.8709 11.8615 16.6992 12.276 16.6992 12.7168C16.6992 13.1577 16.8709 13.5721 17.1826 13.8838C17.3313 14.0325 17.5725 14.0325 17.7212 13.8838C17.87 13.7351 17.87 13.494 17.7212 13.3452C17.3747 12.9987 17.3747 12.4349 17.7212 12.0884C17.8891 11.9206 18.1122 11.8282 18.3496 11.8282C18.587 11.8282 18.8101 11.9206 18.978 12.0884C19.3245 12.4349 19.3245 12.9987 18.978 13.3452C18.8293 13.4939 18.8293 13.7351 18.978 13.8838C19.0524 13.9582 19.1498 13.9954 19.2473 13.9954C19.3447 13.9954 19.4422 13.9582 19.5166 13.8838C19.8283 13.5721 20 13.1577 20 12.7168C20 12.276 19.8283 11.8615 19.5166 11.5498Z"
                          fill="white"
                        />
                        <path
                          d="M8.04102 20C8.60193 20 9.05664 19.5453 9.05664 18.9844C9.05664 18.4235 8.60193 17.9688 8.04102 17.9688C7.4801 17.9688 7.02539 18.4235 7.02539 18.9844C7.02539 19.5453 7.4801 20 8.04102 20Z"
                          fill="white"
                        />
                        <path
                          d="M13.5 20C14.0609 20 14.5156 19.5453 14.5156 18.9844C14.5156 18.4235 14.0609 17.9688 13.5 17.9688C12.9391 17.9688 12.4844 18.4235 12.4844 18.9844C12.4844 19.5453 12.9391 20 13.5 20Z"
                          fill="white"
                        />
                        <path
                          d="M14.9568 17.9688C15.1582 18.2569 15.2768 18.6069 15.2768 18.9844C15.2768 19.3618 15.1582 19.7119 14.9568 20H17.5012C17.2998 19.7119 17.1811 19.3618 17.1811 18.9844C17.1811 18.6069 17.2998 18.2569 17.5012 17.9688H14.9568Z"
                          fill="white"
                        />
                        <path
                          d="M9.49783 17.9688C9.69923 18.2569 9.81786 18.6069 9.81786 18.9844C9.81786 19.3618 9.69923 19.7119 9.49783 20H12.0422C11.8408 19.7119 11.7221 19.3618 11.7221 18.9844C11.7221 18.6069 11.8408 18.2569 12.0422 17.9688H9.49783Z"
                          fill="white"
                        />
                        <path
                          d="M18.959 20C19.5199 20 19.9746 19.5453 19.9746 18.9844C19.9746 18.4235 19.5199 17.9688 18.959 17.9688C18.3981 17.9688 17.9434 18.4235 17.9434 18.9844C17.9434 19.5453 18.3981 20 18.959 20Z"
                          fill="white"
                        />
                        <path
                          d="M14.4521 14.9219H12.5479C12.3375 14.9219 12.167 15.0924 12.167 15.3027V17.207H14.833V15.3027C14.833 15.0924 14.6625 14.9219 14.4521 14.9219Z"
                          fill="white"
                        />
                        <path
                          d="M10.6436 14.9219H8.73926C8.52892 14.9219 8.3584 15.0924 8.3584 15.3027V17.207H11.0244V15.3027C11.0244 15.0924 10.8539 14.9219 10.6436 14.9219Z"
                          fill="white"
                        />
                        <path
                          d="M16.3564 14.9219C16.1461 14.9219 15.9756 15.0924 15.9756 15.3027V17.207H18.6416V15.3027C18.6416 15.0924 18.4711 14.9219 18.2607 14.9219H16.3564Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div *ngSwitchCase="'Unit'">
                      <svg
                        width="27"
                        height="27"
                        viewBox="0 0 27 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.5 1.1547C12.7376 0.440169 14.2624 0.440169 15.5 1.1547L23.1913 5.5953C24.4289 6.30983 25.1913 7.63034 25.1913 9.0594V17.9406C25.1913 19.3697 24.4289 20.6902 23.1913 21.4047L15.5 25.8453C14.2624 26.5598 12.7376 26.5598 11.5 25.8453L3.80866 21.4047C2.57105 20.6902 1.80866 19.3697 1.80866 17.9406V9.0594C1.80866 7.63034 2.57105 6.30983 3.80866 5.5953L11.5 1.1547Z"
                          fill="#10CE9C"
                        />
                        <path
                          d="M7.81226 16.3438H9.43726V15.9375H9.03101V13.2908C9.15703 13.1975 9.25942 13.0759 9.32998 12.9359C9.40054 12.7958 9.43729 12.6412 9.43729 12.4844C9.43729 12.3276 9.40054 12.1729 9.32998 12.0329C9.25942 11.8928 9.15703 11.7713 9.03101 11.678V9.90469L10.1055 11.0016C10.1242 11.0209 10.1466 11.0363 10.1714 11.0468C10.1962 11.0572 10.2229 11.0626 10.2498 11.0625H10.8591C10.913 11.0625 10.9647 11.0411 11.0028 11.003C11.0409 10.9649 11.0623 10.9132 11.0623 10.8594V10.25C11.0624 10.2231 11.057 10.1964 11.0465 10.1717C11.0361 10.1469 11.0207 10.1245 11.0013 10.1058L9.42304 8.56C9.43089 8.51433 9.43564 8.46818 9.43726 8.42188C9.43726 8.15251 9.33025 7.89419 9.13979 7.70372C8.94932 7.51325 8.69099 7.40625 8.42163 7.40625C8.15227 7.40625 7.89394 7.51325 7.70348 7.70372C7.51301 7.89419 7.40601 8.15251 7.40601 8.42188C7.40619 8.57865 7.44303 8.73321 7.51356 8.87322C7.5841 9.01324 7.68638 9.13482 7.81226 9.22828V11.678C7.68624 11.7713 7.58384 11.8928 7.51328 12.0329C7.44273 12.1729 7.40598 12.3276 7.40598 12.4844C7.40598 12.6412 7.44273 12.7958 7.51328 12.9359C7.58384 13.0759 7.68624 13.1975 7.81226 13.2908V16.3438Z"
                          fill="white"
                        />
                        <path
                          d="M13.2969 9.41922V10.25H13.7031V9.41922C13.9868 9.37102 14.2443 9.22411 14.4302 9.00444C14.616 8.78477 14.7182 8.50649 14.7188 8.21875V7.60938C14.7188 7.5555 14.6973 7.50384 14.6593 7.46574C14.6212 7.42765 14.5695 7.40625 14.5156 7.40625H12.4844C12.4305 7.40625 12.3788 7.42765 12.3407 7.46574C12.3027 7.50384 12.2812 7.5555 12.2812 7.60938V8.21875C12.2818 8.50649 12.384 8.78477 12.5698 9.00444C12.7557 9.22411 13.0132 9.37102 13.2969 9.41922Z"
                          fill="white"
                        />
                        <path
                          d="M15.125 11.6455L14.7391 11.9015C14.3728 12.1477 13.9414 12.2793 13.5 12.2793C13.0586 12.2793 12.6272 12.1477 12.2609 11.9015L11.875 11.6455V14.1094H15.125V11.6455ZM13.7031 13.2969H13.2969V12.8907H13.7031V13.2969Z"
                          fill="white"
                        />
                        <path
                          d="M9.84375 16.3438H17.1562V15.125H9.84375V16.3438ZM15.7344 15.5312H16.1406V15.9375H15.7344V15.5312ZM14.9219 15.5312H15.3281V15.9375H14.9219V15.5312ZM14.1094 15.5312H14.5156V15.9375H14.1094V15.5312ZM13.2969 15.5312H13.7031V15.9375H13.2969V15.5312ZM12.4844 15.5312H12.8906V15.9375H12.4844V15.5312ZM11.6719 15.5312H12.0781V15.9375H11.6719V15.5312ZM10.8594 15.5312H11.2656V15.9375H10.8594V15.5312Z"
                          fill="white"
                        />
                        <path
                          d="M19.1874 11.678V9.22828C19.3133 9.13482 19.4156 9.01324 19.4861 8.87322C19.5567 8.73321 19.5935 8.57865 19.5937 8.42188C19.5937 8.15251 19.4867 7.89419 19.2962 7.70372C19.1057 7.51325 18.8474 7.40625 18.5781 7.40625C18.3087 7.40625 18.0504 7.51325 17.8599 7.70372C17.6694 7.89419 17.5624 8.15251 17.5624 8.42188C17.564 8.46818 17.5688 8.51433 17.5767 8.56L15.9984 10.1058C15.979 10.1245 15.9636 10.1469 15.9532 10.1717C15.9427 10.1964 15.9373 10.2231 15.9374 10.25V10.8594C15.9374 10.9132 15.9588 10.9649 15.9969 11.003C16.035 11.0411 16.0867 11.0625 16.1406 11.0625H16.7499C16.7768 11.0626 16.8035 11.0572 16.8283 11.0468C16.8531 11.0363 16.8755 11.0209 16.8942 11.0016L17.9687 9.90469V11.678C17.8427 11.7713 17.7403 11.8928 17.6697 12.0329C17.5992 12.1729 17.5624 12.3276 17.5624 12.4844C17.5624 12.6412 17.5992 12.7958 17.6697 12.9359C17.7403 13.0759 17.8427 13.1975 17.9687 13.2908V15.9375H17.5624V16.3438H19.1874V13.2908C19.3134 13.1975 19.4158 13.0759 19.4864 12.9359C19.557 12.7958 19.5937 12.6412 19.5937 12.4844C19.5937 12.3276 19.557 12.1729 19.4864 12.0329C19.4158 11.8928 19.3134 11.7713 19.1874 11.678Z"
                          fill="white"
                        />
                        <path
                          d="M7.8125 19.5938H19.1875V16.75H7.8125V19.5938ZM9.03125 17.3594H17.9688C18.1842 17.3594 18.3909 17.445 18.5433 17.5974C18.6956 17.7497 18.7812 17.9564 18.7812 18.1719C18.7812 18.3874 18.6956 18.594 18.5433 18.7464C18.3909 18.8988 18.1842 18.9844 17.9688 18.9844H9.03125C8.81576 18.9844 8.6091 18.8988 8.45673 18.7464C8.30435 18.594 8.21875 18.3874 8.21875 18.1719C8.21875 17.9564 8.30435 17.7497 8.45673 17.5974C8.6091 17.445 8.81576 17.3594 9.03125 17.3594Z"
                          fill="white"
                        />
                        <path
                          d="M9.03125 18.5781H17.9688C18.0765 18.5781 18.1798 18.5353 18.256 18.4591C18.3322 18.383 18.375 18.2796 18.375 18.1719C18.375 18.0641 18.3322 17.9608 18.256 17.8846C18.1798 17.8084 18.0765 17.7656 17.9688 17.7656H9.03125C8.92351 17.7656 8.82017 17.8084 8.74399 17.8846C8.6678 17.9608 8.625 18.0641 8.625 18.1719C8.625 18.2796 8.6678 18.383 8.74399 18.4591C8.82017 18.5353 8.92351 18.5781 9.03125 18.5781Z"
                          fill="white"
                        />
                        <path
                          d="M14.109 10.6562H12.8902C12.8364 10.6562 12.7847 10.6777 12.7466 10.7157C12.7085 10.7538 12.6871 10.8055 12.6871 10.8594V11.4688H12.3418L12.486 11.5642C12.786 11.7649 13.1387 11.872 13.4996 11.872C13.8605 11.872 14.2132 11.7649 14.5132 11.5642L14.6574 11.4688H14.3121V10.8594C14.3121 10.8055 14.2907 10.7538 14.2526 10.7157C14.2145 10.6777 14.1629 10.6562 14.109 10.6562ZM13.9059 11.4688H13.0934V11.0625H13.9059V11.4688Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div *ngSwitchCase="'Assembly'">
                      <svg
                        width="27"
                        height="27"
                        viewBox="0 0 27 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.5 1.1547C12.7376 0.440169 14.2624 0.440169 15.5 1.1547L23.1913 5.5953C24.4289 6.30983 25.1913 7.63034 25.1913 9.0594V17.9406C25.1913 19.3697 24.4289 20.6902 23.1913 21.4047L15.5 25.8453C14.2624 26.5598 12.7376 26.5598 11.5 25.8453L3.80866 21.4047C2.57105 20.6902 1.80866 19.3697 1.80866 17.9406V9.0594C1.80866 7.63034 2.57105 6.30983 3.80866 5.5953L11.5 1.1547Z"
                          fill="#10CE9C"
                        />
                        <g clip-path="url(#clip0)">
                          <path
                            d="M18.9731 16.9459V16.5576C19.3349 16.4076 19.5902 16.0508 19.5902 15.6353C19.5902 15.085 19.1425 14.6372 18.5922 14.6372C18.1777 14.6372 17.8216 14.8912 17.671 15.2517H16.4327C16.4219 14.9873 16.557 14.7343 16.7905 14.5982C17.1925 14.3639 17.2712 13.8161 16.9515 13.478C16.7415 13.2559 16.6941 12.9257 16.833 12.6534C17.0445 12.2389 16.8146 11.7355 16.3628 11.624C16.066 11.5507 15.8476 11.2986 15.8173 10.9944C15.7712 10.5313 15.3056 10.2321 14.8652 10.3825C14.5759 10.4813 14.2559 10.3873 14.0659 10.1478C13.7767 9.78325 13.2233 9.78325 12.9342 10.1478C12.7442 10.3873 12.4241 10.4813 12.1349 10.3825C11.701 10.2343 11.243 10.5227 11.1854 10.9739H9.33118C9.23021 10.7283 9.03403 10.5315 8.78865 10.4298V9.99877C9.30301 9.8129 9.67167 9.31977 9.67167 8.74213C9.67167 8.00551 9.07241 7.40625 8.33588 7.40625C7.59926 7.40625 7 8.00551 7 8.74203C7 9.37234 7.43888 9.90167 8.02693 10.0414V10.4297C7.66512 10.5797 7.40982 10.9365 7.40982 11.352C7.40982 11.9023 7.85753 12.3501 8.40779 12.3501C8.82227 12.3501 9.17844 12.0961 9.32899 11.7356H10.3927C10.1107 11.9353 9.99818 12.3226 10.167 12.6534C10.3059 12.9256 10.2585 13.2558 10.0485 13.478C9.7287 13.816 9.80755 14.3639 10.2095 14.5981C10.4737 14.7521 10.6122 15.0556 10.5556 15.3559C10.4694 15.8132 10.8318 16.2315 11.2968 16.2112C11.6021 16.198 11.8827 16.3784 11.9975 16.6616C12.1722 17.093 12.7033 17.2489 13.0834 16.9805C13.3332 16.8043 13.6668 16.8043 13.9165 16.9805C14.2967 17.2489 14.8277 17.093 15.0024 16.6616C15.1172 16.3784 15.3979 16.198 15.7032 16.2112C15.9098 16.2203 16.096 16.1425 16.2318 16.0134H17.6688C17.7698 16.259 17.966 16.4558 18.2113 16.5575V16.9885C17.697 17.1744 17.3283 17.6675 17.3283 18.2452C17.3283 18.9818 17.9276 19.5811 18.6641 19.5811C19.4007 19.5811 20 18.9818 20 18.2453C20 17.615 19.5611 17.0856 18.9731 16.9459ZM7.76172 8.74203C7.76172 8.42545 8.01929 8.16787 8.33588 8.16787C8.65237 8.16787 8.91005 8.42545 8.91005 8.74203C8.91005 9.05862 8.65247 9.3162 8.33588 9.3162C8.01929 9.3162 7.76172 9.05862 7.76172 8.74203ZM11.291 13.4937C11.291 12.2756 12.2819 11.2847 13.5 11.2847C14.7181 11.2847 15.709 12.2756 15.709 13.4937C15.709 14.7117 14.7181 15.7026 13.5 15.7026C12.2819 15.7026 11.291 14.7117 11.291 13.4937ZM18.6641 18.8194C18.3475 18.8194 18.09 18.5619 18.09 18.2453C18.09 17.9287 18.3476 17.6711 18.6641 17.6711C18.9807 17.6711 19.2383 17.9287 19.2383 18.2453C19.2383 18.5619 18.9807 18.8194 18.6641 18.8194Z"
                            fill="white"
                          />
                          <path
                            d="M13.5 14.9409C14.298 14.9409 14.9473 14.2917 14.9473 13.4937C14.9473 12.6956 14.298 12.0464 13.5 12.0464C12.702 12.0464 12.0527 12.6956 12.0527 13.4937C12.0527 14.2917 12.702 14.9409 13.5 14.9409Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0">
                            <rect
                              width="13"
                              height="13"
                              fill="white"
                              transform="translate(7 7)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div *ngSwitchCase="'SubAssembly'">
                      <svg
                        width="27"
                        height="27"
                        viewBox="0 0 27 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.5 1.1547C12.7376 0.440169 14.2624 0.440169 15.5 1.1547L23.1913 5.5953C24.4289 6.30983 25.1913 7.63034 25.1913 9.0594V17.9406C25.1913 19.3697 24.4289 20.6902 23.1913 21.4047L15.5 25.8453C14.2624 26.5598 12.7376 26.5598 11.5 25.8453L3.80866 21.4047C2.57105 20.6902 1.80866 19.3697 1.80866 17.9406V9.0594C1.80866 7.63034 2.57105 6.30983 3.80866 5.5953L11.5 1.1547Z"
                          fill="#10CE9C"
                        />
                        <path
                          d="M17.9688 11.4688H17.5625V11.0625C17.5625 10.838 17.3807 10.6563 17.1562 10.6563H16.75V9.03125H16.9531C17.0652 9.03125 17.1562 8.94025 17.1562 8.82813V8.42188C17.1562 8.30975 17.0652 8.21875 16.9531 8.21875H14.4557C14.4943 8.34753 14.5156 8.48383 14.5156 8.625C14.5156 8.76617 14.4943 8.90247 14.4557 9.03125H15.9375V10.6563H15.5312C15.3068 10.6563 15.125 10.838 15.125 11.0625V11.4688H14.7188C13.8213 11.4688 13.0938 12.1963 13.0938 13.0938V13.5C13.0938 14.3285 13.7143 15.0108 14.5156 15.111V14.3125C14.5156 14.303 14.5181 14.294 14.5185 14.2847C14.1671 14.1951 13.9062 13.8792 13.9062 13.5V13.0938C13.9062 12.645 14.27 12.2813 14.7188 12.2813H15.9375V12.6875C15.9375 12.912 16.1193 13.0938 16.3438 13.0938C16.5682 13.0938 16.75 12.912 16.75 12.6875V12.2813H17.9688C18.4175 12.2813 18.7812 12.645 18.7812 13.0938V13.5C18.7812 13.8792 18.5204 14.1951 18.169 14.2847C18.1694 14.294 18.1719 14.303 18.1719 14.3125V15.111C18.9732 15.0108 19.5938 14.3285 19.5938 13.5V13.0938C19.5938 12.1963 18.8662 11.4688 17.9688 11.4688Z"
                          fill="white"
                        />
                        <path
                          d="M16.9531 14.9219V14.1094H15.7344V14.9219H16.1406V14.5156H16.5469V14.9219H16.9531Z"
                          fill="white"
                        />
                        <path
                          d="M18.5781 17.7656V16.9531H17.5625H17.3594V17.7656H17.7656V17.3594H18.1719V17.7656H18.5781Z"
                          fill="white"
                        />
                        <path
                          d="M14.1094 17.7656H14.5156V17.3594H14.9219V17.7656H15.3281V16.9531H15.125H14.1094V17.7656Z"
                          fill="white"
                        />
                        <path
                          d="M19.1875 16.9531H18.9844V18.1719H16.9531V16.9531H16.75C16.6379 16.9531 16.5469 17.0443 16.5469 17.1562V19.1875C16.5469 19.2994 16.6379 19.3906 16.75 19.3906H19.1875C19.2996 19.3906 19.3906 19.2994 19.3906 19.1875V17.1562C19.3906 17.0443 19.2996 16.9531 19.1875 16.9531Z"
                          fill="white"
                        />
                        <path
                          d="M15.9375 16.9531H15.7344V18.1719H13.7031V16.9531H13.5C13.3879 16.9531 13.2969 17.0443 13.2969 17.1562V19.1875C13.2969 19.2994 13.3879 19.3906 13.5 19.3906H15.9375C16.0496 19.3906 16.1406 19.2994 16.1406 19.1875V17.1562C16.1406 17.0443 16.0496 16.9531 15.9375 16.9531Z"
                          fill="white"
                        />
                        <path
                          d="M15.125 14.1094C15.0129 14.1094 14.9219 14.2006 14.9219 14.3125V16.3438C14.9219 16.4557 15.0129 16.5469 15.125 16.5469H15.9375H16.75H17.5625C17.6746 16.5469 17.7656 16.4557 17.7656 16.3438V14.3125C17.7656 14.2006 17.6746 14.1094 17.5625 14.1094H17.3594V15.3281H15.3281V14.1094H15.125Z"
                          fill="white"
                        />
                        <path
                          d="M10.4531 12.2812C10.4531 11.5004 9.82039 10.8653 9.041 10.8598L9.03389 10.8596V10.8594C9.03287 10.8596 9.03206 10.8594 9.03125 10.8594C8.24739 10.8594 7.60938 11.4972 7.60938 12.2812C7.60938 13.0653 8.24739 13.7031 9.03125 13.7031C9.81511 13.7031 10.4531 13.0653 10.4531 12.2812ZM8.21875 12.2812C8.21875 11.8325 8.58255 11.4688 9.03125 11.4688C9.47995 11.4688 9.84375 11.8325 9.84375 12.2812C9.84375 12.73 9.47995 13.0938 9.03125 13.0938C8.58255 13.0938 8.21875 12.73 8.21875 12.2812Z"
                          fill="white"
                        />
                        <path
                          d="M11.7395 9.05685L9.58984 10.5407C10.1005 10.705 10.5139 11.0877 10.7188 11.5787L12.3156 9.81309C12.0458 9.63596 11.8397 9.37007 11.7395 9.05685Z"
                          fill="white"
                        />
                        <path
                          d="M8.44687 14.0122L9.1962 17.0977L11.0944 17.3824L10.0942 13.7658C9.7942 13.9811 9.42776 14.1095 9.03106 14.1095C8.82671 14.1095 8.6307 14.0744 8.44687 14.0122Z"
                          fill="white"
                        />
                        <path
                          d="M14.1094 8.625C14.1094 8.06498 13.6538 7.60938 13.0938 7.60938C12.5337 7.60938 12.0781 8.06498 12.0781 8.625C12.0781 9.18502 12.5337 9.64062 13.0938 9.64062C13.6538 9.64062 14.1094 9.18502 14.1094 8.625ZM12.6875 8.625C12.6875 8.40055 12.8693 8.21875 13.0938 8.21875C13.3182 8.21875 13.5 8.40055 13.5 8.625C13.5 8.84945 13.3182 9.03125 13.0938 9.03125C12.8693 9.03125 12.6875 8.84945 12.6875 8.625Z"
                          fill="white"
                        />
                        <path
                          d="M11.5591 17.8626L11.236 17.8141L11.2157 17.8198L11.2132 17.8106L8.42188 17.392V19.3905H12.0781V18.4653C12.0781 18.1612 11.86 17.9077 11.5591 17.8626Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div *ngSwitchCase="'Component'">
                      <svg
                        width="27"
                        height="27"
                        viewBox="0 0 27 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.5 1.1547C12.7376 0.440169 14.2624 0.440169 15.5 1.1547L23.1913 5.5953C24.4289 6.30983 25.1913 7.63034 25.1913 9.0594V17.9406C25.1913 19.3697 24.4289 20.6902 23.1913 21.4047L15.5 25.8453C14.2624 26.5598 12.7376 26.5598 11.5 25.8453L3.80866 21.4047C2.57105 20.6902 1.80866 19.3697 1.80866 17.9406V9.0594C1.80866 7.63034 2.57105 6.30983 3.80866 5.5953L11.5 1.1547Z"
                          fill="#10CE9C"
                        />
                        <g clip-path="url(#clip0)">
                          <path
                            d="M19.7396 12.7307L18.6543 12.3689C18.6198 12.2116 18.5781 12.0556 18.5294 11.9022L19.2883 11.0464C19.3971 10.9237 19.4152 10.7452 19.3332 10.6033L18.9253 9.89674C18.8433 9.75478 18.6798 9.6812 18.5191 9.71403L17.3962 9.94376C17.2882 9.82552 17.1746 9.71187 17.0563 9.60368L17.286 8.48096C17.3189 8.32034 17.2453 8.15672 17.1033 8.07476L16.3967 7.66681C16.2548 7.58485 16.0763 7.60287 15.9536 7.7117L15.0978 8.4706C14.9445 8.42193 14.7886 8.38016 14.6311 8.34565L14.2693 7.26041C14.2174 7.10489 14.0718 7 13.9079 7H13.092C12.9281 7 12.7826 7.10489 12.7308 7.26038L12.3689 8.34563C12.2115 8.38016 12.0555 8.4219 11.9022 8.47057L11.0464 7.7117C10.9237 7.6029 10.7452 7.58487 10.6033 7.66681L9.89671 8.07476C9.75473 8.15672 9.68115 8.32034 9.71403 8.48096L9.94376 9.60368C9.82542 9.71185 9.7118 9.82549 9.60378 9.94376L8.48093 9.71403C8.32029 9.68117 8.1567 9.75478 8.07476 9.89674L7.66683 10.6033C7.58485 10.7452 7.60293 10.9238 7.71172 11.0464L8.47062 11.9022C8.4219 12.0556 8.38018 12.2116 8.34575 12.3689L7.26043 12.7307C7.10489 12.7826 7 12.9281 7 13.092V13.908C7 14.0719 7.10491 14.2174 7.26046 14.2693L8.3457 14.6309C8.38013 14.7883 8.42188 14.9443 8.4706 15.0978L7.7117 15.9536C7.60293 16.0763 7.58485 16.2548 7.66681 16.3967L8.07473 17.1033C8.15672 17.2452 8.32024 17.3188 8.48091 17.286L9.60376 17.0562C9.71182 17.1745 9.82542 17.2882 9.94374 17.3962L9.714 18.519C9.68115 18.6796 9.75473 18.8433 9.89669 18.9252L10.6033 19.3331C10.7453 19.4151 10.9237 19.397 11.0464 19.2882L11.9022 18.5294C12.0556 18.578 12.2115 18.6198 12.3689 18.6542L12.7307 19.7395C12.7826 19.8951 12.9281 19.9999 13.092 19.9999H13.9079C14.0718 19.9999 14.2174 19.8951 14.2692 19.7395L14.631 18.6542C14.7884 18.6198 14.9443 18.578 15.0978 18.5294L15.9535 19.2882C16.0762 19.397 16.2547 19.4151 16.3967 19.3331L17.1032 18.9252C17.2452 18.8433 17.3188 18.6796 17.2859 18.519L17.0562 17.3962C17.1745 17.2882 17.2881 17.1745 17.3962 17.0562L18.519 17.286C18.6797 17.3189 18.8433 17.2452 18.9252 17.1033L19.3331 16.3967C19.4151 16.2548 19.397 16.0762 19.2882 15.9536L18.5293 15.0978C18.578 14.9443 18.6198 14.7883 18.6542 14.6309L19.7395 14.2693C19.895 14.2174 19.9999 14.0719 19.9999 13.908V13.092C20 12.9281 19.8951 12.7826 19.7396 12.7307ZM14.9822 10.1705L13.9494 11.9597C13.6515 11.8728 13.3397 11.8765 13.0509 11.9607L12.0182 10.1722C12.9383 9.76392 14.0156 9.73934 14.9822 10.1705ZM14.343 13.5C14.343 13.9648 13.9648 14.343 13.5 14.343C13.0352 14.343 12.657 13.9648 12.657 13.5C12.657 13.0352 13.0352 12.657 13.5 12.657C13.9648 12.657 14.343 13.0352 14.343 13.5ZM11.3587 10.553L12.3914 12.3415C12.1741 12.5496 12.0151 12.8177 11.9414 13.1192H9.87546C9.98528 12.0664 10.5452 11.1457 11.3587 10.553ZM11.3587 16.447C10.5452 15.8543 9.9853 14.9336 9.87546 13.8809H11.9414C12.0151 14.1823 12.1741 14.4505 12.3914 14.6585L11.3587 16.447ZM12.0178 16.8295L13.0506 15.0403C13.3485 15.1272 13.6603 15.1235 13.9491 15.0393L14.9818 16.8278C14.0617 17.2361 12.9844 17.2607 12.0178 16.8295ZM15.6413 16.447L14.6086 14.6585C14.8259 14.4504 14.9849 14.1823 15.0586 13.8809H17.1245C17.0147 14.9336 16.4548 15.8543 15.6413 16.447ZM15.0587 13.1191C14.985 12.8177 14.8259 12.5495 14.6087 12.3415L15.6413 10.5529C16.4548 11.1457 17.0147 12.0664 17.1246 13.1191H15.0587V13.1191Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0">
                            <rect
                              width="13"
                              height="13"
                              fill="white"
                              transform="translate(7 7)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  </div>
                </div>
                <!-- <div class="selectedtree"> -->
                <p class="tree-text-main"></p>
                <p
                  class="tree-text"
                  (click)="onNodeSelect(node)"
                  [ngStyle]="{ cursor: node.Level === 'Unit' ? 'pointer' : '' }"
                >
                  {{ replaceIcon(node.icon) }}{{ node.text }}
                </p>
              </div>
              <!-- </div> -->
            </li>
          </mat-tree-node>
          <!-- This is the tree node template for expandable nodes -->
          <mat-nested-tree-node
            *matTreeNodeDef="let node; when: hasChild"
            class="parent-node"
            matTreeNodePadding
          >
            <li class="tree-node">
              <div class="tree-content">
                <button
                  mat-icon-button
                  class="tree-tpggler"
                  [attr.aria-label]="'Toggle ' + node.name"
                  matTreeNodeToggle
                  [ngClass]="{ 'node-open': treeControl.isExpanded(node) }"
                >
                  <span *ngIf="!treeControl.isExpanded(node)">
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="0.5"
                        y="0.5"
                        width="14"
                        height="14"
                        stroke="#7B868C"
                      />
                      <path
                        d="M11.25 8.0353H8.03571H6.96429H3.75V6.96387H6.96429H8.03571H11.25V8.0353Z"
                        fill="#7B868C"
                      />
                      <path
                        d="M6.96429 11.25L6.96429 8.03571L6.96429 6.96429L6.96429 3.75L8.03572 3.75L8.03572 6.96429L8.03572 8.03571L8.03572 11.25L6.96429 11.25Z"
                        fill="#7B868C"
                      />
                    </svg>
                  </span>
                  <span *ngIf="treeControl.isExpanded(node)">
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="0.5"
                        y="0.5"
                        width="14"
                        height="14"
                        stroke="#7B868C"
                      />
                      <path
                        d="M11.25 8.2853H8.03571H6.96429H3.75V7.21387H6.96429H8.03571H11.25V8.2853Z"
                        fill="#7B868C"
                      />
                    </svg>
                  </span>
                </button>
                <div
                  class="node-icon"
                  [ngStyle]="{
                    'background-color':
                      replaceString(node.icon) === true ? 'red' : ''
                  }"
                  [ngClass]="{ 'node-open': treeControl.isExpanded(node) }"
                >
                  <div [ngSwitch]="node.Level">
                    <div *ngSwitchCase="'Group'">
                      <svg
                        width="29"
                        height="29"
                        viewBox="0 0 29 29"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.5 1.1547C13.7376 0.440169 15.2624 0.440169 16.5 1.1547L25.0574 6.0953C26.295 6.80983 27.0574 8.13034 27.0574 9.5594V19.4406C27.0574 20.8697 26.295 22.1902 25.0574 22.9047L16.5 27.8453C15.2624 28.5598 13.7376 28.5598 12.5 27.8453L3.94263 22.9047C2.70503 22.1902 1.94263 20.8697 1.94263 19.4406V9.5594C1.94263 8.13034 2.70503 6.80983 3.94263 6.0953L12.5 1.1547Z"
                          fill="#10CE9C"
                        />
                        <path
                          d="M10.0101 9.89258H9.24838V11.6056H8V20.1187H11.2585V11.6056H10.0101V9.89258ZM10.2166 18.2144H9.04188V17.4526H10.2166V18.2144H10.2166ZM10.2166 16.6909H9.04188V15.9292H10.2166V16.6909H10.2166ZM10.2166 15.1675H9.04188V14.4058H10.2166V15.1675H10.2166ZM10.2166 12.8823V13.644H9.04188V12.8823H10.2166Z"
                          fill="white"
                        />
                        <path
                          d="M19.7516 11.6056V9.89258H18.9899V11.6056H17.7415V20.1187H21V11.6056H19.7516ZM19.9581 18.2144H18.7834V17.4526H19.9581V18.2144ZM19.9581 16.6909H18.7834V15.9292H19.9581V16.6909ZM19.9581 15.1675H18.7834V14.4058H19.9581V15.1675ZM19.9581 13.644H18.7834V12.8823H19.9581V13.644Z"
                          fill="white"
                        />
                        <path
                          d="M14.1191 18.9761H14.8809V20.1187H14.1191V18.9761Z"
                          fill="white"
                        />
                        <path
                          d="M12.0202 20.1188H13.3574V18.2145H15.6426V20.1188H16.9798V8.88037L12.0202 10.0472V20.1188ZM14.8809 11.359H16.0556V12.1207H14.8809V11.359ZM14.8809 12.8824H16.0556V13.6442H14.8809V12.8824ZM14.8809 14.4059H16.0556V15.1676H14.8809V14.4059ZM14.8809 15.9293H16.0556V16.691H14.8809V15.9293ZM12.9444 11.359H14.1191V12.1207H12.9444V11.359ZM12.9444 12.8824H14.1191V13.6442H12.9444V12.8824ZM12.9444 14.4059H14.1191V15.1676H12.9444V14.4059ZM12.9444 15.9293H14.1191V16.691H12.9444V15.9293Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div *ngSwitchCase="'Plant'">
                      <svg
                        width="27"
                        height="27"
                        viewBox="0 0 27 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.5 1.1547C12.7376 0.440169 14.2624 0.440169 15.5 1.1547L23.1913 5.5953C24.4289 6.30983 25.1913 7.63034 25.1913 9.0594V17.9406C25.1913 19.3697 24.4289 20.6902 23.1913 21.4047L15.5 25.8453C14.2624 26.5598 12.7376 26.5598 11.5 25.8453L3.80866 21.4047C2.57105 20.6902 1.80866 19.3697 1.80866 17.9406V9.0594C1.80866 7.63034 2.57105 6.30983 3.80866 5.5953L11.5 1.1547Z"
                          fill="#10CE9C"
                        />
                        <path
                          d="M19.4292 12.9508C19.238 12.8484 19.0091 12.8595 18.8282 12.9803L15.667 15.09V13.4707C15.667 13.2534 15.5453 13.0537 15.3539 12.9514C15.1624 12.849 14.9293 12.8603 14.748 12.9809L11.4975 15.1473V10.6091C11.4975 10.4885 11.4051 10.3816 11.2848 10.3816H7.48063C7.36037 10.3816 7.26251 10.4885 7.26251 10.6091V19.7836C7.26251 19.9039 7.36037 20.0003 7.48063 20.0003H19.5248C19.645 20.0003 19.7378 19.9039 19.7378 19.7836V13.4698C19.7381 13.2529 19.6212 13.0532 19.4292 12.9508ZM14.2882 17.2865C14.2882 17.3713 14.2196 17.4399 14.1342 17.4399H13.0635C12.9784 17.4399 12.9098 17.3713 12.9098 17.2865V16.2149C12.9098 16.1298 12.9784 16.0612 13.0635 16.0612H14.1342C14.2196 16.0612 14.2882 16.1298 14.2882 16.2149V17.2865ZM18.2929 17.2865C18.2929 17.3713 18.2249 17.4399 18.1395 17.4399H17.0685C16.9834 17.4399 16.9147 17.3713 16.9147 17.2865V16.2149C16.9147 16.1298 16.9834 16.0612 17.0685 16.0612H18.1395C18.2249 16.0612 18.2929 16.1298 18.2929 16.2149V17.2865Z"
                          fill="white"
                        />
                        <path
                          d="M7.48135 9.52779H11.2855C11.4058 9.52779 11.4982 9.44496 11.4982 9.3247V7.5877C11.4982 7.26237 11.2398 7 10.9142 7H7.85263C7.5273 7 7.26351 7.26237 7.26351 7.5877V9.32498C7.26351 9.44496 7.36137 9.52779 7.48135 9.52779Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div *ngSwitchCase="'Division'">
                      <svg
                        width="27"
                        height="27"
                        viewBox="0 0 27 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.5 1.1547C12.7376 0.440169 14.2624 0.440169 15.5 1.1547L23.1913 5.5953C24.4289 6.30983 25.1913 7.63034 25.1913 9.0594V17.9406C25.1913 19.3697 24.4289 20.6902 23.1913 21.4047L15.5 25.8453C14.2624 26.5598 12.7376 26.5598 11.5 25.8453L3.80866 21.4047C2.57105 20.6902 1.80866 19.3697 1.80866 17.9406V9.0594C1.80866 7.63034 2.57105 6.30983 3.80866 5.5953L11.5 1.1547Z"
                          fill="#10CE9C"
                        />
                        <g clip-path="url(#clip0)">
                          <path
                            d="M12.1428 9.63622H12.5934V10.0868H12.1428V9.63622Z"
                            fill="white"
                          />
                          <path
                            d="M12.1428 11.4387H12.5934V11.8893H12.1428V11.4387Z"
                            fill="white"
                          />
                          <path
                            d="M12.1428 13.2408H12.5934V13.6914H12.1428V13.2408Z"
                            fill="white"
                          />
                          <path
                            d="M9.88936 15.0433H10.34V15.4939H9.88936V15.0433Z"
                            fill="white"
                          />
                          <path
                            d="M17.5496 11.8893H18.0002V12.34H17.5496V11.8893Z"
                            fill="white"
                          />
                          <path
                            d="M9.88936 13.2408H10.34V13.6914H9.88936V13.2408Z"
                            fill="white"
                          />
                          <path
                            d="M9.88936 9.63622H10.34V10.0868H9.88936V9.63622Z"
                            fill="white"
                          />
                          <path
                            d="M12.1428 15.0433H12.5934V15.4939H12.1428V15.0433Z"
                            fill="white"
                          />
                          <path
                            d="M9.88936 11.4387H10.34V11.8893H9.88936V11.4387Z"
                            fill="white"
                          />
                          <path
                            d="M15.7473 13.6917H16.1979V14.1423H15.7473V13.6917Z"
                            fill="white"
                          />
                          <path
                            d="M17.5496 13.6917H18.0002V14.1423H17.5496V13.6917Z"
                            fill="white"
                          />
                          <path
                            d="M17.5496 15.4939H18.0002V15.9445H17.5496V15.4939Z"
                            fill="white"
                          />
                          <path
                            d="M15.7473 11.8893H16.1979V12.34H15.7473V11.8893Z"
                            fill="white"
                          />
                          <path
                            d="M15.7473 15.4939H16.1979V15.9445H15.7473V15.4939Z"
                            fill="white"
                          />
                          <path
                            d="M9.66408 17.2964H11.0159V19.0988H9.66408V17.2964Z"
                            fill="white"
                          />
                          <path
                            d="M11.4664 17.2964H12.8183V19.0988H11.4664V17.2964Z"
                            fill="white"
                          />
                          <path
                            d="M16.1984 17.7474H17.5502V19.0992H16.1984V17.7474Z"
                            fill="white"
                          />
                          <path
                            d="M18.9018 19.5494V11.1638L14.8464 10.15V19.5494H14.3958V8.68251L8.08727 7V19.5494H7.41136V20H19.5777V19.5494H18.9018ZM11.6921 9.41079C11.6921 9.28637 11.793 9.18549 11.9174 9.18549H12.8186C12.9431 9.18549 13.0439 9.28637 13.0439 9.41079V10.312C13.0439 10.4364 12.9431 10.5373 12.8186 10.5373H11.9174C11.793 10.5373 11.6921 10.4364 11.6921 10.312V9.41079ZM11.6921 11.2132C11.6921 11.0888 11.793 10.9879 11.9174 10.9879H12.8186C12.9431 10.9879 13.0439 11.0888 13.0439 11.2132V12.1144C13.0439 12.2389 12.9431 12.3397 12.8186 12.3397H11.9174C11.793 12.3397 11.6921 12.2389 11.6921 12.1144V11.2132ZM11.6921 13.0156C11.6921 12.8912 11.793 12.7903 11.9174 12.7903H12.8186C12.9431 12.7903 13.0439 12.8912 13.0439 13.0156V13.9169C13.0439 14.0413 12.9431 14.1422 12.8186 14.1422H11.9174C11.793 14.1422 11.6921 14.0413 11.6921 13.9169V13.0156ZM11.6921 14.8181C11.6921 14.6936 11.793 14.5928 11.9174 14.5928H12.8186C12.9431 14.5928 13.0439 14.6936 13.0439 14.8181V15.7193C13.0439 15.8437 12.9431 15.9446 12.8186 15.9446H11.9174C11.793 15.9446 11.6921 15.8437 11.6921 15.7193V14.8181ZM9.43909 9.41079C9.43909 9.28637 9.53997 9.18549 9.66439 9.18549H10.5656C10.69 9.18549 10.7909 9.28637 10.7909 9.41079V10.312C10.7909 10.4364 10.69 10.5373 10.5656 10.5373H9.66439C9.53997 10.5373 9.43909 10.4364 9.43909 10.312V9.41079ZM9.43909 11.2132C9.43909 11.0888 9.53997 10.9879 9.66439 10.9879H10.5656C10.69 10.9879 10.7909 11.0888 10.7909 11.2132V12.1144C10.7909 12.2389 10.69 12.3397 10.5656 12.3397H9.66439C9.53997 12.3397 9.43909 12.2389 9.43909 12.1144V11.2132ZM9.43909 13.0156C9.43909 12.8912 9.53997 12.7903 9.66439 12.7903H10.5656C10.69 12.7903 10.7909 12.8912 10.7909 13.0156V13.9169C10.7909 14.0413 10.69 14.1422 10.5656 14.1422H9.66439C9.53997 14.1422 9.43909 14.0413 9.43909 13.9169V13.0156ZM9.43909 14.8181C9.43909 14.6936 9.53997 14.5928 9.66439 14.5928H10.5656C10.69 14.5928 10.7909 14.6936 10.7909 14.8181V15.7193C10.7909 15.8437 10.69 15.9446 10.5656 15.9446H9.66439C9.53997 15.9446 9.43909 15.8437 9.43909 15.7193V14.8181ZM13.2692 19.0988V19.5494H9.21379V17.0711C9.21379 16.9467 9.31467 16.8458 9.43909 16.8458H13.0439C13.1684 16.8458 13.2692 16.9467 13.2692 17.0711V19.0988ZM15.297 11.6638C15.297 11.5394 15.3979 11.4385 15.5223 11.4385H16.4235C16.5479 11.4385 16.6488 11.5394 16.6488 11.6638V12.565C16.6488 12.6895 16.5479 12.7903 16.4235 12.7903H15.5223C15.3979 12.7903 15.297 12.6895 15.297 12.565V11.6638ZM15.297 13.4662C15.297 13.3418 15.3979 13.2409 15.5223 13.2409H16.4235C16.5479 13.2409 16.6488 13.3418 16.6488 13.4662V14.3675C16.6488 14.4919 16.5479 14.5928 16.4235 14.5928H15.5223C15.3979 14.5928 15.297 14.4919 15.297 14.3675V13.4662ZM15.297 16.1699V15.2687C15.297 15.1443 15.3979 15.0434 15.5223 15.0434H16.4235C16.5479 15.0434 16.6488 15.1443 16.6488 15.2687V16.1699C16.6488 16.2943 16.5479 16.3952 16.4235 16.3952H15.5223C15.3979 16.3952 15.297 16.2943 15.297 16.1699ZM18.0006 19.5494H15.7476V17.5217C15.7476 17.3973 15.8485 17.2964 15.9729 17.2964H17.7753C17.8997 17.2964 18.0006 17.3973 18.0006 17.5217V19.5494ZM18.4512 16.1699C18.4512 16.2943 18.3503 16.3952 18.2259 16.3952H17.3247C17.2003 16.3952 17.0994 16.2943 17.0994 16.1699V15.2687C17.0994 15.1443 17.2003 15.0434 17.3247 15.0434H18.2259C18.3503 15.0434 18.4512 15.1443 18.4512 15.2687V16.1699ZM18.4512 14.3675C18.4512 14.4919 18.3503 14.5928 18.2259 14.5928H17.3247C17.2003 14.5928 17.0994 14.4919 17.0994 14.3675V13.4662C17.0994 13.3418 17.2003 13.2409 17.3247 13.2409H18.2259C18.3503 13.2409 18.4512 13.3418 18.4512 13.4662V14.3675ZM18.4512 12.565C18.4512 12.6895 18.3503 12.7903 18.2259 12.7903H17.3247C17.2003 12.7903 17.0994 12.6895 17.0994 12.565V11.6638C17.0994 11.5394 17.2003 11.4385 17.3247 11.4385H18.2259C18.3503 11.4385 18.4512 11.5394 18.4512 11.6638V12.565Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0">
                            <rect
                              width="13"
                              height="13"
                              fill="white"
                              transform="translate(7 7)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div *ngSwitchCase="'Department'">
                      <svg
                        width="27"
                        height="27"
                        viewBox="0 0 27 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.5 1.1547C12.7376 0.440169 14.2624 0.440169 15.5 1.1547L23.1913 5.5953C24.4289 6.30983 25.1913 7.63034 25.1913 9.0594V17.9406C25.1913 19.3697 24.4289 20.6902 23.1913 21.4047L15.5 25.8453C14.2624 26.5598 12.7376 26.5598 11.5 25.8453L3.80866 21.4047C2.57105 20.6902 1.80866 19.3697 1.80866 17.9406V9.0594C1.80866 7.63034 2.57105 6.30983 3.80866 5.5953L11.5 1.1547Z"
                          fill="#10CE9C"
                        />
                        <path
                          d="M14.7465 15.7852H12.2533C11.8885 15.7852 11.5918 16.0813 11.5918 16.4453V20H15.408V16.4453C15.408 16.0813 15.1113 15.7852 14.7465 15.7852Z"
                          fill="white"
                        />
                        <path
                          d="M18.5805 16.9531H16.8408C16.4728 16.9531 16.1735 17.2493 16.1735 17.6133C16.1735 19.73 16.1746 19.6035 16.1714 19.6336V20H19.2478V17.6133C19.2478 17.2493 18.9483 16.9531 18.5805 16.9531Z"
                          fill="white"
                        />
                        <path
                          d="M20 10.0723V8.39648C20 7.62643 19.3736 7 18.6037 7H8.39629C7.62643 7 7 7.62643 7 8.39648V10.0723H20ZM18.0697 8.54883C18.2801 8.54883 18.4506 8.71932 18.4506 8.92969C18.4506 9.14005 18.2801 9.31055 18.0697 9.31055C17.8595 9.31055 17.689 9.14005 17.689 8.92969C17.689 8.71932 17.8595 8.54883 18.0697 8.54883ZM16.5465 8.54883C16.7567 8.54883 16.9272 8.71932 16.9272 8.92969C16.9272 9.14005 16.7567 9.31055 16.5465 9.31055C16.3361 9.31055 16.1656 9.14005 16.1656 8.92969C16.1656 8.71932 16.3361 8.54883 16.5465 8.54883ZM15.0232 8.54883C15.2335 8.54883 15.404 8.71932 15.404 8.92969C15.404 9.14005 15.2335 9.31055 15.0232 9.31055C14.813 9.31055 14.6424 9.14005 14.6424 8.92969C14.6424 8.71932 14.813 8.54883 15.0232 8.54883Z"
                          fill="white"
                        />
                        <path
                          d="M9.30206 14.668C9.0916 14.668 8.92041 14.8389 8.92041 15.0488C8.92041 15.2588 9.0916 15.4297 9.30206 15.4297C9.51243 15.4297 9.68362 15.2588 9.68362 15.0488C9.68362 14.8389 9.51243 14.668 9.30206 14.668Z"
                          fill="white"
                        />
                        <path
                          d="M10.16 16.9531H8.41859C8.05003 16.9531 7.7502 17.2493 7.7502 17.6133V20H10.8284C10.8284 19.3434 10.8284 17.7141 10.8284 17.6133C10.8284 17.2493 10.5286 16.9531 10.16 16.9531Z"
                          fill="white"
                        />
                        <path
                          d="M17.7235 14.668C17.513 14.668 17.3418 14.8389 17.3418 15.0488C17.3418 15.2588 17.513 15.4297 17.7235 15.4297C17.9339 15.4297 18.1051 15.2588 18.1051 15.0488C18.1051 14.8389 17.9339 14.668 17.7235 14.668Z"
                          fill="white"
                        />
                        <path
                          d="M7 10.834V17.4261C7.09254 16.7303 7.69338 16.1914 8.4188 16.1914H9.30212C8.67082 16.1914 8.15726 15.6788 8.15726 15.0488C8.15726 14.4188 8.67082 13.9062 9.30212 13.9062C9.93341 13.9062 10.447 14.4188 10.447 15.0488C10.447 15.6788 9.93341 16.1914 9.30212 16.1914C10.1967 16.1914 10.4401 16.1505 10.8316 16.3579C10.877 15.6145 11.4972 15.0234 12.2534 15.0234H13.5127C12.7763 15.0234 12.177 14.4255 12.177 13.6904C12.177 12.9554 12.7763 12.3574 13.5127 12.3574C14.2492 12.3574 14.8484 12.9554 14.8484 13.6904C14.8484 14.4255 14.2492 15.0234 13.5127 15.0234H14.7466C15.5031 15.0234 16.1234 15.6149 16.1685 16.3587C16.5548 16.1533 16.7837 16.1914 17.7233 16.1914C17.092 16.1914 16.5784 15.6788 16.5784 15.0488C16.5784 14.4188 17.092 13.9062 17.7233 13.9062C18.3546 13.9062 18.8681 14.4188 18.8681 15.0488C18.8681 15.6788 18.3546 16.1914 17.7233 16.1914H18.5804C19.3104 16.1914 19.914 16.7378 20 17.4407V10.834H7Z"
                          fill="white"
                        />
                        <path
                          d="M13.5127 13.1191C13.1971 13.1191 12.9403 13.3754 12.9403 13.6904C12.9403 14.0054 13.1971 14.2617 13.5127 14.2617C13.8284 14.2617 14.0852 14.0054 14.0852 13.6904C14.0852 13.3754 13.8284 13.1191 13.5127 13.1191Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div *ngSwitchCase="'Line'">
                      <svg
                        width="27"
                        height="27"
                        viewBox="0 0 27 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.5 1.1547C12.7376 0.440169 14.2624 0.440169 15.5 1.1547L23.1913 5.5953C24.4289 6.30983 25.1913 7.63034 25.1913 9.0594V17.9406C25.1913 19.3697 24.4289 20.6902 23.1913 21.4047L15.5 25.8453C14.2624 26.5598 12.7376 26.5598 11.5 25.8453L3.80866 21.4047C2.57105 20.6902 1.80866 19.3697 1.80866 17.9406V9.0594C1.80866 7.63034 2.57105 6.30983 3.80866 5.5953L11.5 1.1547Z"
                          fill="#10CE9C"
                        />
                        <path
                          d="M16.0955 8.92341H15.5502C15.498 8.81308 15.4372 8.70761 15.3682 8.60752L15.6406 8.13559C15.7302 7.9804 15.6771 7.78197 15.5219 7.69239L14.398 7.04354C14.3235 7.0005 14.2349 6.98887 14.1518 7.01111C14.0687 7.0334 13.9979 7.08777 13.9548 7.16229L13.6828 7.63346C13.56 7.62303 13.44 7.62303 13.3172 7.63346L13.0452 7.16229C13.0021 7.08777 12.9313 7.0334 12.8482 7.01111C12.7651 6.98887 12.6765 7.0005 12.602 7.04354L11.4781 7.69242C11.3229 7.782 11.2698 7.98042 11.3594 8.13561L11.6318 8.60757C11.5628 8.70764 11.502 8.81314 11.4498 8.92343H10.9045C10.7253 8.92343 10.5801 9.06869 10.5801 9.24787V10.5456C10.5801 10.7248 10.7253 10.8701 10.9045 10.8701H11.4498C11.502 10.9803 11.5628 11.0858 11.6318 11.1859L11.3594 11.6579C11.2698 11.813 11.3229 12.0115 11.4781 12.101L12.602 12.7499C12.6765 12.793 12.765 12.8046 12.8482 12.7824C12.9313 12.7601 13.0021 12.7057 13.0452 12.6312L13.3172 12.1599C13.44 12.1704 13.56 12.1704 13.6828 12.1599L13.9548 12.6311C13.9979 12.7056 14.0687 12.76 14.1518 12.7823C14.1795 12.7897 14.2077 12.7933 14.2358 12.7933C14.2923 12.7933 14.3483 12.7786 14.398 12.7499L15.5219 12.101C15.6771 12.0114 15.7303 11.813 15.6407 11.6578L15.3682 11.1859C15.4373 11.0858 15.498 10.9803 15.5502 10.87H16.0955C16.2747 10.87 16.4199 10.7247 16.4199 10.5456V10.2211V9.57224V9.24785C16.4199 9.06867 16.2747 8.92341 16.0955 8.92341ZM13.5 10.8489C12.9749 10.8489 12.5479 10.4218 12.5479 9.89671C12.5479 9.37165 12.9749 8.94456 13.5 8.94456C14.0251 8.94456 14.4521 9.37165 14.4521 9.89671C14.4521 10.4218 14.0251 10.8489 13.5 10.8489Z"
                          fill="white"
                        />
                        <path
                          d="M9.03125 11.1108V10.2774H9.81836V9.5157H8.65039C8.44005 9.5157 8.26953 9.68622 8.26953 9.89655V11.1108C7.97426 11.1802 7.70322 11.33 7.48339 11.5499C7.17167 11.8616 7 12.276 7 12.7169C7 13.1577 7.17167 13.5722 7.48339 13.8839C7.6321 14.0326 7.87326 14.0326 8.022 13.8839C8.17074 13.7352 8.17074 13.494 8.022 13.3453C7.67552 12.9988 7.67552 12.435 8.022 12.0885C8.18986 11.9206 8.41301 11.8282 8.65039 11.8282C8.88777 11.8282 9.11093 11.9206 9.27878 12.0885C9.62526 12.435 9.62526 12.9988 9.27878 13.3453C9.13004 13.494 9.13004 13.7351 9.27878 13.8839C9.35315 13.9582 9.45063 13.9954 9.54808 13.9954C9.64553 13.9954 9.74303 13.9582 9.81737 13.8839C10.1291 13.5722 10.3008 13.1577 10.3008 12.7169C10.3008 12.276 10.1291 11.8616 9.81737 11.5499C9.59756 11.33 9.32652 11.1802 9.03125 11.1108Z"
                          fill="white"
                        />
                        <path
                          d="M19.5166 11.5498C19.2968 11.33 19.0257 11.1802 18.7305 11.1107V9.89649C18.7305 9.68615 18.5599 9.51563 18.3496 9.51563H17.1816V10.2773H17.9687V11.1107C17.6735 11.1802 17.4024 11.33 17.1826 11.5498C16.8709 11.8615 16.6992 12.276 16.6992 12.7168C16.6992 13.1577 16.8709 13.5721 17.1826 13.8838C17.3313 14.0325 17.5725 14.0325 17.7212 13.8838C17.87 13.7351 17.87 13.494 17.7212 13.3452C17.3747 12.9987 17.3747 12.4349 17.7212 12.0884C17.8891 11.9206 18.1122 11.8282 18.3496 11.8282C18.587 11.8282 18.8101 11.9206 18.978 12.0884C19.3245 12.4349 19.3245 12.9987 18.978 13.3452C18.8293 13.4939 18.8293 13.7351 18.978 13.8838C19.0524 13.9582 19.1498 13.9954 19.2473 13.9954C19.3447 13.9954 19.4422 13.9582 19.5166 13.8838C19.8283 13.5721 20 13.1577 20 12.7168C20 12.276 19.8283 11.8615 19.5166 11.5498Z"
                          fill="white"
                        />
                        <path
                          d="M8.04102 20C8.60193 20 9.05664 19.5453 9.05664 18.9844C9.05664 18.4235 8.60193 17.9688 8.04102 17.9688C7.4801 17.9688 7.02539 18.4235 7.02539 18.9844C7.02539 19.5453 7.4801 20 8.04102 20Z"
                          fill="white"
                        />
                        <path
                          d="M13.5 20C14.0609 20 14.5156 19.5453 14.5156 18.9844C14.5156 18.4235 14.0609 17.9688 13.5 17.9688C12.9391 17.9688 12.4844 18.4235 12.4844 18.9844C12.4844 19.5453 12.9391 20 13.5 20Z"
                          fill="white"
                        />
                        <path
                          d="M14.9568 17.9688C15.1582 18.2569 15.2768 18.6069 15.2768 18.9844C15.2768 19.3618 15.1582 19.7119 14.9568 20H17.5012C17.2998 19.7119 17.1811 19.3618 17.1811 18.9844C17.1811 18.6069 17.2998 18.2569 17.5012 17.9688H14.9568Z"
                          fill="white"
                        />
                        <path
                          d="M9.49783 17.9688C9.69923 18.2569 9.81786 18.6069 9.81786 18.9844C9.81786 19.3618 9.69923 19.7119 9.49783 20H12.0422C11.8408 19.7119 11.7221 19.3618 11.7221 18.9844C11.7221 18.6069 11.8408 18.2569 12.0422 17.9688H9.49783Z"
                          fill="white"
                        />
                        <path
                          d="M18.959 20C19.5199 20 19.9746 19.5453 19.9746 18.9844C19.9746 18.4235 19.5199 17.9688 18.959 17.9688C18.3981 17.9688 17.9434 18.4235 17.9434 18.9844C17.9434 19.5453 18.3981 20 18.959 20Z"
                          fill="white"
                        />
                        <path
                          d="M14.4521 14.9219H12.5479C12.3375 14.9219 12.167 15.0924 12.167 15.3027V17.207H14.833V15.3027C14.833 15.0924 14.6625 14.9219 14.4521 14.9219Z"
                          fill="white"
                        />
                        <path
                          d="M10.6436 14.9219H8.73926C8.52892 14.9219 8.3584 15.0924 8.3584 15.3027V17.207H11.0244V15.3027C11.0244 15.0924 10.8539 14.9219 10.6436 14.9219Z"
                          fill="white"
                        />
                        <path
                          d="M16.3564 14.9219C16.1461 14.9219 15.9756 15.0924 15.9756 15.3027V17.207H18.6416V15.3027C18.6416 15.0924 18.4711 14.9219 18.2607 14.9219H16.3564Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div *ngSwitchCase="'Unit'">
                      <svg
                        width="27"
                        height="27"
                        viewBox="0 0 27 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.5 1.1547C12.7376 0.440169 14.2624 0.440169 15.5 1.1547L23.1913 5.5953C24.4289 6.30983 25.1913 7.63034 25.1913 9.0594V17.9406C25.1913 19.3697 24.4289 20.6902 23.1913 21.4047L15.5 25.8453C14.2624 26.5598 12.7376 26.5598 11.5 25.8453L3.80866 21.4047C2.57105 20.6902 1.80866 19.3697 1.80866 17.9406V9.0594C1.80866 7.63034 2.57105 6.30983 3.80866 5.5953L11.5 1.1547Z"
                          fill="#10CE9C"
                        />
                        <path
                          d="M7.81226 16.3438H9.43726V15.9375H9.03101V13.2908C9.15703 13.1975 9.25942 13.0759 9.32998 12.9359C9.40054 12.7958 9.43729 12.6412 9.43729 12.4844C9.43729 12.3276 9.40054 12.1729 9.32998 12.0329C9.25942 11.8928 9.15703 11.7713 9.03101 11.678V9.90469L10.1055 11.0016C10.1242 11.0209 10.1466 11.0363 10.1714 11.0468C10.1962 11.0572 10.2229 11.0626 10.2498 11.0625H10.8591C10.913 11.0625 10.9647 11.0411 11.0028 11.003C11.0409 10.9649 11.0623 10.9132 11.0623 10.8594V10.25C11.0624 10.2231 11.057 10.1964 11.0465 10.1717C11.0361 10.1469 11.0207 10.1245 11.0013 10.1058L9.42304 8.56C9.43089 8.51433 9.43564 8.46818 9.43726 8.42188C9.43726 8.15251 9.33025 7.89419 9.13979 7.70372C8.94932 7.51325 8.69099 7.40625 8.42163 7.40625C8.15227 7.40625 7.89394 7.51325 7.70348 7.70372C7.51301 7.89419 7.40601 8.15251 7.40601 8.42188C7.40619 8.57865 7.44303 8.73321 7.51356 8.87322C7.5841 9.01324 7.68638 9.13482 7.81226 9.22828V11.678C7.68624 11.7713 7.58384 11.8928 7.51328 12.0329C7.44273 12.1729 7.40598 12.3276 7.40598 12.4844C7.40598 12.6412 7.44273 12.7958 7.51328 12.9359C7.58384 13.0759 7.68624 13.1975 7.81226 13.2908V16.3438Z"
                          fill="white"
                        />
                        <path
                          d="M13.2969 9.41922V10.25H13.7031V9.41922C13.9868 9.37102 14.2443 9.22411 14.4302 9.00444C14.616 8.78477 14.7182 8.50649 14.7188 8.21875V7.60938C14.7188 7.5555 14.6973 7.50384 14.6593 7.46574C14.6212 7.42765 14.5695 7.40625 14.5156 7.40625H12.4844C12.4305 7.40625 12.3788 7.42765 12.3407 7.46574C12.3027 7.50384 12.2812 7.5555 12.2812 7.60938V8.21875C12.2818 8.50649 12.384 8.78477 12.5698 9.00444C12.7557 9.22411 13.0132 9.37102 13.2969 9.41922Z"
                          fill="white"
                        />
                        <path
                          d="M15.125 11.6455L14.7391 11.9015C14.3728 12.1477 13.9414 12.2793 13.5 12.2793C13.0586 12.2793 12.6272 12.1477 12.2609 11.9015L11.875 11.6455V14.1094H15.125V11.6455ZM13.7031 13.2969H13.2969V12.8907H13.7031V13.2969Z"
                          fill="white"
                        />
                        <path
                          d="M9.84375 16.3438H17.1562V15.125H9.84375V16.3438ZM15.7344 15.5312H16.1406V15.9375H15.7344V15.5312ZM14.9219 15.5312H15.3281V15.9375H14.9219V15.5312ZM14.1094 15.5312H14.5156V15.9375H14.1094V15.5312ZM13.2969 15.5312H13.7031V15.9375H13.2969V15.5312ZM12.4844 15.5312H12.8906V15.9375H12.4844V15.5312ZM11.6719 15.5312H12.0781V15.9375H11.6719V15.5312ZM10.8594 15.5312H11.2656V15.9375H10.8594V15.5312Z"
                          fill="white"
                        />
                        <path
                          d="M19.1874 11.678V9.22828C19.3133 9.13482 19.4156 9.01324 19.4861 8.87322C19.5567 8.73321 19.5935 8.57865 19.5937 8.42188C19.5937 8.15251 19.4867 7.89419 19.2962 7.70372C19.1057 7.51325 18.8474 7.40625 18.5781 7.40625C18.3087 7.40625 18.0504 7.51325 17.8599 7.70372C17.6694 7.89419 17.5624 8.15251 17.5624 8.42188C17.564 8.46818 17.5688 8.51433 17.5767 8.56L15.9984 10.1058C15.979 10.1245 15.9636 10.1469 15.9532 10.1717C15.9427 10.1964 15.9373 10.2231 15.9374 10.25V10.8594C15.9374 10.9132 15.9588 10.9649 15.9969 11.003C16.035 11.0411 16.0867 11.0625 16.1406 11.0625H16.7499C16.7768 11.0626 16.8035 11.0572 16.8283 11.0468C16.8531 11.0363 16.8755 11.0209 16.8942 11.0016L17.9687 9.90469V11.678C17.8427 11.7713 17.7403 11.8928 17.6697 12.0329C17.5992 12.1729 17.5624 12.3276 17.5624 12.4844C17.5624 12.6412 17.5992 12.7958 17.6697 12.9359C17.7403 13.0759 17.8427 13.1975 17.9687 13.2908V15.9375H17.5624V16.3438H19.1874V13.2908C19.3134 13.1975 19.4158 13.0759 19.4864 12.9359C19.557 12.7958 19.5937 12.6412 19.5937 12.4844C19.5937 12.3276 19.557 12.1729 19.4864 12.0329C19.4158 11.8928 19.3134 11.7713 19.1874 11.678Z"
                          fill="white"
                        />
                        <path
                          d="M7.8125 19.5938H19.1875V16.75H7.8125V19.5938ZM9.03125 17.3594H17.9688C18.1842 17.3594 18.3909 17.445 18.5433 17.5974C18.6956 17.7497 18.7812 17.9564 18.7812 18.1719C18.7812 18.3874 18.6956 18.594 18.5433 18.7464C18.3909 18.8988 18.1842 18.9844 17.9688 18.9844H9.03125C8.81576 18.9844 8.6091 18.8988 8.45673 18.7464C8.30435 18.594 8.21875 18.3874 8.21875 18.1719C8.21875 17.9564 8.30435 17.7497 8.45673 17.5974C8.6091 17.445 8.81576 17.3594 9.03125 17.3594Z"
                          fill="white"
                        />
                        <path
                          d="M9.03125 18.5781H17.9688C18.0765 18.5781 18.1798 18.5353 18.256 18.4591C18.3322 18.383 18.375 18.2796 18.375 18.1719C18.375 18.0641 18.3322 17.9608 18.256 17.8846C18.1798 17.8084 18.0765 17.7656 17.9688 17.7656H9.03125C8.92351 17.7656 8.82017 17.8084 8.74399 17.8846C8.6678 17.9608 8.625 18.0641 8.625 18.1719C8.625 18.2796 8.6678 18.383 8.74399 18.4591C8.82017 18.5353 8.92351 18.5781 9.03125 18.5781Z"
                          fill="white"
                        />
                        <path
                          d="M14.109 10.6562H12.8902C12.8364 10.6562 12.7847 10.6777 12.7466 10.7157C12.7085 10.7538 12.6871 10.8055 12.6871 10.8594V11.4688H12.3418L12.486 11.5642C12.786 11.7649 13.1387 11.872 13.4996 11.872C13.8605 11.872 14.2132 11.7649 14.5132 11.5642L14.6574 11.4688H14.3121V10.8594C14.3121 10.8055 14.2907 10.7538 14.2526 10.7157C14.2145 10.6777 14.1629 10.6562 14.109 10.6562ZM13.9059 11.4688H13.0934V11.0625H13.9059V11.4688Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div *ngSwitchCase="'Assembly'">
                      <svg
                        width="27"
                        height="27"
                        viewBox="0 0 27 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.5 1.1547C12.7376 0.440169 14.2624 0.440169 15.5 1.1547L23.1913 5.5953C24.4289 6.30983 25.1913 7.63034 25.1913 9.0594V17.9406C25.1913 19.3697 24.4289 20.6902 23.1913 21.4047L15.5 25.8453C14.2624 26.5598 12.7376 26.5598 11.5 25.8453L3.80866 21.4047C2.57105 20.6902 1.80866 19.3697 1.80866 17.9406V9.0594C1.80866 7.63034 2.57105 6.30983 3.80866 5.5953L11.5 1.1547Z"
                          fill="#10CE9C"
                        />
                        <g clip-path="url(#clip0)">
                          <path
                            d="M18.9731 16.9459V16.5576C19.3349 16.4076 19.5902 16.0508 19.5902 15.6353C19.5902 15.085 19.1425 14.6372 18.5922 14.6372C18.1777 14.6372 17.8216 14.8912 17.671 15.2517H16.4327C16.4219 14.9873 16.557 14.7343 16.7905 14.5982C17.1925 14.3639 17.2712 13.8161 16.9515 13.478C16.7415 13.2559 16.6941 12.9257 16.833 12.6534C17.0445 12.2389 16.8146 11.7355 16.3628 11.624C16.066 11.5507 15.8476 11.2986 15.8173 10.9944C15.7712 10.5313 15.3056 10.2321 14.8652 10.3825C14.5759 10.4813 14.2559 10.3873 14.0659 10.1478C13.7767 9.78325 13.2233 9.78325 12.9342 10.1478C12.7442 10.3873 12.4241 10.4813 12.1349 10.3825C11.701 10.2343 11.243 10.5227 11.1854 10.9739H9.33118C9.23021 10.7283 9.03403 10.5315 8.78865 10.4298V9.99877C9.30301 9.8129 9.67167 9.31977 9.67167 8.74213C9.67167 8.00551 9.07241 7.40625 8.33588 7.40625C7.59926 7.40625 7 8.00551 7 8.74203C7 9.37234 7.43888 9.90167 8.02693 10.0414V10.4297C7.66512 10.5797 7.40982 10.9365 7.40982 11.352C7.40982 11.9023 7.85753 12.3501 8.40779 12.3501C8.82227 12.3501 9.17844 12.0961 9.32899 11.7356H10.3927C10.1107 11.9353 9.99818 12.3226 10.167 12.6534C10.3059 12.9256 10.2585 13.2558 10.0485 13.478C9.7287 13.816 9.80755 14.3639 10.2095 14.5981C10.4737 14.7521 10.6122 15.0556 10.5556 15.3559C10.4694 15.8132 10.8318 16.2315 11.2968 16.2112C11.6021 16.198 11.8827 16.3784 11.9975 16.6616C12.1722 17.093 12.7033 17.2489 13.0834 16.9805C13.3332 16.8043 13.6668 16.8043 13.9165 16.9805C14.2967 17.2489 14.8277 17.093 15.0024 16.6616C15.1172 16.3784 15.3979 16.198 15.7032 16.2112C15.9098 16.2203 16.096 16.1425 16.2318 16.0134H17.6688C17.7698 16.259 17.966 16.4558 18.2113 16.5575V16.9885C17.697 17.1744 17.3283 17.6675 17.3283 18.2452C17.3283 18.9818 17.9276 19.5811 18.6641 19.5811C19.4007 19.5811 20 18.9818 20 18.2453C20 17.615 19.5611 17.0856 18.9731 16.9459ZM7.76172 8.74203C7.76172 8.42545 8.01929 8.16787 8.33588 8.16787C8.65237 8.16787 8.91005 8.42545 8.91005 8.74203C8.91005 9.05862 8.65247 9.3162 8.33588 9.3162C8.01929 9.3162 7.76172 9.05862 7.76172 8.74203ZM11.291 13.4937C11.291 12.2756 12.2819 11.2847 13.5 11.2847C14.7181 11.2847 15.709 12.2756 15.709 13.4937C15.709 14.7117 14.7181 15.7026 13.5 15.7026C12.2819 15.7026 11.291 14.7117 11.291 13.4937ZM18.6641 18.8194C18.3475 18.8194 18.09 18.5619 18.09 18.2453C18.09 17.9287 18.3476 17.6711 18.6641 17.6711C18.9807 17.6711 19.2383 17.9287 19.2383 18.2453C19.2383 18.5619 18.9807 18.8194 18.6641 18.8194Z"
                            fill="white"
                          />
                          <path
                            d="M13.5 14.9409C14.298 14.9409 14.9473 14.2917 14.9473 13.4937C14.9473 12.6956 14.298 12.0464 13.5 12.0464C12.702 12.0464 12.0527 12.6956 12.0527 13.4937C12.0527 14.2917 12.702 14.9409 13.5 14.9409Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0">
                            <rect
                              width="13"
                              height="13"
                              fill="white"
                              transform="translate(7 7)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div *ngSwitchCase="'SubAssembly'">
                      <svg
                        width="27"
                        height="27"
                        viewBox="0 0 27 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.5 1.1547C12.7376 0.440169 14.2624 0.440169 15.5 1.1547L23.1913 5.5953C24.4289 6.30983 25.1913 7.63034 25.1913 9.0594V17.9406C25.1913 19.3697 24.4289 20.6902 23.1913 21.4047L15.5 25.8453C14.2624 26.5598 12.7376 26.5598 11.5 25.8453L3.80866 21.4047C2.57105 20.6902 1.80866 19.3697 1.80866 17.9406V9.0594C1.80866 7.63034 2.57105 6.30983 3.80866 5.5953L11.5 1.1547Z"
                          fill="#10CE9C"
                        />
                        <path
                          d="M17.9688 11.4688H17.5625V11.0625C17.5625 10.838 17.3807 10.6563 17.1562 10.6563H16.75V9.03125H16.9531C17.0652 9.03125 17.1562 8.94025 17.1562 8.82813V8.42188C17.1562 8.30975 17.0652 8.21875 16.9531 8.21875H14.4557C14.4943 8.34753 14.5156 8.48383 14.5156 8.625C14.5156 8.76617 14.4943 8.90247 14.4557 9.03125H15.9375V10.6563H15.5312C15.3068 10.6563 15.125 10.838 15.125 11.0625V11.4688H14.7188C13.8213 11.4688 13.0938 12.1963 13.0938 13.0938V13.5C13.0938 14.3285 13.7143 15.0108 14.5156 15.111V14.3125C14.5156 14.303 14.5181 14.294 14.5185 14.2847C14.1671 14.1951 13.9062 13.8792 13.9062 13.5V13.0938C13.9062 12.645 14.27 12.2813 14.7188 12.2813H15.9375V12.6875C15.9375 12.912 16.1193 13.0938 16.3438 13.0938C16.5682 13.0938 16.75 12.912 16.75 12.6875V12.2813H17.9688C18.4175 12.2813 18.7812 12.645 18.7812 13.0938V13.5C18.7812 13.8792 18.5204 14.1951 18.169 14.2847C18.1694 14.294 18.1719 14.303 18.1719 14.3125V15.111C18.9732 15.0108 19.5938 14.3285 19.5938 13.5V13.0938C19.5938 12.1963 18.8662 11.4688 17.9688 11.4688Z"
                          fill="white"
                        />
                        <path
                          d="M16.9531 14.9219V14.1094H15.7344V14.9219H16.1406V14.5156H16.5469V14.9219H16.9531Z"
                          fill="white"
                        />
                        <path
                          d="M18.5781 17.7656V16.9531H17.5625H17.3594V17.7656H17.7656V17.3594H18.1719V17.7656H18.5781Z"
                          fill="white"
                        />
                        <path
                          d="M14.1094 17.7656H14.5156V17.3594H14.9219V17.7656H15.3281V16.9531H15.125H14.1094V17.7656Z"
                          fill="white"
                        />
                        <path
                          d="M19.1875 16.9531H18.9844V18.1719H16.9531V16.9531H16.75C16.6379 16.9531 16.5469 17.0443 16.5469 17.1562V19.1875C16.5469 19.2994 16.6379 19.3906 16.75 19.3906H19.1875C19.2996 19.3906 19.3906 19.2994 19.3906 19.1875V17.1562C19.3906 17.0443 19.2996 16.9531 19.1875 16.9531Z"
                          fill="white"
                        />
                        <path
                          d="M15.9375 16.9531H15.7344V18.1719H13.7031V16.9531H13.5C13.3879 16.9531 13.2969 17.0443 13.2969 17.1562V19.1875C13.2969 19.2994 13.3879 19.3906 13.5 19.3906H15.9375C16.0496 19.3906 16.1406 19.2994 16.1406 19.1875V17.1562C16.1406 17.0443 16.0496 16.9531 15.9375 16.9531Z"
                          fill="white"
                        />
                        <path
                          d="M15.125 14.1094C15.0129 14.1094 14.9219 14.2006 14.9219 14.3125V16.3438C14.9219 16.4557 15.0129 16.5469 15.125 16.5469H15.9375H16.75H17.5625C17.6746 16.5469 17.7656 16.4557 17.7656 16.3438V14.3125C17.7656 14.2006 17.6746 14.1094 17.5625 14.1094H17.3594V15.3281H15.3281V14.1094H15.125Z"
                          fill="white"
                        />
                        <path
                          d="M10.4531 12.2812C10.4531 11.5004 9.82039 10.8653 9.041 10.8598L9.03389 10.8596V10.8594C9.03287 10.8596 9.03206 10.8594 9.03125 10.8594C8.24739 10.8594 7.60938 11.4972 7.60938 12.2812C7.60938 13.0653 8.24739 13.7031 9.03125 13.7031C9.81511 13.7031 10.4531 13.0653 10.4531 12.2812ZM8.21875 12.2812C8.21875 11.8325 8.58255 11.4688 9.03125 11.4688C9.47995 11.4688 9.84375 11.8325 9.84375 12.2812C9.84375 12.73 9.47995 13.0938 9.03125 13.0938C8.58255 13.0938 8.21875 12.73 8.21875 12.2812Z"
                          fill="white"
                        />
                        <path
                          d="M11.7395 9.05685L9.58984 10.5407C10.1005 10.705 10.5139 11.0877 10.7188 11.5787L12.3156 9.81309C12.0458 9.63596 11.8397 9.37007 11.7395 9.05685Z"
                          fill="white"
                        />
                        <path
                          d="M8.44687 14.0122L9.1962 17.0977L11.0944 17.3824L10.0942 13.7658C9.7942 13.9811 9.42776 14.1095 9.03106 14.1095C8.82671 14.1095 8.6307 14.0744 8.44687 14.0122Z"
                          fill="white"
                        />
                        <path
                          d="M14.1094 8.625C14.1094 8.06498 13.6538 7.60938 13.0938 7.60938C12.5337 7.60938 12.0781 8.06498 12.0781 8.625C12.0781 9.18502 12.5337 9.64062 13.0938 9.64062C13.6538 9.64062 14.1094 9.18502 14.1094 8.625ZM12.6875 8.625C12.6875 8.40055 12.8693 8.21875 13.0938 8.21875C13.3182 8.21875 13.5 8.40055 13.5 8.625C13.5 8.84945 13.3182 9.03125 13.0938 9.03125C12.8693 9.03125 12.6875 8.84945 12.6875 8.625Z"
                          fill="white"
                        />
                        <path
                          d="M11.5591 17.8626L11.236 17.8141L11.2157 17.8198L11.2132 17.8106L8.42188 17.392V19.3905H12.0781V18.4653C12.0781 18.1612 11.86 17.9077 11.5591 17.8626Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div *ngSwitchCase="'Component'">
                      <svg
                        width="27"
                        height="27"
                        viewBox="0 0 27 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.5 1.1547C12.7376 0.440169 14.2624 0.440169 15.5 1.1547L23.1913 5.5953C24.4289 6.30983 25.1913 7.63034 25.1913 9.0594V17.9406C25.1913 19.3697 24.4289 20.6902 23.1913 21.4047L15.5 25.8453C14.2624 26.5598 12.7376 26.5598 11.5 25.8453L3.80866 21.4047C2.57105 20.6902 1.80866 19.3697 1.80866 17.9406V9.0594C1.80866 7.63034 2.57105 6.30983 3.80866 5.5953L11.5 1.1547Z"
                          fill="#10CE9C"
                        />
                        <g clip-path="url(#clip0)">
                          <path
                            d="M19.7396 12.7307L18.6543 12.3689C18.6198 12.2116 18.5781 12.0556 18.5294 11.9022L19.2883 11.0464C19.3971 10.9237 19.4152 10.7452 19.3332 10.6033L18.9253 9.89674C18.8433 9.75478 18.6798 9.6812 18.5191 9.71403L17.3962 9.94376C17.2882 9.82552 17.1746 9.71187 17.0563 9.60368L17.286 8.48096C17.3189 8.32034 17.2453 8.15672 17.1033 8.07476L16.3967 7.66681C16.2548 7.58485 16.0763 7.60287 15.9536 7.7117L15.0978 8.4706C14.9445 8.42193 14.7886 8.38016 14.6311 8.34565L14.2693 7.26041C14.2174 7.10489 14.0718 7 13.9079 7H13.092C12.9281 7 12.7826 7.10489 12.7308 7.26038L12.3689 8.34563C12.2115 8.38016 12.0555 8.4219 11.9022 8.47057L11.0464 7.7117C10.9237 7.6029 10.7452 7.58487 10.6033 7.66681L9.89671 8.07476C9.75473 8.15672 9.68115 8.32034 9.71403 8.48096L9.94376 9.60368C9.82542 9.71185 9.7118 9.82549 9.60378 9.94376L8.48093 9.71403C8.32029 9.68117 8.1567 9.75478 8.07476 9.89674L7.66683 10.6033C7.58485 10.7452 7.60293 10.9238 7.71172 11.0464L8.47062 11.9022C8.4219 12.0556 8.38018 12.2116 8.34575 12.3689L7.26043 12.7307C7.10489 12.7826 7 12.9281 7 13.092V13.908C7 14.0719 7.10491 14.2174 7.26046 14.2693L8.3457 14.6309C8.38013 14.7883 8.42188 14.9443 8.4706 15.0978L7.7117 15.9536C7.60293 16.0763 7.58485 16.2548 7.66681 16.3967L8.07473 17.1033C8.15672 17.2452 8.32024 17.3188 8.48091 17.286L9.60376 17.0562C9.71182 17.1745 9.82542 17.2882 9.94374 17.3962L9.714 18.519C9.68115 18.6796 9.75473 18.8433 9.89669 18.9252L10.6033 19.3331C10.7453 19.4151 10.9237 19.397 11.0464 19.2882L11.9022 18.5294C12.0556 18.578 12.2115 18.6198 12.3689 18.6542L12.7307 19.7395C12.7826 19.8951 12.9281 19.9999 13.092 19.9999H13.9079C14.0718 19.9999 14.2174 19.8951 14.2692 19.7395L14.631 18.6542C14.7884 18.6198 14.9443 18.578 15.0978 18.5294L15.9535 19.2882C16.0762 19.397 16.2547 19.4151 16.3967 19.3331L17.1032 18.9252C17.2452 18.8433 17.3188 18.6796 17.2859 18.519L17.0562 17.3962C17.1745 17.2882 17.2881 17.1745 17.3962 17.0562L18.519 17.286C18.6797 17.3189 18.8433 17.2452 18.9252 17.1033L19.3331 16.3967C19.4151 16.2548 19.397 16.0762 19.2882 15.9536L18.5293 15.0978C18.578 14.9443 18.6198 14.7883 18.6542 14.6309L19.7395 14.2693C19.895 14.2174 19.9999 14.0719 19.9999 13.908V13.092C20 12.9281 19.8951 12.7826 19.7396 12.7307ZM14.9822 10.1705L13.9494 11.9597C13.6515 11.8728 13.3397 11.8765 13.0509 11.9607L12.0182 10.1722C12.9383 9.76392 14.0156 9.73934 14.9822 10.1705ZM14.343 13.5C14.343 13.9648 13.9648 14.343 13.5 14.343C13.0352 14.343 12.657 13.9648 12.657 13.5C12.657 13.0352 13.0352 12.657 13.5 12.657C13.9648 12.657 14.343 13.0352 14.343 13.5ZM11.3587 10.553L12.3914 12.3415C12.1741 12.5496 12.0151 12.8177 11.9414 13.1192H9.87546C9.98528 12.0664 10.5452 11.1457 11.3587 10.553ZM11.3587 16.447C10.5452 15.8543 9.9853 14.9336 9.87546 13.8809H11.9414C12.0151 14.1823 12.1741 14.4505 12.3914 14.6585L11.3587 16.447ZM12.0178 16.8295L13.0506 15.0403C13.3485 15.1272 13.6603 15.1235 13.9491 15.0393L14.9818 16.8278C14.0617 17.2361 12.9844 17.2607 12.0178 16.8295ZM15.6413 16.447L14.6086 14.6585C14.8259 14.4504 14.9849 14.1823 15.0586 13.8809H17.1245C17.0147 14.9336 16.4548 15.8543 15.6413 16.447ZM15.0587 13.1191C14.985 12.8177 14.8259 12.5495 14.6087 12.3415L15.6413 10.5529C16.4548 11.1457 17.0147 12.0664 17.1246 13.1191H15.0587V13.1191Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0">
                            <rect
                              width="13"
                              height="13"
                              fill="white"
                              transform="translate(7 7)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  </div>
                </div>
                <p class="tree-text-main"></p>
                <p
                  class="tree-text"
                  [ngStyle]="{ cursor: node.Level === 'Unit' ? 'pointer' : '' }"
                >
                  {{ replaceIcon(node.icon) }}{{ node.text }}
                </p>
              </div>
              <ul
                [ngClass]="
                  !treeControl.isExpanded(node)
                    ? 'node-invisible'
                    : 'node-visible'
                "
              >
                <ng-container matTreeNodeOutlet></ng-container>
              </ul>
            </li>
          </mat-nested-tree-node>
        </mat-tree>
      </div>
    </div>
  </div>

  <!-- quality check list execution -->

  <ng-template #imageZoomModel>
    <img
      src="{{ currentImagePath }}"
      style="height: 98%; width: 100%; overflow: hidden"
    />
  </ng-template>

  <ng-template #imageZoomModelShow>
    <img
      [src]="currentImagePath"
      style="height: 98%; width: 100%; overflow: hidden"
    />
  </ng-template>

  <ng-template #checklistExecutionModal>
    <div mat-dialog-title>
      <div class="d-flex justify-content-between align-items-center">
        <h1 mat-dialog-title>
          {{
            langObj
              ? langObj?.ChecklistExecution
              : ("ChecklistExecution" | translate)
          }}
        </h1>
        <button
          mat-mini-fab
          mat-button
          mat-dialog-close
          color="warn"
          title="close"
        >
          <i class="fa fa-times" style="color: #fff"></i>
        </button>
      </div>
    </div>
    <form [formGroup]="checklistDataForm">
      <mat-dialog-content>
        <div class="content-top-row content-top-row-order-processing">
          <mat-form-field
            appearence="fill"
            class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="margin-left: 0px"
          >
            <mat-label class="required"
              >{{
                langObj ? langObj?.ChecklistType : ("ChecklistType" | translate)
              }}
            </mat-label>
            <input
              matInput
              formControlName="checktype"
              placeholder="Enter List Type"
              readonly
            />
          </mat-form-field>
          <mat-form-field
            appearence="fill"
            class="top-row-first-filed-item top-row-first-filed-item-order-processing"
          >
            <mat-label class="required"
              >{{
                langObj ? langObj?.ChecklistName : ("ChecklistName" | translate)
              }}
            </mat-label>
            <input
              matInput
              formControlName="checkname"
              placeholder="Enter List Name"
              readonly
            />
          </mat-form-field>
          <mat-form-field
            appearence="fill"
            class="top-row-first-filed-item top-row-first-filed-item-order-processing"
          >
            <mat-label>{{
              langObj ? langObj?.Area : ("Area" | translate)
            }}</mat-label>
            <input
              matInput
              formControlName="area"
              placeholder="Enter area Name"
              readonly
            />
            <mat-error
              >{{
                langObj ? langObj?.PleaseSelect : ("PleaseSelect" | translate)
              }}
              {{ langObj ? langObj?.Area : ("Area" | translate) }}</mat-error
            >
          </mat-form-field>
          <div class="inputField" style="width: 295px">
            <nz-date-picker
              (ngModelChange)="getDateShifts($event)"
              class="calender-input"
              formControlName="executionDate"
              id="timePicker1"
              nzFormat="dd/MM/yyyy HH:mm"
              [nzShowTime]="{ nzFormat: 'HH:mm' }"
              [nzInputReadOnly]="true"
            >
            </nz-date-picker>
            <span class="floating-text">{{
              langObj ? langObj?.Date : ("Date" | translate)
            }}</span>
          </div>
          <mat-form-field
            appearence="fill"
            class="top-row-first-filed-item top-row-first-filed-item-order-processing"
          >
            <mat-label class="required">{{
              langObj ? langObj?.Shift : ("Shift" | translate)
            }}</mat-label>
            <input matInput formControlName="shiftName" readonly />
          </mat-form-field>
          <input
            matInput
            formControlName="shift"
            style="display: none"
            readonly
            placeholder="Shift"
          />
        </div>

        <div class="content-top-row content-top-row-order-processing">
          <mat-form-field
            appearence="fill"
            class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="margin-left: 0px"
          >
            <mat-label
              >{{ langObj ? langObj?.Previous : ("Previous" | translate) }}
              {{
                langObj
                  ? langObj?.ProcessOrderNo
                  : ("ProcessOrderNo" | translate)
              }}</mat-label
            >
            <input
              matInput
              formControlName="previousProcessOrder"
              [readonly]="isAuto2"
            />
            <input
              matInput
              formControlName="previousProcessOrderId"
              style="display: none"
              [readonly]="isAuto2"
            />
          </mat-form-field>
          <mat-form-field
            appearence="fill"
            class="top-row-first-filed-item top-row-first-filed-item-order-processing"
          >
            <mat-label
              >{{ langObj ? langObj?.Previous : ("Previous" | translate) }}
              {{
                langObj ? langObj?.ProductName : ("ProductName" | translate)
              }}</mat-label
            >
            <input
              matInput
              placeholder="Product Description"
              formControlName="previousProductName"
              [readonly]="preAuto2"
            />
          </mat-form-field>
        </div>
      </mat-dialog-content>

      <mat-divider></mat-divider>
      <div style="margin-top: 10px"></div>

      <table
        mat-table
        [dataSource]="checkListAddModel"
        class="basic-table plant-model-table popup"
        matSort
      >
        <ng-container matColumnDef="items">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <p class="header-text">
              {{ langObj ? langObj?.Items : ("Items" | translate) }}
            </p>
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="td-text"
            style="padding-left: 80px; width: 30%"
          >
            {{ element.itemName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="good">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            style="padding-left: 0px"
          >
            <p class="header-text">
              {{ langObj ? langObj?.GoodExample : ("GoodExample" | translate) }}
            </p>
          </th>
          <td
            mat-cell
            *matCellDef="let element; let i = index"
            style="width: 10%"
          >
            <img
              [src]="
                element.goodExampleImage !== ''
                  ? element.goodExampleImage
                  : 'assets/images/no-image.png'
              "
              width="30px"
              height="30px"
              (click)="
                imageZoomModal(
                  element.goodExampleImage !== ''
                    ? element.goodExampleImage
                    : 'assets/images/no-image.png'
                )
              "
            />
          </td>
        </ng-container>

        <ng-container matColumnDef="bad">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            style="padding-left: 0px"
          >
            <p class="header-text">
              {{ langObj ? langObj?.BadExample : ("BadExample" | translate) }}
            </p>
          </th>
          <td
            mat-cell
            *matCellDef="let element; let i = index"
            style="width: 10%"
          >
            <img
              [src]="
                element.badExampleImage !== ''
                  ? element.badExampleImage
                  : 'assets/images/no-image.png'
              "
              width="30px"
              height="30px"
              (click)="
                imageZoomModal(
                  element.badExampleImage !== ''
                    ? element.badExampleImage
                    : 'assets/images/no-image.png'
                )
              "
            />
          </td>
        </ng-container>

        <ng-container matColumnDef="score">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <p class="header-text">
              {{ langObj ? langObj?.Result : ("Result" | translate) }}
            </p>
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            style="width: 30%; background-color: #edf1e5"
          >
            <mat-radio-group
              required
              aria-label="Select an option"
              [value]="element.score"
              (change)="scoreUpdate($event, element); onChangeradio($event)"
              *ngIf="element.itemType === 1"
            >
              <mat-radio-button
                *ngFor="let p of categoryTypeDDL"
                [value]="p.id"
                style="margin-left: 10px"
                >{{ p.name }}
              </mat-radio-button>
            </mat-radio-group>

            <mat-form-field
              appearance="fill"
              class="score field-fill-table"
              *ngIf="element.itemType === 2"
              style="width: 180px"
            >
              <input
                matInput
                autocomplete="off"
                (change)="scoreUpdate($event, element)"
                [value]="element.score"
              />
            </mat-form-field>
            <div
              appearance="fill"
              class="field-fill"
              *ngIf="element.itemType === 4"
              style="width: 180px"
            >
              <input
                [placeholder]="
                  langObj ? langObj?.UploadFile : ('UploadFile' | translate)
                "
                type="file"
                (change)="uploadedFile($event, element.checkListDetailId)"
                class="form-control"
                accept=".png, .jpg"
              />
            </div>
            <mat-form-field
              appearence="fill"
              class="field-fill"
              *ngIf="element.itemType === 3"
            >
              <mat-label class="placeholder-title"
                >{{ langObj ? langObj?.FromDate : ("FromDate" | translate) }}
              </mat-label>
              <input
                matInput
                [matDatepicker]="pickerspoedit"
                (dateInput)="onDateChange($event, element)"
                style="width: 180px"
                [readonly]="true"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="pickerspoedit"
              ></mat-datepicker-toggle>
              <mat-datepicker #pickerspoedit></mat-datepicker>
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="remarks">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <p class="header-text">
              {{ langObj ? langObj?.Remarks : ("Remarks" | translate) }}
            </p>
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            style="width: 30%; background-color: #edf1e5"
          >
            <mat-form-field
              appearance="fill"
              class="field-fill-table"
              style="width: 100%"
            >
              <input
                matInput
                [placeholder]="
                  langObj ? langObj?.Remarks : ('Remarks' | translate)
                "
                autocomplete="off"
                (change)="remarksUpdate($event, element)"
                [value]="element.remarks"
              />
            </mat-form-field>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="itemColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: itemColumns"></tr>
        <tr class="mat-row" *matNoDataRow style="text-align: center">
          <td class="mat-cell" style="text-align: center" colspan="7">
            {{ langObj ? langObj?.NoDataFound : ("NoDataFound" | translate) }}
          </td>
        </tr>

        <!-- Group header -->
        <ng-container matColumnDef="groupHeader">
          <th
            (click)="groupHeaderClick(group)"
            colspan="999"
            mat-header-cell
            *matCellDef="let group"
            class="group-header"
          >
            <div class="d-flex align-items-center">
              <mat-icon *ngIf="group.expanded">arrow_drop_down</mat-icon>
              <mat-icon *ngIf="!group.expanded">arrow_right</mat-icon>
              <span class="table-group-title">{{
                group[groupByColumns[group.level - 1]]
              }}</span>
            </div>
          </th>
        </ng-container>
        <tr
          mat-header-row
          *matRowDef="let group; columns: ['groupHeader']; when: isGroup"
        ></tr>
        <mat-row *matRowDef="let row; columns: ['groupHeader']; when: isGroup">
        </mat-row>
      </table>
    </form>
    <div mat-dialog-actions style="float: right; margin-top: 10px">
      <button
        mat-mini-fab
        mat-button
        color="primary"
        [disabled]="!checklistDataForm.valid"
        (click)="addCheckListExecution()"
        *ngIf="IsWrite"
        [pTooltip]="
          langObj ? langObj?.AddExecution : ('AddExecution' | translate)
        "
        tooltipPosition="top"
      >
        <i class="fa fa-floppy-o" style="color: #fff"></i>
      </button>
    </div>
  </ng-template>

  <ng-template #qualityBoolListModal>
    <div mat-dialog-title>
      <div class="d-flex justify-content-between align-items-center">
        <h2>{{ selectionName }} Selection</h2>

        <button
          mat-mini-fab
          mat-button
          mat-dialog-close
          color="warn"
          title="close"
        >
          <i class="fa fa-times" style="color: #fff"></i>
        </button>
      </div>
    </div>
    <mat-dialog-content>
      <div class="wrapper-box wrapper-box-shadow table-wrapper">
        <div class="content-top-row">
          <mat-form-field
            class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="width: 55%"
          >
            <mat-label>Select {{ selectionName }}</mat-label>
            <mat-select [(ngModel)]="qualityBoolVal">
              <mat-option *ngFor="let value of boolList" [value]="value">
                {{ value }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <!-- <mat-label>Select {{selectionName}}</mat-label>
          <select class="form-control" id="roles" name="rolevalue" #roleControl="ngModel" [(ngModel)]="qualityBoolVal">
            <option *ngFor="let value of boolList" value="{{ value }}">
              {{ value }}
            </option>
          </select> -->
          <button
            mat-mini-fab
            mat-button
            color="primary"
            title="Save Color"
            style="margin-left: 10px"
            (click)="saveBool(qualityBoolVal)"
          >
            <i class="fa fa-floppy-o" style="color: #fff"></i>
          </button>
        </div>
      </div>
    </mat-dialog-content>
  </ng-template>

  <div
    class="sidepanel-model-wrapper open-plant-group-model"
    [ngClass]="{ active: isParamterValuesModelVisible }"
  >
    <div
      class="sidepanel-close"
      (click)="closeParamterValuesModelVisible()"
    ></div>
    <div class="model-content">
      <div class="model-top">
        <h2 class="model-title">{{ langObj? langObj?.ParameterValues : ('ParameterValues' | translate) }}</h2>
        <button
          mat-icon-button
          class="model-close-btn"
          aria-label="Close model"
          (click)="closeParamterValuesModelVisible()"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.46 7L14 12.54V14H12.54L7 8.46L1.46 14H0V12.54L5.54 7L0 1.46V0H1.46L7 5.54L12.54 0H14V1.46L8.46 7Z"
              fill="black"
            />
          </svg>
        </button>
      </div>
    </div>
    <ng-template #visibleYearlyTarget style="padding-bottom: 0px !important">
      <div mat-dialog-title>
        <div class="d-flex justify-content-between align-items-center">
          <h2>{{ langObj? langObj?.ParameterAnalysis : ('ParameterAnalysis' | translate) }}</h2>
          <button
            mat-mini-fab
            mat-button
            mat-dialog-close
            color="warn"
            title="close"
          >
            <i class="fa fa-times" style="color: #fff"></i>
          </button>
        </div>
        <div class="p-grid p-fluid">
          <div class="content-top-row">
            <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="width: 250px">
            <!-- <mat-label> {{ langObj ? langObj?.DateRangeScorecard : ("DateRangeScorecard" | translate) }}</mat-label> -->
            <mat-date-range-input [formGroup]="range" [rangePicker]="picker1">
              <input matStartDate formControlName="fromDate" placeholder="From Date" [readOnly]="true" />
              <input matEndDate formControlName="toDate" placeholder="To Date" [readOnly]="true" />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-date-range-picker #picker1 ></mat-date-range-picker>
          </mat-form-field>
          </div>
          <div class="p-col-12 p-md-6 inputField">
            <label
              >{{ langObj ? langObj?.Products : ("Products" | translate) }}
            </label>
            <p-multiSelect
              class="form-select"
              inputId="multiselect"
              [options]="machineProducts"
              optionLabel="Prod_Desc"
              [filter]="true"
              [(ngModel)]="selectedProducts"
              selectedItemsLabel="ALL"
              maxSelectedLabels="{{ machineProducts.length - 1 }}"
            >
            </p-multiSelect>
          </div>
          <div class="p-col-12 p-md-6 inputField_btn">
            <button
              (click)="onChangeParamterAnalysisProcess()"
              mat-flat-button
              color="accent"
              type="submit"
              class="btn-accent"
            >
            {{ langObj? langObj?.Search : ('Search' | translate) }}
            </button>
          </div>
        </div>
      </div>
      <mat-dialog-content class="chartpopup">
        <!-- <canvas  style="width: 600px ;padding: 0px;" id="POClosed"></canvas>   -->
        <div *ngFor="let item of chartArray">
          <div [id]="item.id" [chart]="item.chartOption"></div>
        </div>
        <!-- <div [chart]="stock"></div> -->
      </mat-dialog-content>
    </ng-template>
    <ng-template
      #visibleParameterComparison
      style="padding-bottom: 0px !important"
    >
      <div mat-dialog-title>
        <div class="d-flex justify-content-between align-items-center">
          <h2>{{ langObj? langObj?.ParameterComparison : ('ParameterComparison' | translate) }}</h2>
          <button
            mat-mini-fab
            mat-button
            mat-dialog-close
            color="warn"
            title="close"
          >
            <i class="fa fa-times" style="color: #fff"></i>
          </button>
        </div>
        <div class="p-grid p-fluid">
          <div class="content-top-row">
            <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="width: 250px">
            <!-- <mat-label> {{ langObj ? langObj?.DateRangeScorecard : ("DateRangeScorecard" | translate) }}</mat-label> -->
            <mat-date-range-input [formGroup]="range" [rangePicker]="picker1">
              <input matStartDate formControlName="fromDate" placeholder="From Date" [readOnly]="true" />
              <input matEndDate formControlName="toDate" placeholder="To Date" [readOnly]="true" />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-date-range-picker #picker1 ></mat-date-range-picker>
          </mat-form-field>
          </div>
          <div class="p-col-12 p-md-6 inputField">
            <label
              >{{ langObj ? langObj?.Products : ("Products" | translate) }}
            </label>
            <p-multiSelect
              class="form-select"
              inputId="multiselect"
              [options]="machineProducts"
              optionLabel="Prod_Desc"
              [filter]="true"
              [(ngModel)]="selectedProducts"
              selectedItemsLabel="ALL"
              maxSelectedLabels="{{ machineProducts.length - 1 }}"
            >
            </p-multiSelect>
          </div>
          <div class="p-col-12 p-md-6 inputField_btn">
            <button
              (click)="onChangeParamterComparisionProcess()"
              mat-flat-button
              color="accent"
              type="submit"
              class="btn-accent"
            >
            {{ langObj ? langObj?.Search : ("Search" | translate) }}
            </button>
          </div>
        </div>
      </div>
      <mat-dialog-content class="chartpopup">
        <div [chart]="chart"></div>
      </mat-dialog-content>
    </ng-template>
  </div>

  <ng-template #displayProcessOrdersModal>
    <div mat-dialog-title>
      <div class="d-flex justify-content-between align-items-center">
        <h2>{{ langObj? langObj?.HistoryProcessOrder : ('HistoryProcessOrder' | translate) }}</h2>

        <button
          mat-mini-fab
          mat-button
          mat-dialog-close
          color="warn"
          title="close"
        >
          <i class="fa fa-times" style="color: #fff"></i>
        </button>
      </div>
    </div>
    <mat-dialog-content>
      <div class="wrapper-box wrapper-box-shadow table-wrapper">
        <div
          class="d-flex justify-content-end ; content-top-row content-top-row-order-processing"
        >
          <mat-form-field
            appearence="fill"
            class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="width: 400px; margin-right: 0px"
          >
            <input
              matInput
              placeholder="Search"
              (keyup)="PControllapplyFilter($event)"
              autocomplete="off"
            />
          </mat-form-field>
        </div>

        <div class="content-row-flex-both-end">
          <!--table-->
          <table
            mat-table
            class="basic-table plant-model-table"
            matSort
            [dataSource]="ProcessOrder"
          >
            <ng-container matColumnDef="ProcessOrder">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{ langObj ? langObj?.ProcessOrderNo : ("ProcessOrderNo" | translate) }}</p>
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.ProcessOrder }}
              </td>
            </ng-container>

            <ng-container matColumnDef="ProdCode">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{ langObj ? langObj?.ProductCode : ("ProductCode" | translate) }}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{ element.ProdCode }}</td>
            </ng-container>

            <ng-container matColumnDef="ProdDesc">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{ langObj ? langObj?.ProductDescription : ("ProductDescription" | translate) }}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{ element.ProdDesc }}</td>
            </ng-container>

            <ng-container matColumnDef="StartTime">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{ langObj ? langObj?.StartTime : ("StartTime" | translate) }}</p>
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.StartTime | date: "dd-MM-yyyy HH:mm:ss" }}
              </td>
            </ng-container>

            <ng-container matColumnDef="EndTime">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{ langObj ? langObj?.EndTime : ("EndTime" | translate) }}</p>
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.EndTime | date: "dd-MM-yyyy HH:mm:ss" }}
              </td>
            </ng-container>

            <tr
              mat-header-row
              *matHeaderRowDef="processmodalordersColumns"
            ></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: processmodalordersColumns"
            ></tr>
          </table>
        </div>
        <mat-paginator
          class="basic-paginataor"
          [pageSizeOptions]="[10, 20]"
          showFirstLastButtons
        ></mat-paginator>
      </div>
    </mat-dialog-content>
  </ng-template>

  <div
    class="sidepanel-model-wrapper open-plant-group-model"
    [ngClass]="{ active: isParamterValuesModelVisible }"
  >
    <div
      class="sidepanel-close"
      (click)="closeParamterValuesModelVisible()"
    ></div>
    <div class="model-content">
      <div class="model-top">
        <h2 class="model-title">{{ langObj ? langObj?.ParamterValues : ("ParamterValues" | translate) }}</h2>
        <button
          mat-icon-button
          class="model-close-btn"
          aria-label="Close model"
          (click)="closeParamterValuesModelVisible()"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.46 7L14 12.54V14H12.54L7 8.46L1.46 14H0V12.54L5.54 7L0 1.46V0H1.46L7 5.54L12.54 0H14V1.46L8.46 7Z"
              fill="black"
            />
          </svg>
        </button>
      </div>
    </div>
    <ng-template
      #visibleYearlyTargetQuality
      style="padding-bottom: 0px !important"
    >
      <div mat-dialog-title>
        <div class="d-flex justify-content-between align-items-center">
          <h2>{{ langObj ? langObj?.ParameterAnalysis : ("ParameterAnalysis" | translate) }}</h2>
          <button
            mat-mini-fab
            mat-button
            mat-dialog-close
            color="warn"
            title="close"
          >
            <i class="fa fa-times" style="color: #fff"></i>
          </button>
        </div>
        <div class="p-grid p-fluid">
          <div class="content-top-row">
            <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="width: 250px">
            <!-- <mat-label> {{ langObj ? langObj?.DateRangeScorecard : ("DateRangeScorecard" | translate) }}</mat-label> -->
            <mat-date-range-input [formGroup]="range" [rangePicker]="picker1">
              <input matStartDate formControlName="fromDate" placeholder="From Date" [readOnly]="true" />
              <input matEndDate formControlName="toDate" placeholder="To Date" [readOnly]="true" />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-date-range-picker #picker1 ></mat-date-range-picker>
          </mat-form-field>
          </div>
          <div class="p-col-12 p-md-6 inputField">
            <label
              >{{ langObj ? langObj?.Products : ("Products" | translate) }}
            </label>
            <p-multiSelect
              class="form-select"
              inputId="multiselect"
              [options]="machineProducts"
              optionLabel="Prod_Desc"
              [filter]="true"
              [(ngModel)]="selectedProducts"
              selectedItemsLabel="ALL"
              maxSelectedLabels="{{ machineProducts.length - 1 }}"
            >
            </p-multiSelect>
          </div>
          <div class="p-col-12 p-md-6 inputField_btn">
            <button
              (click)="onChangeParameterAnalysisQuality()"
              mat-flat-button
              color="accent"
              type="submit"
              class="btn-accent"
            >
            {{ langObj ? langObj?.Search : ("Search" | translate) }}
            </button>
          </div>
        </div>
      </div>
      <mat-dialog-content class="chartpopup">
        <!-- <canvas  style="width: 600px ;padding: 0px;" id="POClosed"></canvas>   -->
        <div id="POClosed"></div>
        <div *ngFor="let item of chartArray">
          <div [id]="item.id" [chart]="item.chartOption"></div>
        </div>
        <!-- <div [chart]="stock"></div> -->
      </mat-dialog-content>
    </ng-template>
    <ng-template
      #visibleParameterComparisonQuality
      style="padding-bottom: 0px !important"
    >
      <div mat-dialog-title>
        <div class="d-flex justify-content-between align-items-center">
          <h2>{{ langObj ? langObj?.ParameterComparison : ("ParameterComparison" | translate) }}</h2>
          <button
            mat-mini-fab
            mat-button
            mat-dialog-close
            color="warn"
            title="close"
          >
            <i class="fa fa-times" style="color: #fff"></i>
          </button>
        </div>
        <div class="p-grid p-fluid">
          <div class="content-top-row">
            <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="width: 250px">
            <!-- <mat-label> {{ langObj ? langObj?.DateRangeScorecard : ("DateRangeScorecard" | translate) }}</mat-label> -->
            <mat-date-range-input [formGroup]="range" [rangePicker]="picker1">
              <input matStartDate formControlName="fromDate" placeholder="From Date" [readOnly]="true" />
              <input matEndDate formControlName="toDate" placeholder="To Date" [readOnly]="true" />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-date-range-picker #picker1 ></mat-date-range-picker>
          </mat-form-field>
          </div>
          <div class="p-col-12 p-md-6 inputField">
            <label
              >{{ langObj ? langObj?.Products : ("Products" | translate) }}
            </label>
            <p-multiSelect
              class="form-select"
              inputId="multiselect"
              [options]="machineProducts"
              optionLabel="Prod_Desc"
              [filter]="true"
              [(ngModel)]="selectedProducts"
              selectedItemsLabel="ALL"
              maxSelectedLabels="{{ machineProducts.length - 1 }}"
            >
            </p-multiSelect>
          </div>
          <div class="p-col-12 p-md-6 inputField_btn">
            <button
              (click)="onChangeParamterComparsionQuality()"
              mat-flat-button
              color="accent"
              type="submit"
              class="btn-accent"
            >
            {{ langObj ? langObj?.Search : ("Search" | translate) }}
            </button>
          </div>
        </div>
      </div>
      <mat-dialog-content class="chartpopup">
        <div [chart]="chart"></div>
      </mat-dialog-content>
    </ng-template>
  </div>

  <ng-template #displayQualityOrdersModal>
    <div mat-dialog-title>
      <div class="d-flex justify-content-between align-items-center">
        <h2>{{ langObj ? langObj?.HistoryProcessOrder : ("HistoryProcessOrder" | translate) }}</h2>

        <button
          mat-mini-fab
          mat-button
          mat-dialog-close
          color="warn"
          title="close"
        >
          <i class="fa fa-times" style="color: #fff"></i>
        </button>
      </div>
    </div>
    <mat-dialog-content>
      <div class="wrapper-box wrapper-box-shadow table-wrapper">
        <div
          class="d-flex justify-content-end ; content-top-row content-top-row-order-processing"
        >
          <mat-form-field
            appearence="fill"
            class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="width: 400px; margin-right: 0px"
          >
            <input
              matInput
              placeholder="Search"
              (keyup)="applyFilter($event)"
              autocomplete="off"
            />
          </mat-form-field>
        </div>

        <div class="content-row-flex-both-end">
          <!--table-->
          <table
            mat-table
            class="basic-table plant-model-table"
            matSort
            [dataSource]="qualityProcessOrder"
          >
            <ng-container matColumnDef="ProcessOrder">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{ langObj ? langObj?.ProcessOrderNo : ("ProcessOrderNo" | translate) }}</p>
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.ProcessOrder }}
              </td>
            </ng-container>

            <ng-container matColumnDef="ProdCode">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{ langObj ? langObj?.ProcessCode : ("ProcessCode" | translate) }}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{ element.ProdCode }}</td>
            </ng-container>

            <ng-container matColumnDef="ProdDesc">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{ langObj ? langObj?.ProcessDescription : ("ProcessDescription" | translate) }}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{ element.ProdDesc }}</td>
            </ng-container>

            <ng-container matColumnDef="StartTime">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{ langObj ? langObj?.StartTime : ("StartTime" | translate) }}</p>
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.StartTime | date: "dd-MM-yyyy HH:mm:ss" }}
              </td>
            </ng-container>

            <ng-container matColumnDef="EndTime">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{ langObj ? langObj?.EndTime : ("EndTime" | translate) }}</p>
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.EndTime | date: "dd-MM-yyyy HH:mm:ss" }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="QualityordersColumns"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: QualityordersColumns"
            ></tr>
          </table>
        </div>
        <mat-paginator
          class="basic-paginataor"
          [pageSizeOptions]="[10, 20]"
          showFirstLastButtons
        ></mat-paginator>
      </div>
    </mat-dialog-content>
  </ng-template>
</div>

<mat-form-field
  class="example-full-width"
  appearance="fill"
  style="display: none"
>
  <mat-label>{{
    langObj ? langObj?.choosedate : ("choosedate" | translate)
  }}</mat-label>
  <input
    matInput
    [ngxMatDatetimePicker]="pickerforprocessgrid"
    (dateInput)="processgridDate($event)"
  />
  <mat-datepicker-toggle
    matSuffix
    [for]="pickerforprocessgrid"
  ></mat-datepicker-toggle>
  <ngx-mat-datetime-picker
    [touchUi]="true"
    #pickerforprocessgrid
  ></ngx-mat-datetime-picker>
</mat-form-field>

<mat-form-field
  class="example-full-width"
  appearance="fill"
  style="display: none"
>
  <mat-label>{{
    langObj ? langObj?.choosedate : ("choosedate" | translate)
  }}</mat-label>
  <input
    matInput
    [ngxMatDatetimePicker]="pickerforqualitygrid"
    (dateInput)="qualitygridDate($event)"
  />
  <mat-datepicker-toggle
    matSuffix
    [for]="pickerforqualitygrid"
  ></mat-datepicker-toggle>
  <ngx-mat-datetime-picker
    [touchUi]="true"
    #pickerforqualitygrid
  ></ngx-mat-datetime-picker>
</mat-form-field>
